module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "chapter-title0",
    attrs: {
      "id": "ch-9"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_70"
    }
  }, [_vm._v("The Remnants of Free Exercise")])]), _c('a', {
    attrs: {
      "id": "page_70"
    }
  }, [_c('h1', {
    staticClass: "sec10",
    attrs: {
      "id": "sec-7"
    }
  }, [_c('em', [_vm._v("1990 Supreme Court Review 1")])]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_c('em', [_vm._v("This is my most complete attempt to refute the reasoning and conclusions of")]), _vm._v(" Employment Division v. Smith "), _c('em', [_vm._v("and")]), _vm._v(" Jimmy Swaggart Ministries v. Board of Equalization, "), _c('em', [_vm._v("two Supreme Court decisions in 1990 that dramatically shrank the Free Exercise Clause.")]), _vm._v(" Smith "), _c('em', [_vm._v("held that government can regulate or prohibit religiously motivated behavior, including even worship services, without having to show any governmental need to interfere with religious liberty, so long as the regulation is imposed by a “generally applicable law.”")]), _vm._v(" Swaggart "), _c('em', [_vm._v("held that religious exemptions from generally applicable taxes are a matter of legislative grace, not required by the Constitution.")]), _vm._v(" Smith "), _c('em', [_vm._v("was a paradigm-shifting case, and nearly all the subsequent law of free exercise has been a working out of the legal and political responses to")]), _vm._v(" Smith. Swaggart "), _c('em', [_vm._v("turned out to be less important, principally because religious tax exemptions retain strong political support.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('em', [_vm._v("This article was written in the summer and fall immediately after the decisions; it is an early reaction, but with the benefit of months to reflect rather than days or weeks. The lines of argument for reducing the damage from these decisions are anticipated here but more fully developed in later work based on longer experience with the decisions.")])])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_70"
    }
  }, [_c('em', [_vm._v("The")]), _vm._v(" Supreme Court Review "), _c('em', [_vm._v("is published annually by The University of Chicago, and, as the name implies, it is devoted to reviewing the work of the Supreme")])]), _c('a', {
    attrs: {
      "id": "page_71"
    }
  }, [_c('em', [_vm._v("Court of the United States. The editorial process dragged on; despite the 1990 date, this did not actually appear in print until late spring 1991.")])])]), _c('a', {
    attrs: {
      "id": "page_71"
    }
  }), _c('p', {
    staticClass: "para1"
  }, [_c('a', {
    attrs: {
      "id": "page_71"
    }
  }, [_vm._v("In two opinions last term, the Supreme Court rewrote the law of free exercise. In "), _c('em', [_vm._v("Jimmy Swaggart Ministries v. Board of Equalization,")])]), _c('a', {
    attrs: {
      "href": "#/#foot-1",
      "id": "foot_1"
    }
  }, [_c('sup', [_vm._v("1")])]), _vm._v(" the Court held that the dissemination of religious messages may be taxed under generally applicable laws. In "), _c('em', [_vm._v("Employment Division v. Smith,")]), _c('a', {
    attrs: {
      "href": "#/#foot-2",
      "id": "foot_2"
    }
  }, [_c('sup', [_vm._v("2")])]), _vm._v(" the Court held that worship services may be prohibited under generally applicable laws. The Court said that generally applicable laws are neutral, and that neutrality is all the Free Exercise Clause requires.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('em', [_vm._v("Swaggart")]), _vm._v(" produced only modest reaction; "), _c('em', [_vm._v("Smith")]), _vm._v(" produced widespread disbelief and outrage. Anger at the result was compounded by anger at the procedure. The Court sharply changed existing law without an opportunity for briefing or argument, and it issued an opinion claiming that its new rules had been the law for a hundred years. An extraordinary coalition of religious and civil liberties groups has sought to have "), _c('em', [_vm._v("Smith")]), _vm._v(" overturned, first by an unsuccessful petition for rehearing and now by proposed legislation."), _c('a', {
    attrs: {
      "href": "#/#foot-3",
      "id": "foot_3"
    }
  }, [_c('sup', [_vm._v("3")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("I share the judgment that "), _c('em', [_vm._v("Smith")]), _vm._v(" is the more important of the two cases. State and local governments have already relied on "), _c('em', [_vm._v("Smith")]), _vm._v(" for authority to dictate the location of an altar in a Catholic church"), _c('a', {
    attrs: {
      "href": "#/#foot-4",
      "id": "foot_4"
    }
  }, [_c('sup', [_vm._v("4")])]), _vm._v(" and to suppress animal sacrifice among Afro-Caribbean immigrants;"), _c('a', {
    attrs: {
      "href": "#/#foot-5",
      "id": "foot_5"
    }
  }, [_c('sup', [_vm._v("5")])]), _vm._v(" a trial court applying "), _c('em', [_vm._v("Smith")]), _vm._v(" has equated the rights of churches with the rights of pornographic movie theaters."), _c('a', {
    attrs: {
      "href": "#/#foot-6",
      "id": "foot_6"
    }
  }, [_c('sup', [_vm._v("6")])]), _vm._v(" It is entirely foreseeable that women and homosexuals will demand ordination under local civil rights ordinances,"), _c('a', {
    attrs: {
      "href": "#/#foot-7",
      "id": "foot_7"
    }
  }, [_c('sup', [_vm._v("7")])]), _vm._v(" and that various interest "), _c('a', {
    attrs: {
      "id": "page_72"
    }
  }, [_vm._v("groups will see "), _c('em', [_vm._v("Smith")]), _vm._v(" as an invitation to impose their regulatory agenda on churches. "), _c('em', [_vm._v("Smith")]), _vm._v(" may authorize all these things or none of them. It announces a dramatic new rule and a large number of ill-defined exceptions, and the relative scope of rule and exception remains to be litigated.")])]), _c('a', {
    attrs: {
      "id": "page_72"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Taxation and tax exemption raise additional complexities, and full treatment of these subjects would require a separate article. But "), _c('em', [_vm._v("Swaggart")]), _vm._v(" deserves more attention than it has received. General taxation of churches would also be a dramatic change in church-state relations, and both opinions treat taxation and regulation as equivalent for free exercise purposes.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_72"
    }
  }, [_c('em', [_vm._v("Smith")]), _vm._v(" has already been subjected to substantial scholarly criticism, and I will not retrace all that ground. Michael McConnell has shown that the understanding of free exercise in the founding generation included exemptions for religiously motivated conduct.")]), _c('a', {
    attrs: {
      "href": "#/#foot-8",
      "id": "foot_8"
    }
  }, [_c('sup', [_vm._v("8")])]), _vm._v(" Thus, "), _c('em', [_vm._v("Smith")]), _vm._v(" is probably wrong as a matter of original intent; certainly no plausible opinion can be written without taking account of the evidence McConnell musters. His work was completed before the Court’s decision, and published immediately after. It was not brought to the Court’s attention, because no one knew the Court was reconsidering the right to exemptions.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Justice O’Connor’s dissent and early scholarly commentary document the obvious: the Court’s account of its precedents in "), _c('em', [_vm._v("Smith")]), _vm._v(" is transparently dishonest."), _c('a', {
    attrs: {
      "href": "#/#foot-9",
      "id": "foot_9"
    }
  }, [_c('sup', [_vm._v("9")])]), _vm._v(" Perhaps the point is made most effectively by quoting Justice Scalia, in a pair of opinions fourteen months apart. Here is Scalia in 1989:")]), _vm._v(" "), _c('p', {
    staticClass: "ext"
  }, [_vm._v("In such cases as "), _c('em', [_vm._v("Sherbert v. Verner, Wisconsin v. Yoder, Thomas v. Review Bd. of Indiana Employment Security Div.")]), _vm._v(", and "), _c('em', [_vm._v("Hobbie v. Unemployment Appeals Comm’n of Fla.")]), _vm._v(", we held that the Free Exercise Clause of the First Amendment "), _c('em', [_vm._v("required")]), _vm._v(" religious beliefs to be accommodated by granting religion-specific exemptions from otherwise applicable laws."), _c('a', {
    attrs: {
      "href": "#/#foot-10",
      "id": "foot_10"
    }
  }, [_c('sup', [_vm._v("10")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para1"
  }, [_vm._v("And here is Scalia in 1990, for the Court in "), _c('em', [_vm._v("Smith:")])]), _vm._v(" "), _c('p', {
    staticClass: "ext"
  }, [_c('a', {
    attrs: {
      "id": "page_73"
    }
  }, [_vm._v("We have never held that an individual’s religious beliefs excuse him from compliance with an otherwise valid law prohibiting conduct that the State is free to regulate.")]), _c('a', {
    attrs: {
      "href": "#/#foot-11",
      "id": "foot_11"
    }
  }, [_c('sup', [_vm._v("11")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para1"
  }, [_vm._v("He was right the first time.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The early published reactions to "), _c('em', [_vm._v("Smith")]), _vm._v(" also make the point that the decision is inconsistent with the apparent meaning of the constitutional text."), _c('a', {
    attrs: {
      "href": "#/#foot-12",
      "id": "foot_12"
    }
  }, [_c('sup', [_vm._v("12")])]), _vm._v(" The Court concedes that religious conduct is the exercise of religion,"), _c('a', {
    attrs: {
      "href": "#/#foot-13",
      "id": "foot_13"
    }
  }, [_c('sup', [_vm._v("13")])]), _vm._v(" and it accurately describes the law at issue as a “criminal prohibition” of this religious exercise."), _c('a', {
    attrs: {
      "href": "#/#foot-14",
      "id": "foot_14"
    }
  }, [_c('sup', [_vm._v("14")])]), _vm._v(" On its face, such a law would seem to be a “law prohibiting the free exercise thereof.” The Court does not really dispute the point; it says only that this is not the only “permissible” meaning of the text."), _c('a', {
    attrs: {
      "href": "#/#foot-15",
      "id": "foot_15"
    }
  }, [_c('sup', [_vm._v("15")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("When a decision is dubious or demonstrably wrong as a matter of text, precedent, and original intent, it must be based on something else. In this article, I will examine first the theoretical conceptions revealed by "), _c('em', [_vm._v("Swaggart, Smith")]), _vm._v(", and the scholarly supporters of the approach taken in "), _c('em', [_vm._v("Smith,")]), _c('a', {
    attrs: {
      "href": "#/#foot-16",
      "id": "foot_16"
    }
  }, [_c('sup', [_vm._v("16")])]), _vm._v(" and why I think those conceptions are misconceptions. I will consider the Court’s conception of religious neutrality,"), _c('a', {
    attrs: {
      "href": "#/#foot-17",
      "id": "foot_17"
    }
  }, [_c('sup', [_vm._v("17")])]), _vm._v(" its apparent conception of religion, its crucial distinction between religious belief and religious practice, and its conception of the judicial role.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Second, I will consider the doctrinal and practical impact of these cases. The Free Exercise Clause is now principally a special case of equal protection, forbidding religious discrimination. It also survives as an adjunct to the Free Speech Clause, and to the unenumerated right of parents to direct the education of their children. But the Free Exercise Clause itself now has little independent substantive content.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The practical impact may be limited or enormous, depending on the ultimate content of the various exceptions and limitations in the opinion. A "), _c('a', {
    attrs: {
      "id": "page_74"
    }
  }, [_vm._v("rule against express religious discrimination provides more protection for minority faiths than most governments have provided through most of human history. The Court’s announced rule should mean that neither criminal punishment nor civil disabilities can be inflicted on religious minorities identified by name, doctrine, or ritual.")])]), _c('a', {
    attrs: {
      "id": "page_74"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("But the obvious forms of persecution are not the ones a contemporary American majority is likely to use. The scope of regulation in the modern administrative state creates ample opportunity for facially neutral religious oppression. Such oppressive laws may be enacted through hostility, sheer indifference, or ignorance of minority faiths. If the Court intends to defer to any formally neutral law restricting religion, then it has created a legal framework for persecution, and persecutions will result. I do not use that word hyperbolically or rhetorically. I mean it quite literally, and I will defend the usage.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec4"
  }, [_c('strong', [_c('em', [_vm._v("I. The Cases")])])]), _vm._v(" "), _c('h1', {
    staticClass: "sec5"
  }, [_c('strong', [_c('em', [_vm._v("A.")]), _vm._v(" Swaggart "), _c('em', [_vm._v("and the Taxation of Churches")])])]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("The "), _c('em', [_vm._v("Swaggart")]), _vm._v(" case arose out of California’s attempt to collect sales and use tax on Swaggart’s distribution of religious books, tapes, and records to Californians. Some of these items were sold in California at evangelistic services that Swaggart called crusades. Most were sold by mail from Swaggart’s headquarters in Louisiana. California imposed a 6 percent sales tax on the items sold in California, and a 6 percent use tax on the items sold by mail and used in California.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_74"
    }
  }, [_vm._v("California demanded that Swaggart collect and remit its use tax, asserting that Swaggart’s crusades in California created sufficient jurisdictional contacts to support that demand.")]), _c('a', {
    attrs: {
      "href": "#/#foot-18",
      "id": "foot_18"
    }
  }, [_c('sup', [_vm._v("18")])]), _vm._v(" Swaggart argued that these contacts were not jurisdictionally sufficient, but the Court held that this claim had not been preserved. Swaggart also argued that the jurisdictional holding penalized the protected decision to hold a church service in California. The cost of entering the state for a crusade was liability to collect and remit use tax on a much larger volume of mail order transactions that would otherwise have been beyond the reach of California law. The Court ignored this argument; in an earlier "), _c('a', {
    attrs: {
      "id": "page_75"
    }
  }, [_vm._v("pair of free speech cases, it had rejected a somewhat similar challenge to judicial jurisdiction based on distribution of a few copies of a publication.")]), _c('a', {
    attrs: {
      "href": "#/#foot-19",
      "id": "foot_19"
    }
  }, [_c('sup', [_vm._v("19")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Swaggart did collect and remit the sales tax on items described in the opinion as “nonreligious merchandise,”"), _c('a', {
    attrs: {
      "href": "#/#foot-20",
      "id": "foot_20"
    }
  }, [_c('sup', [_vm._v("20")])]), _vm._v(" but perhaps better described as religious memorabilia. These items included t-shirts, mugs, bowls, plates, communion cups, and replicas of Christ’s crown of thorns and the ark of the covenant. Many of these items embodied or were marked with religious symbols; they were designed in part to proclaim or reinforce faith. They illustrate the force of the Court’s observation that a constitutional tax immunity for religious activities would present non-trivial line-drawing issues."), _c('a', {
    attrs: {
      "href": "#/#foot-21",
      "id": "foot_21"
    }
  }, [_c('sup', [_vm._v("21")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Swaggart objected to the collection of sales and use tax on books and audio recordings containing explicitly religious messages. The claim was very simple: a tax on the distribution of a book of sermons, or a recording of gospel hymns, was a tax on dissemination of the faith. A tax on dissemination of the faith was forbidden by "), _c('em', [_vm._v("Murdock v. Pennsylvania")]), _c('a', {
    attrs: {
      "href": "#/#foot-22",
      "id": "foot_22"
    }
  }, [_c('sup', [_vm._v("22")])]), _vm._v(" and "), _c('em', [_vm._v("Follett v. McCormick.")]), _c('a', {
    attrs: {
      "href": "#/#foot-23",
      "id": "foot_23"
    }
  }, [_c('sup', [_vm._v("23")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('em', [_vm._v("Murdock")]), _vm._v(" and "), _c('em', [_vm._v("Follett")]), _vm._v(" struck down peddler’s taxes as applied to sales of religious literature by Jehovah’s Witness proselytizers. The Witnesses charged for their literature, but the Court said that was irrelevant. A religious organization must pay the expenses of distributing its message, and an “evangelist.… does not become a mere book agent by selling the Bible or religious tracts to help defray his expenses or to sustain him.”"), _c('a', {
    attrs: {
      "href": "#/#foot-24",
      "id": "foot_24"
    }
  }, [_c('sup', [_vm._v("24")])]), _vm._v(" The Court noted that Thomas Paine had charged for his revolutionary pamphlets.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('em', [_vm._v("Swaggart")]), _vm._v(" confined "), _c('em', [_vm._v("Murdock")]), _vm._v(" and "), _c('em', [_vm._v("Follett")]), _vm._v(" to their facts, announcing that they prohibited only “flat license taxes that operated as a prior restraint.”"), _c('a', {
    attrs: {
      "href": "#/#foot-25",
      "id": "foot_25"
    }
  }, [_c('sup', [_vm._v("25")])]), _vm._v(" A plurality of three had suggested this distinction a year before, in a case striking down a tax exemption that discriminated among publications on the basis of content."), _c('a', {
    attrs: {
      "href": "#/#foot-26",
      "id": "foot_26"
    }
  }, [_c('sup', [_vm._v("26")])]), _vm._v(" Three dissenters had charged that such a distinction "), _c('a', {
    attrs: {
      "id": "page_76"
    }
  }, [_vm._v("“trivializes the holdings” of "), _c('em', [_vm._v("Murdock")]), _vm._v(" and "), _c('em', [_vm._v("Follett.")])]), _c('a', {
    attrs: {
      "href": "#/#foot-27",
      "id": "foot_27"
    }
  }, [_c('sup', [_vm._v("27")])]), _vm._v(" But in "), _c('em', [_vm._v("Swaggart")]), _vm._v(" the Court accepted the distinction unanimously.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The Court also emphasized other features of California’s tax: it was “not a flat tax,” it represented “only a small fraction of any retail sale,” and it applied “neutrally to all retail sales of tangible personal property.”"), _c('a', {
    attrs: {
      "href": "#/#foot-28",
      "id": "foot_28"
    }
  }, [_c('sup', [_vm._v("28")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Thus, the sales and use tax is not a tax on the right to disseminate religious information, ideas, or beliefs per se; rather, it is a tax on the privilege of making retail sales of tangible personal property and on the storage, use, or other consumption of tangible personal property in California."), _c('a', {
    attrs: {
      "href": "#/#foot-29",
      "id": "foot_29"
    }
  }, [_c('sup', [_vm._v("29")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The Court’s distinction of "), _c('em', [_vm._v("Murdock")]), _vm._v(" on the ground that it involved a license tax has some basis in the "), _c('em', [_vm._v("Murdock")]), _vm._v(" opinion."), _c('a', {
    attrs: {
      "href": "#/#foot-30",
      "id": "foot_30"
    }
  }, [_c('sup', [_vm._v("30")])]), _vm._v(" The broader notion of formal neutrality has none. "), _c('em', [_vm._v("Murdock")]), _vm._v(" rejected formal neutrality as “immaterial.” It was not enough that the state “classifies the privileges protected by the First Amendment along with the wares and merchandise of hucksters and peddlers and treats them all alike.”"), _c('a', {
    attrs: {
      "href": "#/#foot-31",
      "id": "foot_31"
    }
  }, [_c('sup', [_vm._v("31")])]), _vm._v(" But formal neutrality was critical in "), _c('em', [_vm._v("Swaggart:")]), _vm._v(" states may now tax religion so long as they do not do so “per se.”")]), _vm._v(" "), _c('h1', {
    staticClass: "sec5"
  }, [_c('strong', [_c('em', [_vm._v("B.")]), _vm._v(" Smith "), _c('em', [_vm._v("and the Regulation of Religious Conduct")])])]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_c('em', [_vm._v("Smith")]), _vm._v(" began as another in a series of unemployment compensation cases, arguably routine in principle,"), _c('a', {
    attrs: {
      "href": "#/#foot-32",
      "id": "foot_32"
    }
  }, [_c('sup', [_vm._v("32")])]), _vm._v(" but with facts that could have been made up for a law school exam: two counselors in a drug and alcohol abuse clinic were fired for taking peyote at a worship service of the Native American Church. One was Native American; one was white. By the time the Supreme Court finished with the case, it was no longer an unemployment compensation case, it was certainly not routine, and the facts had become utterly irrelevant.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Peyote is a hallucinogenic drug produced by a small cactus in the southwestern United States and northern Mexico. It is an illegal drug, but it has never been an important recreational drug. One takes peyote by eating the buds of the cactus plant. The buds are tough, bitter, difficult to chew, and frequently "), _c('a', {
    attrs: {
      "id": "page_77"
    }
  }, [_vm._v("cause nausea or vomiting.")]), _c('a', {
    attrs: {
      "href": "#/#foot-33",
      "id": "foot_33"
    }
  }, [_c('sup', [_vm._v("33")])]), _vm._v(" Peyote appears to be much safer than the synthetic hallucinogenics that are illegally produced and more widely abused;"), _c('a', {
    attrs: {
      "href": "#/#foot-34",
      "id": "foot_34"
    }
  }, [_c('sup', [_vm._v("34")])]), _vm._v(" adverse reactions are only very occasionally reported."), _c('a', {
    attrs: {
      "href": "#/#foot-35",
      "id": "foot_35"
    }
  }, [_c('sup', [_vm._v("35")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("There is no dispute that peyote worship is an ancient and bona fide Native American religion, now infused with elements of Christianity."), _c('a', {
    attrs: {
      "href": "#/#foot-36",
      "id": "foot_36"
    }
  }, [_c('sup', [_vm._v("36")])]), _vm._v(" To the believer, peyote is a sacramental substance, an object of worship, and a source of divine protection. The central event at a worship service, or “meeting,” is the consumption of peyote in a highly structured ritual."), _c('a', {
    attrs: {
      "href": "#/#foot-37",
      "id": "foot_37"
    }
  }, [_c('sup', [_vm._v("37")])]), _vm._v(" Federal drug laws and many state drug laws exempt religious use by the Native American Church,"), _c('a', {
    attrs: {
      "href": "#/#foot-38",
      "id": "foot_38"
    }
  }, [_c('sup', [_vm._v("38")])]), _vm._v(" and federal drug authorities issue licenses to grow peyote for religious use. There is substantial evidence that on balance the religion is a positive influence on its members, and especially on recovering alcoholics."), _c('a', {
    attrs: {
      "href": "#/#foot-39",
      "id": "foot_39"
    }
  }, [_c('sup', [_vm._v("39")])]), _vm._v(" The irony of drug counselors fired for peyote worship may be more apparent than real; the peyote religion teaches total abstinence from all other drugs, and from recreational use of peyote, emphatically and with some success. But no religious practice is uniform for all believers, and Oregon cited reports that peyote use is not always so structured and constrained as more sympathetic accounts would suggest."), _c('a', {
    attrs: {
      "href": "#/#foot-40",
      "id": "foot_40"
    }
  }, [_c('sup', [_vm._v("40")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The case that reached the Supreme Court arose on a simple claim for unemployment compensation. In its first encounter with the case, the Court announced that it wanted to decide whether Oregon could criminally punish peyote use, an issue it considered logically prior to the unemployment compensation issue."), _c('a', {
    attrs: {
      "href": "#/#foot-41",
      "id": "foot_41"
    }
  }, [_c('sup', [_vm._v("41")])]), _vm._v(" The Court remanded the case, asking the Oregon Supreme "), _c('a', {
    attrs: {
      "id": "page_78"
    }
  }, [_vm._v("Court to determine whether sacramental peyote use violated Oregon criminal laws. When the case returned to the Court (after an affirmative answer from the Oregon Supreme Court) both sides briefed the criminal law issue under the prevailing standard: would criminal punishment of religious peyote use serve a compelling interest by the least restrictive means?")])]), _c('a', {
    attrs: {
      "id": "page_78"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The Supreme Court rejected the compelling interest standard and announced a fundamentally different standard, without notice to the parties that it was reconsidering the standard. The Court’s new standard required no attention to the facts of the case or to any of the issues argued by the parties:")])]), _c('p', {
    staticClass: "ext"
  }, [_c('a', {
    attrs: {
      "id": "page_78"
    }
  }, [_vm._v("[I]f prohibiting the exercise of religion … is not the object of [a tax or regulation] but merely the incidental effect of a generally applicable and otherwise valid provision, the First Amendment has not been offended.… [T]he right of free exercise does not relieve an individual of the obligation to comply with a “valid and neutral law of general applicability.”")]), _c('a', {
    attrs: {
      "href": "#/#foot-42",
      "id": "foot_42"
    }
  }, [_c('sup', [_vm._v("42")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para1"
  }, [_vm._v("Because Oregon’s prohibition of peyote is generally applicable, the peyote worship service is not constitutionally protected.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The scope of this new principle is not clear. It applies to religious conduct, but apparently not to religious belief and profession of faith."), _c('a', {
    attrs: {
      "href": "#/#foot-43",
      "id": "foot_43"
    }
  }, [_c('sup', [_vm._v("43")])]), _vm._v(" Even with respect to conduct, the Court recognized exceptions for “hybrid” cases that involve free exercise and some other constitutional right — freedom of speech or press, or the unenumerated right of parents “to direct the education of their children.”"), _c('a', {
    attrs: {
      "href": "#/#foot-44",
      "id": "foot_44"
    }
  }, [_c('sup', [_vm._v("44")])]), _vm._v(" This last category preserved "), _c('em', [_vm._v("Wisconsin v. Yoder,")]), _c('a', {
    attrs: {
      "href": "#/#foot-45",
      "id": "foot_45"
    }
  }, [_c('sup', [_vm._v("45")])]), _vm._v(" which exempted Amish children from the first two years of high school. There is either an exception, or an explication of the requirement that laws be neutral and generally applicable, that preserves from overruling the Court’s earlier unemployment compensation cases."), _c('a', {
    attrs: {
      "href": "#/#foot-46",
      "id": "foot_46"
    }
  }, [_c('sup', [_vm._v("46")])]), _vm._v(" But this proviso did not apply to "), _c('em', [_vm._v("Smith")]), _vm._v(" itself, even though it was an unemployment compensation case. These exceptions and limitations rest on ill-defined principles and have ill-defined borders. Their most obvious feature is this: although the Court distorted the rationale of its precedents beyond recognition, the exceptions and limitations to its new principle preserved all its prior results. We may be told in the next case that these results were really undermined by "), _c('em', [_vm._v("Smith")]), _vm._v(" and "), _c('a', {
    attrs: {
      "id": "page_79"
    }
  }, [_vm._v("that they must now be overruled after all. But the distortions are inexplicable unless someone in the majority wishes to preserve these precedents. Part of the task in future cases is to search for principled lines between what the Court has preserved and what it has rejected.")])]), _c('a', {
    attrs: {
      "id": "page_79"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The lines to be drawn apparently depend on definitional categories. Belief is protected, but conduct generally is not; speech and parental control are protected, but other conduct generally is not; even conduct is protected against non-neutral laws, but not against laws that are neutral and generally applicable. To apply these rules, courts must sort cases into the various categories: belief or conduct; speech, parental control, or something else; neutral or not neutral.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_79"
    }
  }, [_vm._v("The lines to be drawn do not depend on any balance of competing interests. On the Court’s approach, it makes no difference what the state’s policy is or what the religious practice is. It is important to understand that the alleged dangers of peyote are irrelevant to the holding in "), _c('em', [_vm._v("Smith.")]), _vm._v(" It makes no difference whether peyote is deadly or harmless, or whether peyote worship is infrequent, structured, and disciplined or constant, casual, and dissipated. It makes no difference whether Oregon has forbidden peyote, or wine, or unleavened bread. In Justice Scalia’s example, it makes no difference whether the prohibited religious practice is “throwing rice at church weddings” or “getting married in church.”")]), _c('a', {
    attrs: {
      "href": "#/#foot-47",
      "id": "foot_47"
    }
  }, [_c('sup', [_vm._v("47")])]), _vm._v(" Indeed, the Court’s principal ground of decision was precisely that courts should not assess the importance of either government interests or religious practices."), _c('a', {
    attrs: {
      "href": "#/#foot-48",
      "id": "foot_48"
    }
  }, [_c('sup', [_vm._v("48")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The point is underscored by the religious practice at issue. However unfamiliar, deviant, or even dangerous the peyote ritual may seem from a majoritarian perspective, it is also the central religious ritual of an ancient faith. The Court held that Oregon can suppress a worship service, and so long as that is the incidental effect of a generally applicable law, Oregon need have no reason for refusing a religious exemption.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec4",
    attrs: {
      "id": "sec3-20"
    }
  }, [_c('strong', [_c('em', [_vm._v("II. Four Misconceptions")])])]), _vm._v(" "), _c('h1', {
    staticClass: "sec5",
    attrs: {
      "id": "sec4-13"
    }
  }, [_c('strong', [_c('em', [_vm._v("A. The Court’s Conception of Neutrality")])])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('strong', [_vm._v("1. Formal neutrality and majoritarianism")]), _vm._v(". "), _c('em', [_vm._v("Swaggart")]), _vm._v(" and "), _c('em', [_vm._v("Smith")]), _vm._v(" make formal neutrality the dominant principle of the Court’s free exercise jurisprudence. Instead of a substantive right to be left alone by government, churches and "), _c('a', {
    attrs: {
      "id": "page_80"
    }
  }, [_vm._v("believers now get a right to equal protection. Instead of an exemption from taxation and regulation, churches and believers get the right to be taxed or regulated no more heavily than secular institutions. But in the modern regulatory state, secular institutions are pervasively taxed and regulated. Religious exercise is not free when it is pervasively taxed and regulated.")])]), _c('a', {
    attrs: {
      "id": "page_80"
    }
  }), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_80"
    }
  }, [_vm._v("Eleven years before, in "), _c('em', [_vm._v("Jones v. Wolf,")])]), _c('a', {
    attrs: {
      "href": "#/#foot-49",
      "id": "foot_49"
    }
  }, [_c('sup', [_vm._v("49")])]), _vm._v(" the Court made the same move in another free exercise context, the resolution of internal church disputes in secular courts. "), _c('em', [_vm._v("Jones")]), _vm._v(" held that state courts may apply “neutral principles of law” to such disputes, interpreting deeds to church property, corporate charters and trust instruments, and even church constitutions, provided only that secular courts do not decide questions of religious doctrine. This created an alternative to the earlier rule of deference to the highest church authority to decide the dispute."), _c('a', {
    attrs: {
      "href": "#/#foot-50",
      "id": "foot_50"
    }
  }, [_c('sup', [_vm._v("50")])]), _vm._v(" Instead of a right to settle their own disputes, churches got a right to have their disputes resolved by the same rules and procedures applicable to secular institutions.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("In each of these contexts, the Court has chosen an equal protection rule instead of an exemption rule. More important, in applying the equal protection rule, the unique features of religion do not require that religion be distinguished from any other human activity. In the Court’s view, religious use of peyote, or of wine, is no more protected by the Constitution than is recreational use. A soldier who believes he must cover his head before an omnipresent God is constitutionally indistinguishable from a soldier who wants to wear a Budweiser gimme cap."), _c('a', {
    attrs: {
      "href": "#/#foot-51",
      "id": "foot_51"
    }
  }, [_c('sup', [_vm._v("51")])]), _vm._v(" That is, the Free Exercise Clause has been read to require only religion-blind equal protection. In earlier work, I have called this approach “formal neutrality,”"), _c('a', {
    attrs: {
      "href": "#/#foot-52",
      "id": "foot_52"
    }
  }, [_c('sup', [_vm._v("52")])]), _vm._v(" and I will use that term here.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The Court says that churches and believers are entitled to at least formal neutrality, but that government may sometimes give them more. Government may grant religious exemptions from regulation,"), _c('a', {
    attrs: {
      "href": "#/#foot-53",
      "id": "foot_53"
    }
  }, [_c('sup', [_vm._v("53")])]), _vm._v(" and secular courts may defer to religious authorities in religious disputes."), _c('a', {
    attrs: {
      "href": "#/#foot-54",
      "id": "foot_54"
    }
  }, [_c('sup', [_vm._v("54")])]), _vm._v(" In these contexts, "), _c('a', {
    attrs: {
      "id": "page_81"
    }
  }, [_vm._v("exemptions are permitted but not required. With respect to taxation, formal neutrality in theory is both the minimum and the maximum. Government may not exempt religious income, property, or activity from taxation, except as part of some larger exempt class defined in secular terms.")]), _c('a', {
    attrs: {
      "href": "#/#foot-55",
      "id": "foot_55"
    }
  }, [_c('sup', [_vm._v("55")])]), _vm._v(" But in practice, legislatures exempt from taxation most church income and property, and the Court is unlikely to rigorously scrutinize the boundaries of the secular exemptions that are said to include religion."), _c('a', {
    attrs: {
      "href": "#/#foot-56",
      "id": "foot_56"
    }
  }, [_c('sup', [_vm._v("56")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The basic pattern is that religious liberty is entitled only to formal neutrality but may get more favorable treatment from the political branches. This is in fact a move to majoritarianism; the Court is getting out of the business of enforcing the Religion Clauses. Legislatures and enforcement agencies choose when to provide only formal neutrality and when to grant exemptions. Favored religions can be exempted from the rules that burden them, while disfavored religions are denied exemptions from the rules that burden them. The Court somewhat euphemistically concedes that this allocation of responsibility “will place at a relative disadvantage those religious practices that are not widely engaged in.”"), _c('a', {
    attrs: {
      "href": "#/#foot-57",
      "id": "foot_57"
    }
  }, [_c('sup', [_vm._v("57")])]), _vm._v(" But the Court sees no constitutional issue, because even the worst treated religions get the protections of formal neutrality.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The Court has said remarkably little to defend this proposition. In "), _c('em', [_vm._v("Swaggart")]), _vm._v(", the Court simply assumed it:")]), _vm._v(" "), _c('p', {
    staticClass: "ext"
  }, [_vm._v("At the outset, it is undeniable that a generally applicable tax has a secular purpose and neither advances nor inhibits religion, for the very essence of such a tax is that it is neutral and non-discriminatory on questions of religious belief."), _c('a', {
    attrs: {
      "href": "#/#foot-58",
      "id": "foot_58"
    }
  }, [_c('sup', [_vm._v("58")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para1"
  }, [_vm._v("The majority in "), _c('em', [_vm._v("Smith")]), _vm._v(" defended the proposition by arguing, somewhat circularly, that it would be anomalous to let some people violate the law while others were required to obey it. The Court said that strict scrutiny of racial classifications produces “equality of treatment,” which is a “constitutional norm,” but that strict scrutiny in "), _c('em', [_vm._v("Smith")]), _vm._v(" would produce “a private right to ignore generally applicable laws,” which is “a constitutional anomaly.”"), _c('a', {
    attrs: {
      "href": "#/#foot-59",
      "id": "foot_59"
    }
  }, [_c('sup', [_vm._v("59")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_82"
    }
  }, [_vm._v("But the Court simply assumed that the group to be exempted was similarly situated with the group not exempted.")])]), _c('a', {
    attrs: {
      "id": "page_82"
    }
  }), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_82"
    }
  }, [_vm._v("Although formal neutrality has become dominant, neither the Court nor individual justices have been consistent about it. Four justices found religion blindness undeniably neutral in the context of taxation, but oppressive in the context of regulation.")]), _c('a', {
    attrs: {
      "href": "#/#foot-60",
      "id": "foot_60"
    }
  }, [_c('sup', [_vm._v("60")])]), _vm._v(" "), _c('em', [_vm._v("Swaggart’")]), _vm._v("s claim that formally neutral taxation “neither advances nor inhibits religion” invokes the language of the cases on government payments to church-sponsored schools, but it is inconsistent with the substance of those cases. When government pays money to church-sponsored schools, the Court says the benefit advances religion; it is irrelevant that government spends comparable sums on secular schools."), _c('a', {
    attrs: {
      "href": "#/#foot-61",
      "id": "foot_61"
    }
  }, [_c('sup', [_vm._v("61")])]), _vm._v(" But when government takes money from churches, the “burden is not constitutionally significant,” and it is dispositive that government takes comparable sums from secular taxpayers."), _c('a', {
    attrs: {
      "href": "#/#foot-62",
      "id": "foot_62"
    }
  }, [_c('sup', [_vm._v("62")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The Court may resolve this particular inconsistency by permitting formal neutrality under the Establishment Clause as well. But whether applied consistently or inconsistently, formal neutrality is an incorrect interpretation of the Religion Clauses, and especially of the Free Exercise Clause. It is incorrect for several closely related reasons.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('strong', [_vm._v("2. Substantive entitlements and substantive neutrality")]), _vm._v(". Most directly, the Free Exercise Clause creates a substantive right, and the Court has reduced it to a mere equality right."), _c('a', {
    attrs: {
      "href": "#/#foot-63",
      "id": "foot_63"
    }
  }, [_c('sup', [_vm._v("63")])]), _vm._v(" The Free Exercise Clause does not say that Congress shall make no law discriminating against religion, or that no state shall deny to any religion within its jurisdiction the equal protection of the laws. Rather, it says that Congress shall make no law prohibiting the free exercise of religion. Congress may prohibit many things, but it may not prohibit religious "), _c('a', {
    attrs: {
      "id": "page_83"
    }
  }, [_vm._v("exercise. On its face, this is a substantive entitlement, and not merely a pledge of non-discrimination.")])]), _c('a', {
    attrs: {
      "id": "page_83"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The extreme case of substituting equality rights for substantive rights would be total suppression of all religions. There would be perfect equality, but no religious liberty. No one is proposing that, and no reading of the Court’s opinion would permit that, but the extreme case highlights the error of taking the substantive entitlement out of the Free Exercise Clause.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_83"
    }
  }, [_vm._v("Some judges and commentators do indeed appeal to the equality of across-the-board repression in the context of exemptions for religious conduct. In any exemption case, one can imagine, and often identify in the real world, a religion with an analogous practice so disruptive or dangerous that few judges would require an exemption. Justice Stevens concludes from this that if we cannot exempt every minority faith, we should not exempt any.")]), _c('a', {
    attrs: {
      "href": "#/#foot-64",
      "id": "foot_64"
    }
  }, [_c('sup', [_vm._v("64")])]), _vm._v(" Thus, if courts would not require the military to tolerate saffron robes in combat, they should not require the military to tolerate yarmulkes on a stateside Air Force base. The resulting burden on observant Jews may seem arbitrary and irrational when considered in isolation. But in Justice Stevens’ view, it is justified because it avoids any appearance of discrimination against the wearers of saffron robes, and it avoids the necessity of judicial distinctions among religions. He prefers evenhanded repression to imperfect liberty.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Mark Tushnet makes a similar point, complaining that “Christians sometimes win but non-Christians never do.”"), _c('a', {
    attrs: {
      "href": "#/#foot-65",
      "id": "foot_65"
    }
  }, [_c('sup', [_vm._v("65")])]), _vm._v(" Better, therefore, to repress Christian minorities as well. In fact, there have been judicial wins for non-Christians,"), _c('a', {
    attrs: {
      "href": "#/#foot-66",
      "id": "foot_66"
    }
  }, [_c('sup', [_vm._v("66")])]), _vm._v(" and many of the Christian wins are achieved by small and "), _c('a', {
    attrs: {
      "id": "page_84"
    }
  }, [_vm._v("highly unconventional Christian sects, such as the Amish, Jehovah’s Witnesses, and Seventh-day Adventists. Tushnet’s instinct is sound: judges are more likely to respond sympathetically to religious claims that are familiar, easily understood, and unthreatening. But that problem cannot be solved by judicial abdication, because legislators are even more likely to favor familiar faiths with enough adherents to matter at the polls. Constitutionally adjudicated exemptions for small or unpopular religious minorities merely match the legislative exemptions commonly granted to larger or more accepted faiths.")]), _c('a', {
    attrs: {
      "href": "#/#foot-67",
      "id": "foot_67"
    }
  }, [_c('sup', [_vm._v("67")])]), _vm._v(" Even if the Court were to forbid legislated exemptions, the majority would rarely be required to violate its deeply held beliefs, because the majority’s deeply held beliefs will normally be reflected in legislation without an exemption.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("With or without constitutional exemptions, some religions will be burdened by law more than others. Without constitutional exemptions, the line will be drawn between those faiths that can prevail in the legislature and those that cannot. With constitutional exemptions, the line will be between those faiths that can prevail either in the legislature or in the courts, and those that cannot prevail in either place. It is clear that a rule of constitutional exemptions would produce more religious liberty, because it gives religious liberty claims two chances to prevail.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("It is not clear why anyone thinks such a rule would produce more discrimination among religious faiths. Why should we expect legislatures to draw more principled lines than courts? Legislators are under no obligation to be principled. Subject only to their oath to uphold the Constitution, they are free to reflect majority prejudices, to respond to the squeakiest wheel among minorities, to trade votes and make compromises, and to ignore problems that have no votes in them. This political freedom is good for many things, but it is not good for achieving evenhanded treatment of many small, disparate, and sometimes odd or obnoxious religious minorities.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Judges are far from perfect, but they are sworn to do equal justice to all, to decide every case presented to them, and to treat like cases alike. They are obliged by precedent and accepted judicial norms to give principled reasons for their decisions. Justice Blackmun argued that the state’s obligation to treat all religions equally “is fulfilled by the uniform application of the ‘compelling "), _c('a', {
    attrs: {
      "id": "page_85"
    }
  }, [_vm._v("interest’ test to all free exercise claims, not by reaching uniform results as to all claims.”")]), _c('a', {
    attrs: {
      "href": "#/#foot-68",
      "id": "foot_68"
    }
  }, [_c('sup', [_vm._v("68")])]), _vm._v(" Judges cannot achieve the ideal of “uniform application,” but even so, a line based on compelling interest is likely to be more principled than a line based on who can get the sympathetic attention of enough legislators. The goal of neutrality among faiths is not a reason to reject the substantive entitlement in the Free Exercise Clause.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("There is a separate concern about neutrality between religion and nonreligion. The Free Exercise Clause comes paired with the Establishment Clause, and government neutrality toward religion is an important part of the combined mandate of the two clauses. But if the two clauses also create substantive entitlements defined in terms of religion, then formal religion-blind neutrality must not be the kind of neutrality they mandate. Neutrality requires that like things be treated alike, but also that unlike things be appropriately distinguished.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Religion is unlike other human activities, or at least the founders thought so. The proper relation between religion and government was a subject of great debate in the founding generation,"), _c('a', {
    attrs: {
      "href": "#/#foot-69",
      "id": "foot_69"
    }
  }, [_c('sup', [_vm._v("69")])]), _vm._v(" and the Constitution includes two clauses that apply to religion and do not apply to anything else. This debate and these clauses presuppose that religion is in some way a special human activity, requiring special rules applicable only to it. To distinguish between a yarmulke and a gimme cap is not to discriminate between indistinguishable head coverings, but to distinguish a constitutionally protected activity — religious exercise — from an activity not mentioned in the Constitution.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The neutrality mandated by the Constitution is not formal neutrality, but substantive neutrality. By substantive neutrality, I mean that government should “minimize the extent to which it either encourages or discourages religious belief or disbelief, practice or non-practice, observance or nonobservance.”"), _c('a', {
    attrs: {
      "href": "#/#foot-70",
      "id": "foot_70"
    }
  }, [_c('sup', [_vm._v("70")])]), _vm._v(" So defined, substantive neutrality is consistent with the substantive entitlement created by the text of the Free Exercise Clause.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_86"
    }
  }, [_vm._v("To consider the claim that religious exemptions are substantively neutral, one must consider the incentive effects of denying exemptions and of granting them. It is clear that criminal punishment of religious practice discourages believers from practicing their faith. But in most contexts, an exemption for religious practice does not encourage non-believers to join the faith. Much religious activity is self-restraining, burdensome, or meaningless to non-believers. Gentile soldiers will not wear yarmulkes just because it is permitted, and there is no evidence that drug abusers are switching to peyote in states where peyote worship is permitted. The magnitude of encouragement incident to an exemption is generally smaller than the magnitude of discouragement incident to criminalization, and so exemption comes closer to substantive neutrality.")]), _c('a', {
    attrs: {
      "href": "#/#foot-71",
      "id": "foot_71"
    }
  }, [_c('sup', [_vm._v("71")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("In some contexts, such as conscientious objection to military service, religious duty may coincide with self-interest. When that happens, exemptions may tempt non-believers to belief, sometimes to true belief and not merely to false claims of belief. Substantive neutrality then becomes unachievable. Granting exemptions encourages religion, refusing exemptions discourages religion, and both effects are large."), _c('a', {
    attrs: {
      "href": "#/#foot-72",
      "id": "foot_72"
    }
  }, [_c('sup', [_vm._v("72")])]), _vm._v(" Whatever the proper solution in such difficult cases, the difficulty does not arise in the run of cases. In most contexts, the substantive entitlement to exercise religion is consistent with the government’s duty of substantive neutrality toward religion.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('strong', [_vm._v("3. Free exercise and other constitutional doctrine")]), _vm._v(". Understanding free exercise as a substantive right eliminates some alleged anomalies identified in "), _c('em', [_vm._v("Smith.")]), _vm._v(" The Court analogized formally neutral laws that prohibit religious exercise to formally neutral laws that disproportionately burden racial minorities."), _c('a', {
    attrs: {
      "href": "#/#foot-73",
      "id": "foot_73"
    }
  }, [_c('sup', [_vm._v("73")])]), _vm._v(" The disproportionate racial impact of a formally neutral law does not raise any special issue under the Equal Protection Clause."), _c('a', {
    attrs: {
      "href": "#/#foot-74",
      "id": "foot_74"
    }
  }, [_c('sup', [_vm._v("74")])]), _vm._v(" Critics have argued that the Court is simply wrong about racial impact;"), _c('a', {
    attrs: {
      "href": "#/#foot-75",
      "id": "foot_75"
    }
  }, [_c('sup', [_vm._v("75")])]), _vm._v(" on this view, the "), _c('a', {
    attrs: {
      "id": "page_87"
    }
  }, [_vm._v("Court has ended the anomaly by getting the religion cases wrong as well. But even if the Court is right about racial impact, there would be no anomaly in protecting conscientious objectors under the Free Exercise Clause.")])]), _c('a', {
    attrs: {
      "id": "page_87"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The explanation is that the Equal Protection Clause really is just an equality right. It creates no substantive entitlement to engage in any particular conduct or to be evaluated by any particular criteria. A civil service examination with disparate racial impact does not penalize an activity that the Constitution protects. A law prohibiting peyote worship does prohibit an activity the Constitution protects. Moreover, the victims are given an incentive to avoid the penalty by abandoning their faith. Such a law directly penalizes religious exercise, even if it also has other applications to non-religious uses. The impact on religious users is not a mere statistical association; it is a flat prohibition of their religious exercise. Whatever the proper solution to the problem of statistical disparate impact, that solution does not speak to the issue in "), _c('em', [_vm._v("Smith.")])])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_87"
    }
  }, [_vm._v("The Court in "), _c('em', [_vm._v("Smith")]), _vm._v(" also asserted that “generally applicable laws unconcerned with regulating speech that have the effect of interfering with speech do not thereby become subject to compelling-interest analysis under the First Amendment.”")]), _c('a', {
    attrs: {
      "href": "#/#foot-76",
      "id": "foot_76"
    }
  }, [_c('sup', [_vm._v("76")])]), _vm._v(" Like the Free Exercise Clause, the Speech Clause creates a substantive right with a neutrality component. If it were true that the Court had rejected all challenges to formally neutral rules that suppress speech, that would support "), _c('em', [_vm._v("Smith")]), _vm._v(" by analogy. But it is not true.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The Court has, for example, constitutionally exempted unpopular political parties and movements from statutory duties to disclose their lists of members or contributors."), _c('a', {
    attrs: {
      "href": "#/#foot-77",
      "id": "foot_77"
    }
  }, [_c('sup', [_vm._v("77")])]), _vm._v(" Another example is "), _c('em', [_vm._v("Roberts v. United States Jaycees,")]), _c('a', {
    attrs: {
      "href": "#/#foot-78",
      "id": "foot_78"
    }
  }, [_c('sup', [_vm._v("78")])]), _vm._v(" which upheld Minnesota’s public accommodations law as applied to the Jaycees’ exclusion of female members. The law was facially neutral and not directed at speech, but it burdened the Jaycees’ right of association. The Court upheld the law because the burden on associational rights was modest, but the Court unambiguously decided the case under the compelling interest test."), _c('a', {
    attrs: {
      "href": "#/#foot-79",
      "id": "foot_79"
    }
  }, [_c('sup', [_vm._v("79")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_88"
    }
  }, [_vm._v("Probably the best example is "), _c('em', [_vm._v("Hustler Magazine v. Falwell,")])]), _c('a', {
    attrs: {
      "href": "#/#foot-80",
      "id": "foot_80"
    }
  }, [_c('sup', [_vm._v("80")])]), _vm._v(" which created special defenses to protect speech from the formally neutral tort of intentional infliction of emotional distress. The elements of the tort do not mention speech, and many of its applications do not involve speech at all."), _c('a', {
    attrs: {
      "href": "#/#foot-81",
      "id": "foot_81"
    }
  }, [_c('sup', [_vm._v("81")])]), _vm._v(" When the tort is applied to speech, the speech is typically deceptive, harassing, or both, often merely incidental to conduct such as a practical joke or wrongful discharge of an employee, and thus of limited First Amendment significance."), _c('a', {
    attrs: {
      "href": "#/#foot-82",
      "id": "foot_82"
    }
  }, [_c('sup', [_vm._v("82")])]), _vm._v(" But the Court unanimously agreed that to apply the tort to outrageous speech about a public figure would violate the Speech Clause.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The rule in "), _c('em', [_vm._v("Hustler")]), _vm._v(" is modeled on cases like "), _c('em', [_vm._v("New York Times v. Sullivan,")]), _c('a', {
    attrs: {
      "href": "#/#foot-83",
      "id": "foot_83"
    }
  }, [_c('sup', [_vm._v("83")])]), _vm._v(" which imposed constitutional limits on defamation liability. The rules of defamation are not formally neutral, because the tort can be committed only by speech. But at a sufficient level of generality, even the law of defamation can be stated in formally neutral terms. Defamation applies to speech the formally neutral principle that underlies all of tort law: one who inflicts harm on another without legal excuse must generally pay compensation. Similarly, defamation is partly exempted from the formally neutral rules of punitive damages, a set of remedial rules that apply to a broad range of torts.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The constitutional defect in unlimited liability for defamation had nothing to do with whether it was conceived as a specific rule about speech or as a neutral application of a broad principle about tortious harm. The defect was that tort liability for speech penalized the exercise of a substantive constitutional right. Because that was the defect, the principle of the defamation cases clearly applied to emotional distress inflicted by speech, and it was irrelevant in "), _c('em', [_vm._v("Hustler")]), _vm._v(" that intentional infliction of emotional distress might be more readily conceived of as formally neutral.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The lesson of the defamation cases is applicable to many of the Court’s cases protecting speech: The laws were not formally neutral, but if they had been, they would have been struck down anyway. Consider "), _c('em', [_vm._v("Schneider v. State,")]), _c('a', {
    attrs: {
      "href": "#/#foot-84",
      "id": "foot_84"
    }
  }, [_c('sup', [_vm._v("84")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_89"
    }
  }, [_vm._v("holding that the state’s interest in preventing litter was not sufficient to justify a ban on distributing leaflets. Suppose the law had forbidden any person on a public street to hand to any other person any tangible property not requested by the recipient, and that a leafleteer had been arrested under this law. The result should have been the same. The problem in "), _c('em', [_vm._v("Schneider")]), _vm._v(" was not that leaflets were treated more harshly than cigarette samples, but that leaflets were constitutionally protected and cigarette samples were not.")])]), _c('a', {
    attrs: {
      "id": "page_89"
    }
  }), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_89"
    }
  }, [_vm._v("Another example of exemption for speech is "), _c('em', [_vm._v("Cantwell v. Connecticut,")])]), _c('a', {
    attrs: {
      "href": "#/#foot-85",
      "id": "foot_85"
    }
  }, [_c('sup', [_vm._v("85")])]), _vm._v(" protecting religious speech from a formally neutral rule about breach of peace. Justice Scalia in "), _c('em', [_vm._v("Smith")]), _vm._v(" treated another part of "), _c('em', [_vm._v("Cantwell")]), _vm._v(", the requirement of a license for religious or charitable solicitation, as an unconstitutional but formally neutral law. And he recognized "), _c('em', [_vm._v("Murdock")]), _vm._v(" and "), _c('em', [_vm._v("Follett")]), _vm._v(" as exempting religious speech from formally neutral license taxes. These three cases were the basis for his recognition of a hybrid class of free speech and free exercise, protected from formally neutral regulation."), _c('a', {
    attrs: {
      "href": "#/#foot-86",
      "id": "foot_86"
    }
  }, [_c('sup', [_vm._v("86")])]), _vm._v(" But he ignored these cases in his footnote claiming that exemptions from formally neutral laws would be inconsistent with free speech doctrine.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Another arguable example is formally neutral rules restricting symbolic speech, such as draft-card burning and flag burning. The Court said the flag burning laws were motivated by hostility to the messages expressed by flag burning, so that those laws were not neutral even if neutrally worded."), _c('a', {
    attrs: {
      "href": "#/#foot-87",
      "id": "foot_87"
    }
  }, [_c('sup', [_vm._v("87")])]), _vm._v(" The Court refused to consider motive in the draft-card burning prosecution, and upheld the statute under a deferential standard of review."), _c('a', {
    attrs: {
      "href": "#/#foot-88",
      "id": "foot_88"
    }
  }, [_c('sup', [_vm._v("88")])]), _vm._v(" The Court also applies an increasingly deferential standard of review in the time-place-and-manner cases,"), _c('a', {
    attrs: {
      "href": "#/#foot-89",
      "id": "foot_89"
    }
  }, [_c('sup', [_vm._v("89")])]), _vm._v(" which typically involve laws that expressly regulate communication but are formally neutral as to content.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_90"
    }
  }, [_vm._v("For better or worse, the Court has never universalized the compelling interest test. A lower standard of review is more defensible in symbolic speech and time-place-and-manner cases; a restriction on a particular means or place of expression is unlikely to entirely suppress a viewpoint in the way that a restriction on a particular means of worship can entirely suppress a religious faith.")]), _c('a', {
    attrs: {
      "href": "#/#foot-90",
      "id": "foot_90"
    }
  }, [_c('sup', [_vm._v("90")])]), _vm._v(" But the important point here is that the Court has not simply refused to review the burden on speech in these cases. Mere formal neutrality does not put restrictions on speech beyond challenge in the way that formally neutral restrictions on religious practice now appear to be beyond challenge."), _c('a', {
    attrs: {
      "href": "#/#foot-91",
      "id": "foot_91"
    }
  }, [_c('sup', [_vm._v("91")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The detail required to explore these inconsistent claims in the Court’s opinion should not be allowed to obscure the main point. The Court’s formal conception of neutrality ignores the substantive content of the Free Exercise Clause, and it begs the question of what kind of neutrality such a substantive clause requires.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec5",
    attrs: {
      "id": "sec4-14"
    }
  }, [_c('strong', [_c('em', [_vm._v("B. The Court’s Conception of Belief and Practice")])])]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("The second key conception in the "), _c('em', [_vm._v("Smith")]), _vm._v(" opinion is a distinction between belief and practice. The Court says that religious “belief and profession” is protected “first and foremost.”"), _c('a', {
    attrs: {
      "href": "#/#foot-92",
      "id": "foot_92"
    }
  }, [_c('sup', [_vm._v("92")])]), _vm._v(" Belief and profession appear to be protected even from formally neutral regulation, although the Court waffles on that."), _c('a', {
    attrs: {
      "href": "#/#foot-93",
      "id": "foot_93"
    }
  }, [_c('sup', [_vm._v("93")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The Court concedes that religious conduct is also the exercise of religion,"), _c('a', {
    attrs: {
      "href": "#/#foot-94",
      "id": "foot_94"
    }
  }, [_c('sup', [_vm._v("94")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_91"
    }
  }, [_vm._v("but it says that religious conduct is protected only from formally discriminatory regulation. And religious conduct is broadly defined to include doing or not doing any “physical acts,” with a list of examples that goes to the heart of religious practice: “assembling with others for a worship service, participating in sacramental use of bread and wine, proselytizing, abstaining from certain foods or certain modes of transportation.”")]), _c('a', {
    attrs: {
      "href": "#/#foot-95",
      "id": "foot_95"
    }
  }, [_c('sup', [_vm._v("95")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The Court draws its sharp line between belief and practice where Oliver Cromwell drew it, with worship on the unprotected side. Cromwell said to the Catholics of Ireland:")]), _vm._v(" "), _c('p', {
    staticClass: "ext"
  }, [_vm._v("For that which you mention concerning liberty of conscience, I meddle not with any man’s conscience. But if by liberty of conscience you mean a liberty to exercise the mass, I judge it best to use plain dealing, and to let you know, where the Parliament of England have power, that will not be allowed of."), _c('a', {
    attrs: {
      "href": "#/#foot-96",
      "id": "foot_96"
    }
  }, [_c('sup', [_vm._v("96")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para1"
  }, [_vm._v("In similar fashion, Oregon and the Court have said that the peyote worshipers of Oregon can believe their religion but not practice it. The only difference between Scalia’s definition of religious liberty and Cromwell’s is that Scalia requires formal neutrality. Scalia would not let Cromwell expressly forbid Catholic worship services while permitting Puritan worship services. But Scalia has permitted Oregon to achieve that result with respect to peyote worship, and his test would permit Cromwell to achieve it with respect to the Mass. Cromwell could forbid the consumption of wine, or forbid the consumption of wine in any public place where children are present. Either provision would be facially neutral, and either would preclude the Mass as it has been practiced for centuries. It is unclear whether Scalia would let a court inquire into Cromwell’s motive for such a law."), _c('a', {
    attrs: {
      "href": "#/#foot-97",
      "id": "foot_97"
    }
  }, [_c('sup', [_vm._v("97")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Of course no state today is likely to suppress the Mass, and despite virulent anti-Catholicism in the founders’ generation, no American government in 1791 was likely to do so either. But Protestant-Catholic conflict was the most important source of religious persecution known to the founders. The purpose that we can most confidently attribute to the Religion Clauses is that the two centuries of religious conflict in the wake of the Reformation were not to be repeated here."), _c('a', {
    attrs: {
      "href": "#/#foot-98",
      "id": "foot_98"
    }
  }, [_c('sup', [_vm._v("98")])]), _vm._v(" Surely the founders did not intend a Free Exercise "), _c('a', {
    attrs: {
      "id": "page_92"
    }
  }, [_vm._v("Clause capable of giving constitutional legitimacy to Cromwellian persecutions — a clause that would permit the Protestant winners of a religious civil war to lawfully suppress the Mass.")])]), _c('a', {
    attrs: {
      "id": "page_92"
    }
  }), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_92"
    }
  }, [_vm._v("To invoke the shade of Cromwell is to invite the response that one does not do constitutional law by imagining impossible cases. But what makes the Cromwellian example seem impossible is that Catholics are part of the social and political mainstream, and there is no danger that lingering anti-Catholic prejudices will break out into open persecution. Both history and present experience reveal ample danger for religions outside the mainstream.")]), _c('a', {
    attrs: {
      "href": "#/#foot-99",
      "id": "foot_99"
    }
  }, [_c('sup', [_vm._v("99")])])]), _vm._v(" "), _c('h1', {
    staticClass: "sec5",
    attrs: {
      "id": "sec4-15"
    }
  }, [_c('strong', [_c('em', [_vm._v("C. The Court’s Conception of Religion")])])]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_c('em', [_vm._v("Swaggart")]), _vm._v(" and "), _c('em', [_vm._v("Smith")]), _vm._v(" say little explicit about the Court’s conception of religion, but they imply much. I should probably say here that I know little about the personal religiosity of the justices, which is none of my business. They are protected by both the Free Exercise Clause and the Test Oath Clause. Their personal religious conceptions may be quite different from the conceptions implicit in their opinions. They may have accepted convenient arguments to reach a legal result without considering the extent to which those arguments implied a conception of religion. But whatever they consciously thought about, a conception of the Free Exercise Clause inevitably implies a conception of religion.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('strong', [_vm._v("1. Religion as obeying the rules")]), _vm._v(". Parts of the "), _c('em', [_vm._v("Swaggart")]), _vm._v(" opinion experiment dangerously with a narrow conception of religion as obeying the rules. This implication appears most strongly in the free exercise holding. "), _c('em', [_vm._v("Swaggart")]), _vm._v(" appears to assume that the Free Exercise Clause protects conscientious objection claims, but not church autonomy claims."), _c('a', {
    attrs: {
      "href": "#/#foot-100",
      "id": "foot_100"
    }
  }, [_c('sup', [_vm._v("100")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("As to conscientious objection, "), _c('em', [_vm._v("Swaggart")]), _vm._v(" clearly assumed that if a specific doctrinal tenet forbids a church or its believers to comply with a particular law, then the Free Exercise Clause requires an exemption, subject to the compelling interest standard. This assumption was rejected three months later in "), _c('em', [_vm._v("Smith")]), _vm._v(", but "), _c('em', [_vm._v("Swaggart")]), _vm._v(" does not appear to anticipate that development. Justice O’Connor wrote "), _c('em', [_vm._v("Swaggart")]), _vm._v(", and she wrote separately in "), _c('em', [_vm._v("Smith")]), _vm._v(" to reject the Court’s doctrinal shift. If "), _c('em', [_vm._v("Swaggart")]), _vm._v(" implies a limit on free exercise, it is a limit independent of what followed in "), _c('em', [_vm._v("Smith.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_93"
    }
  }, [_vm._v("As to church autonomy, "), _c('em', [_vm._v("Swaggart")]), _vm._v(" assumes that there is little or no free exercise restraint on government’s power to regulate and burden religious practice and religious institutions, so long as government does not require violation of specific doctrinal tenets. The Court held open only the possibility that a free exercise issue might be raised if a generally applicable tax were heavy enough to “effectively choke off an adherent’s religious practices.”")]), _c('a', {
    attrs: {
      "href": "#/#foot-101",
      "id": "foot_101"
    }
  }, [_c('sup', [_vm._v("101")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Thus, the Court rejected the free exercise claim because the Swaggart organization did not allege that “the mere act of paying the tax, by itself, violates its sincere religious beliefs,” and because the burden of paying the tax was “not constitutionally significant.” The economic cost of the tax was like the economic cost of “other generally applicable laws and regulations.” Churches must comply with such laws unless their religious beliefs “mandated” noncompliance."), _c('a', {
    attrs: {
      "href": "#/#foot-102",
      "id": "foot_102"
    }
  }, [_c('sup', [_vm._v("102")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("This emphasis on what is required or mandated is not the whole of the opinion, but it is an important part of the opinion."), _c('a', {
    attrs: {
      "href": "#/#foot-103",
      "id": "foot_103"
    }
  }, [_c('sup', [_vm._v("103")])]), _vm._v(" Before trying to parse out how far the holding depends on this view, I want to explore what is at stake. What would follow if the Court were committed to the position that the Free Exercise Clause protects only the right to obey a religion’s mandatory teachings?")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("This position implies a wholly negative view of religion. It assumes that religions lay down certain binding rules, and that the exercise of religion consists only of obeying the rules. It is as though all of religious experience were reduced to the Book of Leviticus. It is the view of religion held by many secularized adults, who left the church in their youth after hearing much preaching about sin and failing to experience any benefits.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Those who stay in the church are those who do experience benefits. In the view of religion as obeying the rules, all the affirmative, communal, and spiritual aspects of religion are assumed away, placed outside the protection of the Free Exercise Clause. Practices that merely grow out of religious experience, or out of the traditions and interactions of a religious community, "), _c('a', {
    attrs: {
      "id": "page_94"
    }
  }, [_vm._v("are constitutionally unprotected unless they are mandated by binding doctrine.")])]), _c('a', {
    attrs: {
      "id": "page_94"
    }
  }), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_94"
    }
  }, [_vm._v("Lower courts have taken this conception of religion to astonishing lengths, upholding even discriminatory burdens on non-mandatory religious exercise. Thus, courts have held that rules excluding student prayer groups from campuses raise no free exercise issue, because Christians are not required to pray at any particular time or place.")]), _c('a', {
    attrs: {
      "href": "#/#foot-104",
      "id": "foot_104"
    }
  }, [_c('sup', [_vm._v("104")])]), _vm._v(" The Second Circuit suggested that Islamic prayer might be different, because Islamic prayer is required at particular times, and those times might fall within the school day."), _c('a', {
    attrs: {
      "href": "#/#foot-105",
      "id": "foot_105"
    }
  }, [_c('sup', [_vm._v("105")])]), _vm._v(" The Sixth Circuit held that there is no burden on religion when the public school requires children to read books that undermine their religious faith, so long as the school does not require them to believe what they read."), _c('a', {
    attrs: {
      "href": "#/#foot-106",
      "id": "foot_106"
    }
  }, [_c('sup', [_vm._v("106")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("A trial court, in a statutory employment discrimination case, held that leading a group of Catholic and Episcopalian laypeople is not protected religious practice, because it is not “required” by the faith."), _c('a', {
    attrs: {
      "href": "#/#foot-107",
      "id": "foot_107"
    }
  }, [_c('sup', [_vm._v("107")])]), _vm._v(" On that standard, the ministry is not protected religious practice either, because most members do not become ministers. A state supreme court has so held! A blind ministry student, denied vocational training benefits that would have been available for any secular occupation, argued that he was entitled to benefits under the Free Exercise Clause. The court held that he had no claim, because he had not lost benefits “because of conduct mandated by religious belief.”"), _c('a', {
    attrs: {
      "href": "#/#foot-108",
      "id": "foot_108"
    }
  }, [_c('sup', [_vm._v("108")])]), _vm._v(" The court had already held that paying the benefits would violate the state Establishment Clause; perhaps the free exercise reasoning is confined to its facts. The Supreme Court of the United States has sensibly held that the ministry is protected free exercise, although it could not agree on a majority opinion."), _c('a', {
    attrs: {
      "href": "#/#foot-109",
      "id": "foot_109"
    }
  }, [_c('sup', [_vm._v("109")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("It is probably the case that most religious practice is religiously motivated but not religiously mandated. Most religions have some unambiguous "), _c('a', {
    attrs: {
      "id": "page_95"
    }
  }, [_vm._v("requirements, and in some religions, compliance with a distinctive set of rules is one of the central and defining characteristics of the faith. But for many believers, the attempt to distinguish what is required from what grows organically out of the religious experience is an utterly alien question, perhaps a nonsensical and unanswerable question, certainly a question that reflects failure to comprehend much of their faith and experience. In most faiths, serious believers rarely concentrate their efforts on identifying the minimum that God requires. The most widely shared religion in the United States is not such a legalistic faith; consider Christ’s denunciation of “lawyers and Pharisees, hypocrites,” in part for their legalisms.")]), _c('a', {
    attrs: {
      "href": "#/#foot-110",
      "id": "foot_110"
    }
  }, [_c('sup', [_vm._v("110")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("It is true that the interest in free exercise is at a maximum when government prohibits what faith unambiguously requires, or requires what faith prohibits. These are the conflicts that present the greatest potential for suffering and persecution, and the burden of justification on government should also be at a maximum. But these cases are only a small part of religious practice, and they should be only a small part of what the Free Exercise Clause protects. Otherwise, no free exercise issue would be raised by a People’s Bureau for the Management and Supervision of Non-Mandatory Aspects of Religious Practice. The category of mandatory rules does not even exhaust the core of religious exercise, as illustrated by the examples of prayer and the ministry."), _c('a', {
    attrs: {
      "href": "#/#foot-111",
      "id": "foot_111"
    }
  }, [_c('sup', [_vm._v("111")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Perhaps the Court’s emphasis on specific doctrinal tenets was not intended to exhaust the meaning of the Free Exercise Clause, but only to exhaust the scope of the "), _c('em', [_vm._v("Sherbert-Yoder")]), _vm._v(" line of conscientious objection cases. But such a reading might improve the opinion only a little. Perhaps the Court meant something like this: Swaggart’s dissemination of his religious messages is a religious practice, but California has not forbidden that. The dissemination of messages is burdened, but burdens are permitted unless they are formally discriminatory, or unless they “effectively choke off” religious practice. Refusing to pay tax is forbidden and not merely burdened, but refusing to pay tax is not a religious practice unless it is mandated by religious "), _c('a', {
    attrs: {
      "id": "page_96"
    }
  }, [_vm._v("teachings. So if the dissemination of the messages is not unconstitutionally burdened, there is no independent free exercise objection to payment of the tax.")])]), _c('a', {
    attrs: {
      "id": "page_96"
    }
  }), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_96"
    }
  }, [_vm._v("There may be further clues in the Court’s Establishment Clause holding. Swaggart challenged the sales and use tax as an excessive church-state entanglement under the Establishment Clause. It is strange to think of taxing churches as an establishment of religion, but the Court’s current doctrine made the claim plausible. The Court rejected this claim in terms that also imply a narrow view of religion, but not quite so narrow as religion-as-obeying-the-rules. The Court rejected the entanglement claim because collection of the tax did not require “on-site” supervision of “day-to-day operations,” or inquiry “into religious content of the items or the religious motivation for selling or purchasing the items.” And “assuming that the tax imposes substantial administrative burdens,” such burdens are not “constitutionally significant.”")]), _c('a', {
    attrs: {
      "href": "#/#foot-112",
      "id": "foot_112"
    }
  }, [_c('sup', [_vm._v("112")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("At least here the Court recognizes religious motivations in terms that are not limited to compulsion. But again the focus is on specifically religious content and choices. There is little recognition of a general church interest in managing its own institutions. Government can apparently regulate the day-to-day operations of a church so long as it does not supervise them on site. That implication under the Establishment Clause is consistent with the Court’s implication under the Free Exercise Clause that non-mandatory religious practice is protected from discrimination or crushing burdens, but not from burdens that fail to choke off the practice.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("In the Establishment Clause part of the "), _c('em', [_vm._v("Swaggart")]), _vm._v(" opinion, the Court said it was already settled that churches are subject to regulation, and so it followed that they are subject to taxation."), _c('a', {
    attrs: {
      "href": "#/#foot-113",
      "id": "foot_113"
    }
  }, [_c('sup', [_vm._v("113")])]), _vm._v(" In fact it was not settled under either clause that churches are subject to regulation. In "), _c('em', [_vm._v("NLRB v. Catholic Bishop,")]), _c('a', {
    attrs: {
      "href": "#/#foot-114",
      "id": "foot_114"
    }
  }, [_c('sup', [_vm._v("114")])]), _vm._v(" the Court held the National Labor Relations Act inapplicable to parochial school teachers, because to apply it would raise grave questions under the Religion Clauses. The constitutional problem was not that collective bargaining might violate Catholic doctrine, which has long supported the moral right of workers to organize."), _c('a', {
    attrs: {
      "href": "#/#foot-115",
      "id": "foot_115"
    }
  }, [_c('sup', [_vm._v("115")])]), _vm._v(" Rather, "), _c('em', [_vm._v("Catholic Bishop")]), _vm._v(" contemplated a right of religious institutions to be free of regulation that intrudes into their internal affairs, and the Court stretched the statute to avoid deciding that issue. "), _c('a', {
    attrs: {
      "id": "page_97"
    }
  }, [_vm._v("Similarly, the Court had held that secular courts could not resolve internal church disputes, even on administrative matters.")]), _c('a', {
    attrs: {
      "href": "#/#foot-116",
      "id": "foot_116"
    }
  }, [_c('sup', [_vm._v("116")])]), _vm._v(" Some scholars have argued that these cases should point the way to a general right to church autonomy; other scholars have argued against such a right."), _c('a', {
    attrs: {
      "href": "#/#foot-117",
      "id": "foot_117"
    }
  }, [_c('sup', [_vm._v("117")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Swaggart’s brief relied heavily on these church autonomy cases, and hardly at all on the "), _c('em', [_vm._v("Sherbert-Yoder")]), _vm._v(" cases. But the Court ignored the church autonomy issue and the cases that posed it, and decided the "), _c('em', [_vm._v("Sherbert-Yoder")]), _vm._v(" issue instead. Without ever actually considering the question, "), _c('em', [_vm._v("Swaggart")]), _vm._v(" assumed that churches have at most a very narrow right to autonomous control of their internal affairs. If that assumption holds, it will be a very great loss to religious liberty, for reasons I have discussed at length elsewhere."), _c('a', {
    attrs: {
      "href": "#/#foot-118",
      "id": "foot_118"
    }
  }, [_c('sup', [_vm._v("118")])]), _vm._v(" It would not permit a single Bureau for the Supervision of Religion — that would be discriminatory. Instead, it would permit something that may be far worse: it would permit every government bureau to supervise religion in the neutral pursuit of its own bureaucratic agenda.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("This aspect of "), _c('em', [_vm._v("Swaggart")]), _vm._v(" may be moot after "), _c('em', [_vm._v("Smith’")]), _vm._v("s holding that mandatory religious practice is equally subject to regulation. But even the holding may not be moot, and the implicit view of religion is certainly not moot. "), _c('em', [_vm._v("Smith")]), _vm._v(" has narrow boundaries. It does not apply to belief and profession, to hybrid cases, or to laws that are not neutral and generally applicable. Outside those boundaries, "), _c('em', [_vm._v("Swaggart’")]), _vm._v("s conception of religion may remain relevant.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('strong', [_vm._v("2. Religion as a preference")]), _vm._v(". "), _c('em', [_vm._v("Smith")]), _vm._v(" depends on another belief about religion in contemporary America. This belief is not mentioned explicitly, and no particular sentence or paragraph implies it, but I suspect that it is critical to the whole opinion. The Court believes that religious minorities will give up their faith without a fuss if the law says they must. The Court believed it was deciding that strange people must modify their strange religions to conform to the legitimate demands of a modern society.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The Court probably did not believe it was deciding that these strange people should be forced to practice their religion underground, in the modern equivalent of catacombs. The Court almost certainly did not believe it "), _c('a', {
    attrs: {
      "id": "page_98"
    }
  }, [_vm._v("was deciding that all these people should be imprisoned for their faith. I doubt the Court thought about enforcement at all, in part because there was no real criminal prosecution before it.")])]), _c('a', {
    attrs: {
      "id": "page_98"
    }
  }), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_98"
    }
  }, [_vm._v("If enforcement problems did cross the mind of any justice in the majority, he surely assumed that there are not many potential martyrs in modern America. In a secular society where most people profess a religion but few let it inconvenience them, suppressing a faith would not be a problem. Religion is a preference like any other, and faced with a threat of enforcement, believers would change their preference. No persecutions would be necessary, because the threat of persecution would suffice.")]), _c('a', {
    attrs: {
      "href": "#/#foot-119",
      "id": "foot_119"
    }
  }, [_c('sup', [_vm._v("119")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("For some faiths and some believers, the Court is surely right. For others, it is likely to be wrong. The Mormons eventually gave up polygamy, but only after half a century of sometimes bloody conflict, the legal dissolution of their church, and the seizure of all its property. A few did not give it up; Mormon polygamy survives among underground groups who consider themselves the true faithful, and a polygamy case is pending in the Utah Supreme Court."), _c('a', {
    attrs: {
      "href": "#/#foot-120",
      "id": "foot_120"
    }
  }, [_c('sup', [_vm._v("120")])]), _vm._v(" The Jehovah’s Witnesses did not give up their conscientious objection to wartime alternative service, and five thousand of them spent part of World War II in federal prison."), _c('a', {
    attrs: {
      "href": "#/#foot-121",
      "id": "foot_121"
    }
  }, [_c('sup', [_vm._v("121")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The secularization of society is not universal. There are still those among us who experience or think they experience divine instructions, and who are willing to suffer for their faith. There are unfamiliar faiths arriving by immigration from all corners of the world, and many of them may have practices that will offend some local code. There are religious traditions among us that have survived hundreds or thousands of years of official hostility and intermittent persecution, and we should not expect them to suddenly conform to secular demands after reviewing "), _c('em', [_vm._v("Smith")]), _vm._v(" and the statute book. If the Court thought its opinion could be implemented without suffering, without religious resistance, without difficult choices about the means to overcome that resistance — in short, without a whole cluster of "), _c('a', {
    attrs: {
      "id": "page_99"
    }
  }, [_vm._v("evils that the Free Exercise Clause was designed to avoid — it was almost certainly mistaken.")])]), _c('a', {
    attrs: {
      "id": "page_99"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("But suppose the Court were right, and minority faiths comply with little resistance. Some may convert to Christianity or some other accepted faith; others may modify their own practice to eliminate any conflict with the law. The result will be that government has importantly determined religious faith and practice, terminating the existence of minority faiths or changing their central content. Suppression of a faith is no less suppression when the victims go quietly.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec5",
    attrs: {
      "id": "sec4-16"
    }
  }, [_c('strong', [_c('em', [_vm._v("D. The Court’s Conception of Judicial Role")])])]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_c('em', [_vm._v("Smith")]), _vm._v(" importantly depends on a particular conception of the judicial role: judges are not to balance competing interests. A right to religious exemptions from regulation cannot be absolute; the state must be able to override it for sufficiently compelling reasons. But if such a right is judicially enforceable, then judges must apply the compelling interest test, balancing the government’s need for regulation against the believer’s right to practice his faith.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_99"
    }
  }, [_vm._v("That, the Court assures us, would be “horrible.” “[I]t is horrible to contemplate that federal judges will regularly balance against the importance of general laws the significance of religious practice.” Suppression of religious minorities “must be preferred to a system … in which judges weigh the social importance of all laws against the centrality of all religious beliefs.”")]), _c('a', {
    attrs: {
      "href": "#/#foot-122",
      "id": "foot_122"
    }
  }, [_c('sup', [_vm._v("122")])]), _vm._v(" The Court says that its list of cases in which religious practice requires exemption from secular law is a parade of procedural horribles: These cases are horrible not because of their possible results, but because they would require judges to make judgments.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("My reactions to this basis for the Court’s holding come from two different perspectives. First, I think the Court is just wrong to be afraid of balancing, and that it has exaggerated both the difficulties and the uniqueness of balancing in the free exercise context. Second, from the Court’s own perspective, it is caught in contradiction. It has used astonishingly activist methods in pursuit of its non-activist agenda.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('strong', [_vm._v("1. The ubiquity of balancing")]), _vm._v(". If the Court is serious about getting federal judges out of the business of balancing, then a wholesale revolution in constitutional law is imminent. Balancing is absolutely central to the constitutional method adopted by the modern Court."), _c('a', {
    attrs: {
      "href": "#/#foot-123",
      "id": "foot_123"
    }
  }, [_c('sup', [_vm._v("123")])]), _vm._v(" This is no accident; the "), _c('a', {
    attrs: {
      "id": "page_100"
    }
  }, [_vm._v("sweeping imperatives of the Constitution’s individual rights provisions, sometimes conflicting with the government’s urgent need for exceptions, inherently require some sort of balancing.")]), _c('a', {
    attrs: {
      "href": "#/#foot-124",
      "id": "foot_124"
    }
  }, [_c('sup', [_vm._v("124")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("There is little reason to believe that "), _c('em', [_vm._v("Smith")]), _vm._v(" heralds a serious renunciation of balancing, although a changing Court may tilt the constitutional balance more and more in favor of the government. At one point in "), _c('em', [_vm._v("Smith")]), _vm._v(", the Court recognizes that the compelling interest test is “familiar from other fields.”"), _c('a', {
    attrs: {
      "href": "#/#foot-125",
      "id": "foot_125"
    }
  }, [_c('sup', [_vm._v("125")])]), _vm._v(" Elsewhere, it inconsistently claims that its aversion to balancing is general, and that it never balances with a variable on each side.")]), _vm._v(" "), _c('p', {
    staticClass: "ext"
  }, [_vm._v("It is no more appropriate for judges to determine the “centrality” of religious beliefs before applying a “compelling interest” test in the free exercise field, than it would be for them to determine the “importance” of ideas before applying the “compelling interest” test in the free speech field."), _c('a', {
    attrs: {
      "href": "#/#foot-126",
      "id": "foot_126"
    }
  }, [_c('sup', [_vm._v("126")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para1"
  }, [_vm._v("There is a problem with both halves of this comparison. I begin with the speech side, where the argument comes close to plain silliness. The Court has “long recognized that not all speech is of equal First Amendment importance.”"), _c('a', {
    attrs: {
      "href": "#/#foot-127",
      "id": "foot_127"
    }
  }, [_c('sup', [_vm._v("127")])]), _vm._v(" It holds that political speech is more important than commercial speech,"), _c('a', {
    attrs: {
      "href": "#/#foot-128",
      "id": "foot_128"
    }
  }, [_c('sup', [_vm._v("128")])]), _vm._v(" that criticism of public figures is more important than criticism of private figures,"), _c('a', {
    attrs: {
      "href": "#/#foot-129",
      "id": "foot_129"
    }
  }, [_c('sup', [_vm._v("129")])]), _vm._v(" that pornography has limited value"), _c('a', {
    attrs: {
      "href": "#/#foot-130",
      "id": "foot_130"
    }
  }, [_c('sup', [_vm._v("130")])]), _vm._v(" and obscenity has almost no value,"), _c('a', {
    attrs: {
      "href": "#/#foot-131",
      "id": "foot_131"
    }
  }, [_c('sup', [_vm._v("131")])]), _vm._v(" and that some speech is not of public concern."), _c('a', {
    attrs: {
      "href": "#/#foot-132",
      "id": "foot_132"
    }
  }, [_c('sup', [_vm._v("132")])]), _vm._v(" The day after "), _c('em', [_vm._v("Smith")]), _vm._v(", four of the five justices in the majority routinely balanced the "), _c('a', {
    attrs: {
      "id": "page_101"
    }
  }, [_vm._v("“exceedingly modest” interest in possessing child pornography against the state’s compelling interest in preventing “the exploitative use of children.”")]), _c('a', {
    attrs: {
      "href": "#/#foot-133",
      "id": "foot_133"
    }
  }, [_c('sup', [_vm._v("133")])]), _vm._v(" They did not find it necessary to explain away their statement of the day before.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The first half of the quoted comparison is part of the Court’s attempt to show that balancing is uniquely difficult in free exercise cases. The Court considers and rejects the possibility that only “central” religious practices should be protected. A threshold requirement of centrality would indeed be a mistake, both under-inclusive and unworkable. It would be under-inclusive because all religious practices are part of free exercise, and not just those the Court finds central. It would be unworkable because religious centrality is a continuous variable. It cannot be converted into a dichotomous variable, controlling a discontinuous leap from no protection at all to the compelling interest test, without producing distortion, error, and indefensible differences in result.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The opinion’s talk of centrality as a threshold requirement is thus a manufactured difficulty. But the Court is right that any balancing in the free exercise context must consider the burden on religious exercise as well as the threat to government’s compelling interests. The Court says it would be unworkable to deny that point, for to deny it would require “the same degree of ‘compelling state interest’ to impede the practice of throwing rice at church weddings as to impede the practice of getting married in church.”"), _c('a', {
    attrs: {
      "href": "#/#foot-134",
      "id": "foot_134"
    }
  }, [_c('sup', [_vm._v("134")])]), _vm._v(" But of course no one ever denied the point, and the Court’s reductio ad absurdum boomerangs. The majority appears to say it would be “horrible” and inappropriate for judges to recognize the difference between throwing rice and getting married in church. I think they could handle it.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Of course there would be hard cases as well as easy cases. But free exercise exemption cases are not uniquely unmanageable. Many free exercise cases fall into categories in which the balance is largely determined by the category."), _c('a', {
    attrs: {
      "href": "#/#foot-135",
      "id": "foot_135"
    }
  }, [_c('sup', [_vm._v("135")])]), _vm._v(" The degree of unconstrained judicial discretion would be further reduced if courts would take the compelling interest test literally and seriously. The question should not be whether it would be better on the whole to deny the exemption, but whether a particular religious exercise is doing such severe and tangible harm that the Court can imply from necessity an exception to a textually absolute constitutional right."), _c('a', {
    attrs: {
      "href": "#/#foot-136",
      "id": "foot_136"
    }
  }, [_c('sup', [_vm._v("136")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_102"
    }
  }, [_c('strong', [_vm._v("2. Judicial activism in pursuit of judicial minimalism")]), _vm._v(". When I say that the Court pursued its minimalist agenda with activist methods, I do not mean merely that it demolished twenty-seven years of precedent. That is not irrelevant; precedent should not be overruled lightly, or disingenuously. Rewriting the rationale of all those cases is an activist technique, but it is not inherently illegitimate. No reasoned understanding of precedent says that libertarian judges can overrule majoritarian precedents but not vice versa. Some of what the Court did in "), _c('em', [_vm._v("Smith")]), _vm._v(" does seem to be at the borders of jurisprudential legitimacy, and some of it crosses over. The Court artificially created a broad issue by an extraordinary procedure, and then decided that issue with substantive premises that come from outside the Constitution.")])]), _c('a', {
    attrs: {
      "id": "page_102"
    }
  }), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_102"
    }
  }, [_c('strong', [_vm._v("a) The procedure that created the issue")]), _vm._v(". A state administrative agency denied unemployment compensation because it found that Smith and Black had been discharged for misconduct as defined by the employer. The state courts reversed.")]), _c('a', {
    attrs: {
      "href": "#/#foot-137",
      "id": "foot_137"
    }
  }, [_c('sup', [_vm._v("137")])]), _vm._v(" The Oregon Supreme Court said that the state’s deference to employers’ definitions of misconduct was religiously neutral, and thus permissible under the state constitution. But it found federal law clearly to the contrary. Smith and Black had been discharged for practicing their religion, and to withhold unemployment compensation in those circumstances would violate the Free Exercise Clause as interpreted in "), _c('em', [_vm._v("Sherbert v. Verner")]), _c('a', {
    attrs: {
      "href": "#/#foot-138",
      "id": "foot_138"
    }
  }, [_c('sup', [_vm._v("138")])]), _vm._v(" and similar cases.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The Oregon court expressly held that the state’s interest in enforcing its drug laws was irrelevant to an unemployment compensation case."), _c('a', {
    attrs: {
      "href": "#/#foot-139",
      "id": "foot_139"
    }
  }, [_c('sup', [_vm._v("139")])]), _vm._v(" The United States Supreme Court granted certiorari and vacated the judgment, holding that Oregon’s criminal law was relevant after all."), _c('a', {
    attrs: {
      "href": "#/#foot-140",
      "id": "foot_140"
    }
  }, [_c('sup', [_vm._v("140")])]), _vm._v(" If religious use of peyote violated Oregon’s criminal law, and if that criminal law were constitutional, then Oregon could send Smith and Black to prison. A fortiori it could withhold their unemployment compensation. The Court remanded for a determination whether Smith and Black had violated the criminal law of Oregon.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("This does seem to be a case in which the greater power would properly include the lesser. If it is constitutional to impose a large (criminal) penalty, it must surely be constitutional to impose a small (loss-of-benefits) penalty for the very same conduct. But it is not clear why this reasoning required a remand. It should be constitutional to impose the loss-of-benefits penalty even "), _c('a', {
    attrs: {
      "id": "page_103"
    }
  }, [_vm._v("in a state that chooses not to impose the criminal penalty. The proposition that the greater power includes the lesser would not seem to depend on whether the greater power is actually exercised.")])]), _c('a', {
    attrs: {
      "id": "page_103"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The problem is not with the Court’s reasoning that the greater power includes the lesser, but with the unexamined consequences of applying that reasoning in this context. Surely Oregon can waive or disclaim its criminal law interests, and that may have happened here. So far as one can tell from the published opinions, the prosecutor had no intention of prosecuting, Smith and Black were not deterred by fear of prosecution, and the state’s highest court had said the state’s criminal law interests were irrelevant. The state Attorney General made no move to prosecute, but he did insist that criminal law policies were relevant to the unemployment compensation issue.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_103"
    }
  }, [_vm._v("The Court could have denied certiorari, or it could have decided the case as the Oregon court presented it. Instead, the Court reached out for the criminal law issue that it considered logically antecedent to the issue actually presented. This raised substantive, jurisdictional, and prudential questions that the Court appeared not to notice. The substantive question was whether a restriction on a constitutional right could be justified by a state interest not considered by the legislature when it enacted the challenged law.")]), _c('a', {
    attrs: {
      "href": "#/#foot-141",
      "id": "foot_141"
    }
  }, [_c('sup', [_vm._v("141")])]), _vm._v(" The jurisdictional question was whether the dispute over the relevance of Oregon’s criminal law policy went to the federal question of constitutional justification, or to the state question of the meaning of the unemployment compensation laws. The prudential question was whether the Court should decide the constitutionality of a criminal law in a case in which no criminal prosecution was pending, threatened, or feared, on an administrative record so skimpy that the state court had taken most of its facts from a California precedent decided twenty years before."), _c('a', {
    attrs: {
      "href": "#/#foot-142",
      "id": "foot_142"
    }
  }, [_c('sup', [_vm._v("142")])]), _vm._v(" Justices Rehnquist, White, O’Connor, and Scalia voted to decide the criminal law issue in this posture. In any other context, it seems doubtful that they would have considered the constitutionality of a criminal law in such an abstract posture."), _c('a', {
    attrs: {
      "href": "#/#foot-143",
      "id": "foot_143"
    }
  }, [_c('sup', [_vm._v("143")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_104"
    }
  }, [_vm._v("The fifth vote came from Justice Stevens, who wrote the opinion. He has argued in other contexts that the Court should not even review state court judgments upholding federal claims against states. He has said that if a state court provided more protection than the Constitution requires, this “outcome of the state processes offended no federal interest whatever.”")]), _c('a', {
    attrs: {
      "href": "#/#foot-144",
      "id": "foot_144"
    }
  }, [_c('sup', [_vm._v("144")])]), _vm._v(" He has found it “extraordinary” and wholly unjustified for the Supreme Court to uphold a state statute on “a rational basis that the highest court of the State has expressly rejected.”"), _c('a', {
    attrs: {
      "href": "#/#foot-145",
      "id": "foot_145"
    }
  }, [_c('sup', [_vm._v("145")])]), _vm._v(" If a state court substituted its judgment for the legislature’s, that was a “matter of indifference” to federal courts. That was in search and seizure, Commerce Clause, and equal protection cases. For Justice Stevens, free exercise cases are different."), _c('a', {
    attrs: {
      "href": "#/#foot-146",
      "id": "foot_146"
    }
  }, [_c('sup', [_vm._v("146")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("On remand, the Supreme Court of Oregon dutifully answered the questions posed to it, while making clear its view that it had been asked for an advisory opinion."), _c('a', {
    attrs: {
      "href": "#/#foot-147",
      "id": "foot_147"
    }
  }, [_c('sup', [_vm._v("147")])]), _vm._v(" The Oregon court said that there was no exemption for religious use in the Oregon drug laws, but that criminal punishment of the peyote service would violate the federal Free Exercise Clause as interpreted by Congress. Congress had repeatedly indicated its view that the regulatory exemption for peyote worship is constitutionally required."), _c('a', {
    attrs: {
      "href": "#/#foot-148",
      "id": "foot_148"
    }
  }, [_c('sup', [_vm._v("148")])]), _vm._v(" These views had been expressed only in legislative history and not in statutory text, but the Oregon court accepted them as an authoritative exercise of Congressional power, under section 5 of the Fourteenth Amendment, to “protect against state infringement what it believes to be the free exercise of religion protected under the First Amendment.”"), _c('a', {
    attrs: {
      "href": "#/#foot-149",
      "id": "foot_149"
    }
  }, [_c('sup', [_vm._v("149")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The state again successfully petitioned for certiorari. The case had now been converted into a proxy for a criminal prosecution, but the focus remained on peyote. The parties argued about its dangers, about the patterns of religious use, about whether a religious exemption would undermine all drug laws. Both sides agreed on the constitutional standard: Smith and Black were entitled to practice their religion unless the state had a compelling "), _c('a', {
    attrs: {
      "id": "page_105"
    }
  }, [_vm._v("reason to prevent them. The only issue was whether Oregon’s interest was compelling.")])]), _c('a', {
    attrs: {
      "id": "page_105"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The Court did not decide that issue. Instead it decided that no justification was required where the law was neutral and generally applicable. The alleged dangers of peyote were irrelevant to that issue; the facts and record were irrelevant; nothing mattered except the formal neutrality of the Oregon drug laws. Once again the question identified by the Court was logically antecedent to the question presented by the parties. But this time, neither side urged the relevance of the antecedent question, and neither side had any reason to suspect that the antecedent question might really be at issue.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_105"
    }
  }, [_vm._v("In other cases where the Court has decided to reconsider important issues not briefed by the parties, it has announced its intention and set the case for new briefs and new argument.")]), _c('a', {
    attrs: {
      "href": "#/#foot-150",
      "id": "foot_150"
    }
  }, [_c('sup', [_vm._v("150")])]), _vm._v(" It did not take that step in "), _c('em', [_vm._v("Smith.")]), _vm._v(" It fundamentally changed the law of free exercise without briefs or argument, in an abstract case created by the Court. The extraordinarily activist procedure contrasts sharply with the professed goals of minimizing judicial power.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('strong', [_vm._v("b) Extra-constitutional substantive premises")]), _vm._v(". "), _c('em', [_vm._v("Smith’")]), _vm._v("s strange procedural history may be idiosyncratic to the particular case, but the Court’s substantive premises appear to be generally applicable. I start with the Court’s treatment of "), _c('em', [_vm._v("Wisconsin v. Yoder.")]), _c('a', {
    attrs: {
      "href": "#/#foot-151",
      "id": "foot_151"
    }
  }, [_c('sup', [_vm._v("151")])]), _vm._v(" The Court said in "), _c('em', [_vm._v("Smith")]), _vm._v(" that "), _c('em', [_vm._v("Yoder")]), _vm._v(" would be illegitimate if decided under the Free Exercise Clause alone, but that it is legitimate as a hybrid case of free exercise and “the right of parents to direct the education of their children.”"), _c('a', {
    attrs: {
      "href": "#/#foot-152",
      "id": "foot_152"
    }
  }, [_c('sup', [_vm._v("152")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Of course the Constitution nowhere expressly mentions any right of parents or any right to direct education or anything about children. If there is a parental right to direct the education of children, it is an unenumerated right, protected only by the Ninth Amendment, or as the Court would presumably have it, by substantive due process."), _c('a', {
    attrs: {
      "href": "#/#foot-153",
      "id": "foot_153"
    }
  }, [_c('sup', [_vm._v("153")])]), _vm._v(" Especially in the wake of the Bork nomination and his inkblot theory of the Ninth Amendment,"), _c('a', {
    attrs: {
      "href": "#/#foot-154",
      "id": "foot_154"
    }
  }, [_c('sup', [_vm._v("154")])]), _vm._v(" I am delighted to see Justices Scalia, Rehnquist, Kennedy, and White unambiguously "), _c('a', {
    attrs: {
      "id": "page_106"
    }
  }, [_vm._v("endorse unenumerated rights in an opinion for the Court. I hope they mean it.")])]), _c('a', {
    attrs: {
      "id": "page_106"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("But I find it illegitimate to make unenumerated rights superior to the enumerated ones. Why is the Court willing to balance the state’s interest against parental preference on behalf of the unenumerated right of parental control, but not on behalf of the explicit right to free exercise of religion? If the Court feels free to enforce the unenumerated rights it likes, and to strip nearly all independent meaning from the enumerated rights it does not like, it is hard to see how the existence of a written Constitution affects its decisions. The point of enumerating certain rights was to ensure that at least those rights get enforced.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_106"
    }
  }, [_vm._v("The answer to this puzzle may be that the Court’s explanation of "), _c('em', [_vm._v("Yoder")]), _vm._v(" was made up for this day only, and we should not pay any attention to it. But the distinction also fits with the Court’s fears that free exercise exemptions discriminate in favor of persons with religious motivations. Religion should be broadly defined for purposes of free exercise exemptions,")]), _c('a', {
    attrs: {
      "href": "#/#foot-155",
      "id": "foot_155"
    }
  }, [_c('sup', [_vm._v("155")])]), _vm._v(" but no plausible definition will make all claims religious. A parental right to control education can be asserted by any parent, and so is more neutral than a free exercise right to control religious education.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Whatever the merits of a parental right to control education, the Court cannot legitimately reject free exercise claims on the ground that the clause protects only the exercise of religion. There is unambiguously in the Constitution a clause that protects only the exercise of religion. To reject claims under that clause because it does not fit the Court’s conception of neutrality is to unabashedly substitute the Court’s preferences for the text of the Constitution. And that is precisely what the opponents of judicial activism say they most fear.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The same activist error occurs in more general terms in the Court’s hostility to balancing. The Court agrees that plaintiffs are engaged in religious exercise and that Oregon is prohibiting that exercise. But the Court says it is not required to read the text in this straightforward way, and that it will not do so because that would require judicial balancing, which would be horrible. How does the Court know it would be horrible? Where in the Constitution does it say that? The horror of balancing is the Court’s own preference, injected into the Constitution without a basis in the text, in this case at the cost of stripping most of the meaning out of an express part of the text.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_107"
    }
  }, [_vm._v("The constitutional text is absolute, but everyone recognizes that some exceptions are required. The Court’s emphasis on formal neutrality is an attempt to limit the absolute text in a way that avoids balancing. But formal neutrality completely misfits the policies of the clause. It fits neither the interests of the government nor the interests of religion. It fails to protect core religious functions, and it often infringes religious liberty where the government has no real need to do so. It limits the text in a way that does not plausibly serve the purposes of the text.")])]), _c('a', {
    attrs: {
      "id": "page_107"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The need for limitations on the absolute text is an implication from necessity, and the Court will interpret the text most faithfully if it directly addresses the question of when implied exceptions are necessary. The combination of express substantive right and the necessity of implied exceptions leads directly to a certain kind of balancing. The Court cannot just say that such a clause is inconsistent with its conception of the judicial role. The judicial role is defined by the Constitution; the Constitution is not defined by changing conceptions of the judicial role. To refuse to enforce rights that are in the Constitution is as mistaken as enforcing rights that are not in the Constitution.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec4",
    attrs: {
      "id": "sec3-21"
    }
  }, [_c('strong', [_c('em', [_vm._v("III. The Practical Impact: What Is Left of Free Exercise?")])])]), _vm._v(" "), _c('h1', {
    staticClass: "sec5",
    attrs: {
      "id": "sec4-17"
    }
  }, [_c('strong', [_c('em', [_vm._v("A. Taxation of Churches")])])]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("The doctrinal change with respect to taxation is reasonably clear. Most tax statutes exempt churches, and that has not changed. "), _c('em', [_vm._v("Murdock")]), _vm._v(" struck down a minor tax on proselytizing, and created a plausible constitutional argument for more general church tax immunity. But the scope of constitutional tax immunity was never clear, and the issue was rarely litigated, because the statutory exemptions sufficed.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('em', [_vm._v("Swaggart")]), _vm._v(" unambiguously eliminates most constitutional claims to tax exemption. The real choices are now up to legislatures and tax authorities, where the impact is likely to be marginal. The Court’s new rule is that churches are constitutionally immune only from a flat tax that acts as a prior restraint. The boundaries of this category are not wholly unambiguous — what about a flat tax collected after the taxed activity is completed, or a proportionate tax that must be estimated and paid in advance, or a franchise tax on the existence of the religious organization, proportioned to some measure of size or activity and collected at the end of the year? But these are marginal questions, because license taxes of any form are a minor source of revenue.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_107"
    }
  }), _c('a', {
    attrs: {
      "id": "page_108"
    }
  }, [_vm._v("The important change is that churches may now be subjected to all but a tiny percentage of the taxes in a modern society. All the major taxes — sales tax, use tax, income tax, and property tax — and most minor taxes, including gross receipts taxes and most excise taxes and transfer taxes, are formally neutral, generally applicable, and not a flat license tax collected in advance. All would seem to be authorized by the opinion in "), _c('em', [_vm._v("Swaggart.")])])]), _c('a', {
    attrs: {
      "id": "page_108"
    }
  }), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_108"
    }
  }, [_vm._v("Whether these taxes will in fact be levied is up to the political branches and to state and local governments. "), _c('em', [_vm._v("Texas Monthly v. Bullock")]), _vm._v(" says that taxing authorities may not exempt religious organizations or activity as such, but "), _c('em', [_vm._v("Texas Monthly")]), _vm._v(" reaffirms that taxing authorities may include churches in broader categories of tax-exempt organizations, such as charitable organizations or not-for-profit organizations.")]), _c('a', {
    attrs: {
      "href": "#/#foot-156",
      "id": "foot_156"
    }
  }, [_c('sup', [_vm._v("156")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("There is little reason to expect a wholesale movement to repeal traditional tax exemptions. But increased taxation about the margins is inevitable. Governments in need of revenue will be more aggressive about taxing marginal church properties near the borders of the statutory exemptions, more aggressive about collecting tax on taxable activities that were formerly ignored or assumed to be exempt, and more aggressive about demanding “voluntary” contributions in lieu of taxes. Most churches will be burdened; some economically marginal churches will lose properties or abandon ministries. The fixed compliance costs of an interstate ministry are substantial, with scores of local jurisdictions adding their various levies to the basic state sales and use tax. The Court relied on these compliance costs when it held that the Commerce Clause exempts mail order sellers from collecting tax for their buyers’ home states."), _c('a', {
    attrs: {
      "href": "#/#foot-157",
      "id": "foot_157"
    }
  }, [_c('sup', [_vm._v("157")])]), _vm._v(" But if entering a state to hold a worship service is a permanent submission to the state’s taxing jurisdiction, the Commerce Clause rule is of no benefit to a traveling ministry.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Churches responding to new demands for revenue have lost their biggest bargaining chip; with no constitutional defense possible, they can never threaten constitutional litigation. We may reasonably expect political battles in tax-writing committees over proposals to limit or repeal various exemptions that include religion. Whether these developments are good or bad, and how they comport with a more general understanding of the Religion Clauses, I leave for another day.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("I note only one point, which frames the issue and explains why it must await another day. Even if the result in "), _c('em', [_vm._v("Swaggart")]), _vm._v(" is defensible, the reasoning is not. The Court holds that the burden of taxation is constitutionally insignificant, "), _c('a', {
    attrs: {
      "id": "page_109"
    }
  }, [_vm._v("but that cannot be right. Nor is it the case that tax exemption, considered alone, is a subsidy. Government does not subsidize a church by leaving it alone.")])]), _c('a', {
    attrs: {
      "id": "page_109"
    }
  }), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_109"
    }
  }, [_vm._v("If churches may be taxed, it is because they receive some (but not all) government services, and because government services to a tax-exempt body are a form of subsidy. The question is whether government services plus tax exemption is a greater departure from neutrality than the burdens of taxation. The answer may depend on the tax. A tax on unrelated business income is very different from a tax on dissemination of religious messages or on property essential to worship, or a tax that can be triggered by a sermon identifying political candidates whose views of public policy do not violate the church’s views of morality.")]), _c('a', {
    attrs: {
      "href": "#/#foot-158",
      "id": "foot_158"
    }
  }, [_c('sup', [_vm._v("158")])]), _vm._v(" Waiving a fee for specific services, like postage stamps, looks much more like a direct subsidy than exemption from taxes that go into general revenues. Both burden and subsidy may vary with context, and some cases may be hard. But the answer is not to dismiss the serious burdens of taxation as constitutionally insignificant. Religion is not free when the government charges for its exercise.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec5"
  }, [_c('strong', [_c('em', [_vm._v("B. Regulation of Religious Practice")])])]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("The impact of regulation on religious practice is much less clear. This impact may be sweeping or limited, depending on how the Court interprets all the boundaries and exceptions to its opinion. "), _c('em', [_vm._v("Smith")]), _vm._v(" announces a general rule of devastating sweep, but it also announces six overlapping exceptions and limitations, and "), _c('em', [_vm._v("Swaggart")]), _vm._v(" recognizes a seventh. The Free Exercise Clause never requires exemptions from formally neutral regulations of conduct, but:")]), _vm._v(" "), _c('ol', [_c('li', [_vm._v("This rule does not apply to regulation of religious belief and profession."), _c('a', {
    attrs: {
      "href": "#/#foot-159",
      "id": "foot_159"
    }
  }, [_c('sup', [_vm._v("159")])])]), _vm._v(" "), _c('li', [_vm._v("This rule does not apply to religious speech."), _c('a', {
    attrs: {
      "href": "#/#foot-160",
      "id": "foot_160"
    }
  }, [_c('sup', [_vm._v("160")])])]), _vm._v(" "), _c('li', [_vm._v("This rule does not apply to parental control of children’s education."), _c('a', {
    attrs: {
      "href": "#/#foot-161",
      "id": "foot_161"
    }
  }, [_c('sup', [_vm._v("161")])])]), _vm._v(" "), _c('li', [_vm._v("This rule does not apply to unemployment compensation cases."), _c('a', {
    attrs: {
      "href": "#/#foot-162",
      "id": "foot_162"
    }
  }, [_c('sup', [_vm._v("162")])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "id": "page_110"
    }
  }, [_vm._v("This rule does not apply to regulatory schemes that require an “individualized governmental assessment of the reasons for the relevant conduct.”")]), _c('a', {
    attrs: {
      "href": "#/#foot-163",
      "id": "foot_163"
    }
  }, [_c('sup', [_vm._v("163")])])]), _vm._v(" "), _c('li', [_vm._v("This rule does not apply to laws that are not formally neutral and generally applicable.")]), _vm._v(" "), _c('li', [_vm._v("There may be some protection for religious practice under the Establishment Clause."), _c('a', {
    attrs: {
      "href": "#/#foot-164",
      "id": "foot_164"
    }
  }, [_c('sup', [_vm._v("164")])])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para1"
  }, [_vm._v("If the Court means to defer to the political branches on questions of formal neutrality and the scope of the exceptions to "), _c('em', [_vm._v("Smith")]), _vm._v(", then very little is left of judicially enforceable free exercise. There are many religious practices that conflict with the regulatory agenda of one or another interest group, and there are few burdens on religion that cannot be conceptualized in formally neutral terms. But if the Court is serious about requiring at least formal neutrality, and if it is serious about its list of cases in which the Constitution still requires exemptions, then much religious exercise can still claim judicial protection. A serious requirement of formal neutrality must consider legislative motive, religious gerrymanders, exceptions, exemptions, defenses, gaps in coverage, actual or potential bias in enforcement, and whether the state regulates comparable secular conduct or pursues its alleged interests in secular contexts.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("In the remainder of this Section, I examine each of the exceptions and limitations in turn, reading them optimistically from the perspective of religious liberty.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('strong', [_vm._v("1. Belief and profession")]), _vm._v(". The Court begins its analysis by distinguishing “belief and profession” from “physical acts.”"), _c('a', {
    attrs: {
      "href": "#/#foot-165",
      "id": "foot_165"
    }
  }, [_c('sup', [_vm._v("165")])]), _vm._v(" It does not explicitly say that belief and profession are protected even from formally neutral regulation, but that is implied by the structure of the opinion and by the cases cited. The Court says that government cannot “punish the expression of religious doctrines it believes to be false,” citing "), _c('em', [_vm._v("United States v. Ballard."), _c('a', {
    attrs: {
      "href": "#/#foot-166",
      "id": "foot_166"
    }
  }, [_c('sup', [_vm._v("166")])]), _vm._v(" Ballard")]), _vm._v(" was a mail fraud prosecution against an evangelist who promised divine intervention on behalf of his contributors. The mail fraud law is formally neutral, but its application to claims of religious faith would plainly restrict religious exercise, and "), _c('em', [_vm._v("Ballard")]), _vm._v(" created a constitutional exemption.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Similarly, the Court says that government cannot “lend its power to one "), _c('a', {
    attrs: {
      "id": "page_111"
    }
  }, [_vm._v("or the other side in controversies over religious authority or dogma,” citing cases on secular resolution of disputes arising out of church schisms.")]), _c('a', {
    attrs: {
      "href": "#/#foot-167",
      "id": "foot_167"
    }
  }, [_c('sup', [_vm._v("167")])]), _vm._v(" The Court does not cite "), _c('em', [_vm._v("Jones v. Wolf,")]), _c('a', {
    attrs: {
      "href": "#/#foot-168",
      "id": "foot_168"
    }
  }, [_c('sup', [_vm._v("168")])]), _vm._v(" which moved this body of law considerably closer to the formal neutrality model. But even after "), _c('em', [_vm._v("Jones")]), _vm._v(", some formally neutral rules remain unconstitutional. Courts cannot apply to churches a formally neutral rule that when a private association splits into competing factions, the right to the original association’s name and property goes to the faction that adheres most closely to the original goals, purposes, or rules of the association."), _c('a', {
    attrs: {
      "href": "#/#foot-169",
      "id": "foot_169"
    }
  }, [_c('sup', [_vm._v("169")])]), _vm._v(" The Court’s brief reference to these cases in "), _c('em', [_vm._v("Smith")]), _vm._v(" implies that even formally neutral laws cannot interfere with internal church disputes, at least with respect to “religious authority or dogma.”"), _c('a', {
    attrs: {
      "href": "#/#foot-170",
      "id": "foot_170"
    }
  }, [_c('sup', [_vm._v("170")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("This restriction could provide substantial protection against a potent source of formally neutral intrusions into churches: the whole body of modern labor law, including discrimination laws, collective bargaining laws, and wrongful discharge law. These laws provide few exceptions for churches, but courts have generally refused to apply them to ministers and other religious teaching personnel."), _c('a', {
    attrs: {
      "href": "#/#foot-171",
      "id": "foot_171"
    }
  }, [_c('sup', [_vm._v("171")])]), _vm._v(" There is no exception in the employment discrimination laws for sex discrimination by churches."), _c('a', {
    attrs: {
      "href": "#/#foot-172",
      "id": "foot_172"
    }
  }, [_c('sup', [_vm._v("172")])]), _vm._v(" Must religious schools employ unwed mothers as school teachers?"), _c('a', {
    attrs: {
      "href": "#/#foot-173",
      "id": "foot_173"
    }
  }, [_c('sup', [_vm._v("173")])]), _vm._v(" Must faiths that teach a moral duty of mothers to care for small children in the home employ mothers of small children in paid work for the church outside the home?"), _c('a', {
    attrs: {
      "href": "#/#foot-174",
      "id": "foot_174"
    }
  }, [_c('sup', [_vm._v("174")])]), _vm._v(" Must the Roman Catholic Church ordain women priests?"), _c('a', {
    attrs: {
      "href": "#/#foot-175",
      "id": "foot_175"
    }
  }, [_c('sup', [_vm._v("175")])]), _vm._v(" Must churches employ or ordain practicing homosexuals under local gay rights ordinances?"), _c('a', {
    attrs: {
      "href": "#/#foot-176",
      "id": "foot_176"
    }
  }, [_c('sup', [_vm._v("176")])]), _vm._v(" Can "), _c('a', {
    attrs: {
      "id": "page_112"
    }
  }, [_vm._v("courts review the church’s reasons for discharging a parochial school teacher,")]), _c('a', {
    attrs: {
      "href": "#/#foot-177",
      "id": "foot_177"
    }
  }, [_c('sup', [_vm._v("177")])]), _vm._v(" a pastor,"), _c('a', {
    attrs: {
      "href": "#/#foot-178",
      "id": "foot_178"
    }
  }, [_c('sup', [_vm._v("178")])]), _vm._v(" or a bishop?"), _c('a', {
    attrs: {
      "href": "#/#foot-179",
      "id": "foot_179"
    }
  }, [_c('sup', [_vm._v("179")])]), _vm._v(" All of these cases present an internal dispute between the employee and the church, and often there is a reform faction that supports the employee’s position and an entrenched faction that resists it. If government cannot interfere in “controversies over religious authority,” then courts should continue to dismiss most of these cases.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Similarly, there is no express exception for churches in the National Labor Relations Act. The Supreme Court implied one in "), _c('em', [_vm._v("NLRB v. Catholic Bishop,")]), _c('a', {
    attrs: {
      "href": "#/#foot-180",
      "id": "foot_180"
    }
  }, [_c('sup', [_vm._v("180")])]), _vm._v(" holding that the bishop did not have to bargain collectively with unions of parochial school teachers. Some state labor boards have stepped into the resulting gap and successfully asserted jurisdiction."), _c('a', {
    attrs: {
      "href": "#/#foot-181",
      "id": "foot_181"
    }
  }, [_c('sup', [_vm._v("181")])]), _vm._v(" Does "), _c('em', [_vm._v("Smith")]), _vm._v(" validate these state labor board cases? Is there now no constitutional barrier to unionized parochial schools? What about convents and monasteries? Because it is almost inevitable that the union represents one contending faction within the church, and that unionization will affect future decisions about teaching personnel, "), _c('em', [_vm._v("Catholic Bishop")]), _vm._v(" may survive as a case about interference with internal church disputes. Alternatively, it may survive as a hybrid case about free exercise and parental control of education.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('strong', [_vm._v("2. Speech")]), _vm._v(". The Court in "), _c('em', [_vm._v("Smith")]), _vm._v(" appeared to say that religious speech is still protected even from formally neutral laws. The Court discussed speech in four different places, with no cross-references. First, the Court said that “belief and profession” are protected, citing "), _c('em', [_vm._v("Ballard")]), _vm._v(", a religious speech case."), _c('a', {
    attrs: {
      "href": "#/#foot-182",
      "id": "foot_182"
    }
  }, [_c('sup', [_vm._v("182")])]), _vm._v(" Second, the Court said that proselytizing and assembling for worship are conduct, even though they would seem to be speech and profession."), _c('a', {
    attrs: {
      "href": "#/#foot-183",
      "id": "foot_183"
    }
  }, [_c('sup', [_vm._v("183")])]), _vm._v(" Third, the Court recognized a right to constitutional exemptions from generally applicable laws in hybrid cases involving free exercise and speech, citing "), _c('a', {
    attrs: {
      "id": "page_113"
    }
  }, [_c('em', [_vm._v("Cantwell, Murdock")]), _vm._v(", and "), _c('em', [_vm._v("Follett")]), _vm._v(", all religious speech cases.")]), _c('a', {
    attrs: {
      "href": "#/#foot-184",
      "id": "foot_184"
    }
  }, [_c('sup', [_vm._v("184")])]), _vm._v(" So religious speech would seem to be protected as a hybrid claim, even if it is characterized as conduct. Finally, the Court said that the compelling interest test does not apply to “generally applicable laws unconcerned with regulating speech that have the effect of interfering with speech,” citing an antitrust case."), _c('a', {
    attrs: {
      "href": "#/#foot-185",
      "id": "foot_185"
    }
  }, [_c('sup', [_vm._v("185")])]), _vm._v(" This fourth passage is misleading as a description of the Court’s precedents, and in any event applies only to those laws that are formally neutral as between speech and non-expressive conduct. By its terms, this passage does not apply to laws that restrict speech but are formally neutral as between religious and secular speech. The passage appears in a footnote responding to the dissent, and it surely should not be taken as rejecting the Court’s approving citations, in text, of "), _c('em', [_vm._v("Ballard, Cantwell, Murdock")]), _vm._v(", and "), _c('em', [_vm._v("Follett.")]), _vm._v(" Despite the ambiguity of four separate discussions, it appears that religious speech is still protected even from formally neutral laws.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("An exception for speech should have many applications, some of them familiar. Religious speech has been and still is protected by the Speech Clause."), _c('a', {
    attrs: {
      "href": "#/#foot-186",
      "id": "foot_186"
    }
  }, [_c('sup', [_vm._v("186")])]), _vm._v(" The Free Exercise Clause stands as textual evidence that religious speech is central to the First Amendment, like fully protected political speech and not like commercial speech, obscenity, or other categories of speech with only limited constitutional protection. Presumably the Court’s category of “hybrid” free speech and free exercise cases recognizes this fully protected status.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Continued protection for religious speech is key to the many suits for fraud and intentional infliction of emotional distress now pending against high demand religions."), _c('a', {
    attrs: {
      "href": "#/#foot-187",
      "id": "foot_187"
    }
  }, [_c('sup', [_vm._v("187")])]), _vm._v(" These suits are typically brought by disgruntled members and their families; they often produce multi-million dollar verdicts that threaten the very existence of the defendant religion."), _c('a', {
    attrs: {
      "href": "#/#foot-188",
      "id": "foot_188"
    }
  }, [_c('sup', [_vm._v("188")])]), _vm._v(" The trials of "), _c('a', {
    attrs: {
      "id": "page_114"
    }
  }, [_vm._v("these cases are generally characterized by attempts to incite the jury to fear and hatred of a strange faith. But the liability rules of fraud and emotional distress are formally neutral.")])]), _c('a', {
    attrs: {
      "id": "page_114"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Religious speech requires the protection of the "), _c('em', [_vm._v("Ballard")]), _vm._v(" rule against fraud claims; jurors should not be allowed to decide whether claims of religious faith are true or false. "), _c('em', [_vm._v("Ballard")]), _vm._v(" does not and should not protect fraudulent claims about empirical matters that are verifiable in this world.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_114"
    }
  }, [_vm._v("Religious speech also requires protections analogous to those accorded the media in defamation")]), _c('a', {
    attrs: {
      "href": "#/#foot-189",
      "id": "foot_189"
    }
  }, [_c('sup', [_vm._v("189")])]), _vm._v(" and emotional distress cases."), _c('a', {
    attrs: {
      "href": "#/#foot-190",
      "id": "foot_190"
    }
  }, [_c('sup', [_vm._v("190")])]), _vm._v(" The Court recently vacated two judgments affirming large awards of punitive damages against religious bodies for intentional infliction of emotional distress."), _c('a', {
    attrs: {
      "href": "#/#foot-191",
      "id": "foot_191"
    }
  }, [_c('sup', [_vm._v("191")])]), _vm._v(" The Court decided no First Amendment issue; it remanded for consideration in light of its resolution of an insurance company’s claim that standardless awards of punitive damages violate the Due Process Clause."), _c('a', {
    attrs: {
      "href": "#/#foot-192",
      "id": "foot_192"
    }
  }, [_c('sup', [_vm._v("192")])]), _vm._v(" If religious speech is still protected from burdensome but formally neutral rules, then the Court cannot assume that the rule it creates for insurers is automatically adequate for churches.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("If religious speech is protected and religious conduct is not, litigants will claim that much conduct that previously would have been protected under the Free Exercise Clause is now protected as speech. Some of these claims may be strained, but many will be quite legitimate. William Marshall, who urged the Court to do what it did in "), _c('em', [_vm._v("Smith")]), _vm._v(", has also written that most religious conduct can be protected as speech."), _c('a', {
    attrs: {
      "href": "#/#foot-193",
      "id": "foot_193"
    }
  }, [_c('sup', [_vm._v("193")])]), _vm._v(" Certainly all claims to control ministers, teachers, and others who speak for the church may plausibly be presented as speech claims. Challenges to regulation of religious ritual and to landmarking of sacred architecture might plausibly be brought as speech claims. Surely the Boston Jesuits’ desire to relocate their altar in accord with "), _c('a', {
    attrs: {
      "id": "page_115"
    }
  }, [_vm._v("the liturgical reforms of the Second Vatican Council is a case of symbolic speech.")])]), _c('a', {
    attrs: {
      "id": "page_115"
    }
  }), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_115"
    }
  }, [_c('strong', [_vm._v("3. Parental control of education")]), _vm._v(". The Court’s exception for the unenumerated right of parents to control their children’s education would appear to make "), _c('em', [_vm._v("Smith")]), _vm._v(" inapplicable to a large body of litigation, mostly in the state courts, about conflicts between religion and state educational systems. The issues in these cases include intrusive regulation of religious schools,")]), _c('a', {
    attrs: {
      "href": "#/#foot-194",
      "id": "foot_194"
    }
  }, [_c('sup', [_vm._v("194")])]), _vm._v(" home schooling,"), _c('a', {
    attrs: {
      "href": "#/#foot-195",
      "id": "foot_195"
    }
  }, [_c('sup', [_vm._v("195")])]), _vm._v(" and exemptions from public school curricula that undermine religious faith."), _c('a', {
    attrs: {
      "href": "#/#foot-196",
      "id": "foot_196"
    }
  }, [_c('sup', [_vm._v("196")])]), _vm._v(" Even without "), _c('em', [_vm._v("Smith")]), _vm._v(" the states have been winning most of these cases in the lower courts, but the states have lost some, and they have lost the cases decided on the merits in the Supreme Court."), _c('a', {
    attrs: {
      "href": "#/#foot-197",
      "id": "foot_197"
    }
  }, [_c('sup', [_vm._v("197")])]), _vm._v(" Most of these issues remain open at the Supreme Court level, and apparently they remain subject to the compelling interest test.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('strong', [_vm._v("4. Unemployment compensation cases")]), _vm._v(". The Court’s exception for the unemployment compensation cases is the most cryptic of all. At one point, it seems to be an arbitrary exception for unemployment compensation only, based on nothing but precedent, like the distinction between baseball and football in antitrust law. The Court says: “Even if we were inclined to breathe into "), _c('em', [_vm._v("Sherbert")]), _vm._v(" some life beyond the unemployment compensation field, we would not apply it to require exemptions from a generally applicable criminal law.”"), _c('a', {
    attrs: {
      "href": "#/#foot-198",
      "id": "foot_198"
    }
  }, [_c('sup', [_vm._v("198")])]), _vm._v(" If these two categories overlap — as in "), _c('em', [_vm._v("Smith")]), _vm._v(", in which the employee was discharged for violating a generally applicable criminal law — the criminal-law category controls.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("But the Court does offer a reason for the unemployment compensation "), _c('a', {
    attrs: {
      "id": "page_116"
    }
  }, [_vm._v("exception, and the reason appears to have other applications. Indeed, the reason appears to have many applications, and to be a special case of the general requirement of neutrality. It requires separate treatment.")])]), _c('a', {
    attrs: {
      "id": "page_116"
    }
  }), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_116"
    }
  }, [_c('strong', [_vm._v("5. “Individualized governmental assessment of the reasons for the relevant conduct.”")]), _vm._v(" The Court says that the unemployment compensation cases provide for “individualized governmental assessment of the reasons for the relevant conduct,” and that “where the State has in place a system of individual exemptions, it may not refuse to extend that system to cases of ‘religious hardship’ without compelling reason.”")]), _c('a', {
    attrs: {
      "href": "#/#foot-199",
      "id": "foot_199"
    }
  }, [_c('sup', [_vm._v("199")])]), _vm._v(" There are two points run together here. One is individualized assessment, and the other is non-religious exemptions. They will often appear together, but as a matter of logic and policy, they have independent force.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The Court does not explain why individualized assessment cases are to be treated differently, but the reason must be that individualized decision-making provides ample opportunity for discrimination against religion in general or unpopular faiths in particular. Courts cannot assume that an individualized decision-making process was religion-blind just because the underlying statute or legal principle is religion-blind. For example, part of the problem in the fraud and intentional infliction of emotional distress suits against high-demand religions is that the jury can readily vent its hostility to strange religions in the guise of enforcing a supposedly neutral common law rule.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("This is also true, of, for example, zoning, landmarking, and condemnation decisions. Zoning boards restrict the location of new churches,"), _c('a', {
    attrs: {
      "href": "#/#foot-200",
      "id": "foot_200"
    }
  }, [_c('sup', [_vm._v("200")])]), _vm._v(" and what is far worse, restrict the ministries of existing churches."), _c('a', {
    attrs: {
      "href": "#/#foot-201",
      "id": "foot_201"
    }
  }, [_c('sup', [_vm._v("201")])]), _vm._v(" They sometimes "), _c('a', {
    attrs: {
      "id": "page_117"
    }
  }, [_vm._v("discriminate against minority faiths.")]), _c('a', {
    attrs: {
      "href": "#/#foot-202",
      "id": "foot_202"
    }
  }, [_c('sup', [_vm._v("202")])]), _vm._v(" The administration of landmarking laws has burdened churches at rates many times higher than any other class of property."), _c('a', {
    attrs: {
      "href": "#/#foot-203",
      "id": "foot_203"
    }
  }, [_c('sup', [_vm._v("203")])]), _vm._v(" Older religious institutions with open space are sometimes special targets of eminent domain, because it is cheaper to buy open space than to destroy buildings and restore them."), _c('a', {
    attrs: {
      "href": "#/#foot-204",
      "id": "foot_204"
    }
  }, [_c('sup', [_vm._v("204")])]), _vm._v(" These land use cases are readily subject to analysis under the "), _c('em', [_vm._v("Smith")]), _vm._v(" exception for individualized assessments.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("In such individualized decision-making processes, the Court’s explanation of its unemployment compensation cases would seem to require that religion get something analogous to most-favored-nation status. Religious speech should be treated as well as political speech, religious land uses should be treated as well as any other land use of comparable intensity, and so forth. Alleged distinctions — explanations that a proposed religious use will cause "), _c('a', {
    attrs: {
      "id": "page_118"
    }
  }, [_vm._v("more problems than some other use already approved — should be subject to strict scrutiny.")])]), _c('a', {
    attrs: {
      "id": "page_118"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The other point in the Court’s explanation of its unemployment compensation cases is secular exemptions. If the state grants exemptions from its law for secular reasons, then it must grant comparable exemptions for religious reasons. But this is part of the requirement of formal neutrality or general applicability, and nothing should turn on whether the secular exemptions are “individualized.” If the potential for an individualized secular exemption requires religious exemptions, then a fortiori a whole class of secular exemptions should require religious exemptions.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_118"
    }
  }, [_vm._v("In general, the allowance of any exemption is substantial evidence that religious exemptions would not threaten the statutory scheme. The state may conceivably have a compelling reason for denying some claims to religious exemption even though it grants other exemptions, but such cases should be quite rare. An example is "), _c('em', [_vm._v("Gillette v. United States,")])]), _c('a', {
    attrs: {
      "href": "#/#foot-205",
      "id": "foot_205"
    }
  }, [_c('sup', [_vm._v("205")])]), _vm._v(" holding that Congress could exempt from the military draft conscientious objectors who objected to war in any form, without exempting the much more numerous group who objected to unjust wars.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The requirement that religious conduct get the benefit of secular exemptions is a requirement of broad potential application. American statutes are riddled with exceptions and exemptions for various special interests, small businesses, private citizens, and government agencies. The federal employment discrimination laws do not apply to Congress or to employers with fewer than fifteen employees."), _c('a', {
    attrs: {
      "href": "#/#foot-206",
      "id": "foot_206"
    }
  }, [_c('sup', [_vm._v("206")])]), _vm._v(" The law penalizing employers of illegal aliens does not apply to employers of household help."), _c('a', {
    attrs: {
      "href": "#/#foot-207",
      "id": "foot_207"
    }
  }, [_c('sup', [_vm._v("207")])]), _vm._v(" The Florida humane slaughter law exempts any person slaughtering and selling “not more than 20 head of cattle nor more than 35 head of hogs per week.”"), _c('a', {
    attrs: {
      "href": "#/#foot-208",
      "id": "foot_208"
    }
  }, [_c('sup', [_vm._v("208")])]), _vm._v(" And so on.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Exemptions for secular interests without exemptions for religious practice reflect a hostile indifference to religion. It is not that the legislature was consciously trying to harm religion when it failed to create a religious exemption. Rather, it is that such a discriminatory pattern of exemptions shows that the legislature’s goals do not require universal application, and that the legislature "), _c('a', {
    attrs: {
      "id": "page_119"
    }
  }, [_vm._v("values the exempted secular activities more highly than the constitutionally protected religious activities. This pattern of exemptions reflects a legislative judgment that the free exercise of religion is less important than the demands of some special interest group of no constitutional significance. But that is a judgment inconsistent with the constitutional guarantee.")])]), _c('a', {
    attrs: {
      "id": "page_119"
    }
  }), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_119"
    }
  }, [_vm._v("A set of exemptions so institutionalized and generalized that they do not even seem to be exemptions is the scheduling of government functions on the Christian calendar. The Court is so accustomed to this calendar that it appears to think of persons desiring to observe minority holy days as asking for special treatment.")]), _c('a', {
    attrs: {
      "href": "#/#foot-209",
      "id": "foot_209"
    }
  }, [_c('sup', [_vm._v("209")])]), _vm._v(" Consider a Jewish student who asks to make up an examination administered on Yom Kippur. Such a student is not seeking special treatment; he is seeking an accommodation equal to that already extended to Christians. The school’s calendar is not formally neutral just because it never mentions religion. School never meets on Sunday; it never meets on Easter; there is a long break at Christmas, even in schools where the Christmas break falls at an awkward time near the end of the semester. School is the clearest example, but the point is general. Operating on a Christian calendar is a sensible accommodation to the Christian majority, but there is nothing neutral about it. Calendar exemptions for minority religious observance should be required, even after "), _c('em', [_vm._v("Smith")]), _vm._v(", because the calendar is not neutral.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('strong', [_vm._v("6. Formal neutrality")]), _vm._v(". The Court in "), _c('em', [_vm._v("Smith")]), _vm._v(" never defines neutrality. But the Court does implicitly recognize the obvious dangers of evasion and abuse.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Consider first the case of formally neutral laws enacted for the purpose of suppressing a minority faith. Recall the hypothetical of a law banning consumption of wine in public places where children are present. The Court says that a law is neutral if prohibiting the exercise of religion “is not the object of the [law] but merely the incidental effect.”"), _c('a', {
    attrs: {
      "href": "#/#foot-210",
      "id": "foot_210"
    }
  }, [_c('sup', [_vm._v("210")])]), _vm._v(" This language would seem to recognize that even a facially neutral law enacted with bad motive — for the “object” of suppressing a religion — is unconstitutional. That inference is supported by the Court’s immediate citation to "), _c('em', [_vm._v("Grosjean v. American Press Co.")]), _c('a', {
    attrs: {
      "href": "#/#foot-211",
      "id": "foot_211"
    }
  }, [_c('sup', [_vm._v("211")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The “incidental effect” language might also mean that a law is not neutral "), _c('a', {
    attrs: {
      "id": "page_120"
    }
  }, [_vm._v("if its anti-religious applications are such a major part of the total applications that the anti-religious effect cannot be characterized as “incidental.” Consider a facially neutral ban on the sale of unleavened bread. It is hard to imagine any motive for such a law other than hostility to Jews and to those Christians who use unleavened bread in the Eucharist. But suppose the state proves that its actual motive was legitimate — for example, to help the depressed local leaven industry. Still, because there are virtually no secular uses of unleavened bread to be affected by this law, the anti-religious effect would not be incidental, but overwhelmingly dominant. Such a law would not satisfy the Court’s “incidental effect” requirement. It would be unconstitutional unless it served a compelling interest by the least restrictive means, which is surely impossible in this example.")]), _c('a', {
    attrs: {
      "href": "#/#foot-212",
      "id": "foot_212"
    }
  }, [_c('sup', [_vm._v("212")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Consider also religious gerrymanders — laws carefully crafted to burden or benefit a particular religious practice without affecting similar secular practices or similar practices by another religion. Bad motives may be hidden in people’s heads, but a gerrymander is visible on the face of the statute book. Examples are a law forbidding any person wearing a saffron robe to appear on the streets with a shaved head, or a law forbidding the consumption of unleavened bread and bitter herbs at the same meal. Semester break at Christmas is more benign religious gerrymander, but a gerrymander nonetheless.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("A statute that appears neutral in isolation may be obviously not neutral when one considers the jurisdiction’s treatment of similar matters. If the state permits the same conduct for secular reasons that it forbids for religious reasons, or if it permits the infliction of the same harm for secular reasons that it forbids when inflicted for religious reasons, its regulation is neither neutral nor generally applicable. Even under "), _c('em', [_vm._v("Smith")]), _vm._v(", it must have a compelling reason for treating the religious conduct less favorably than the secular conduct.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('strong', [_vm._v("7. The Establishment Clause")]), _vm._v(". Finally, there is the surviving protection for religious exercise in the Establishment Clause. For twenty years the Court has summarized the Establishment Clause in its three-part "), _c('em', [_vm._v("Lemon")]), _vm._v(" test, stating that a law violates the Establishment Clause if it lacks a secular purpose, if it has the primary effect of either advancing or inhibiting religion, or if it excessively entangles the state in religious affairs."), _c('a', {
    attrs: {
      "href": "#/#foot-213",
      "id": "foot_213"
    }
  }, [_c('sup', [_vm._v("213")])]), _vm._v(" The Court has entertained claims by churches that burdensome regulations violate the inhibiting or entanglement "), _c('a', {
    attrs: {
      "id": "page_121"
    }
  }, [_vm._v("prongs of the Establishment Clause, most recently in "), _c('em', [_vm._v("Swaggart.")])]), _c('a', {
    attrs: {
      "href": "#/#foot-214",
      "id": "foot_214"
    }
  }, [_c('sup', [_vm._v("214")])]), _vm._v(" With "), _c('em', [_vm._v("Smith")]), _vm._v(" apparently taking away much of the protection previously found in the Free Exercise Clause, churches will increasingly turn to whatever protections may be found in the Establishment Clause.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("I find it implausible that a burden on religion might violate the Establishment Clause,"), _c('a', {
    attrs: {
      "href": "#/#foot-215",
      "id": "foot_215"
    }
  }, [_c('sup', [_vm._v("215")])]), _vm._v(" and especially so in the only case that matters — when it does not also violate the Free Exercise Clause. Carl Esbeck has argued, however, that the Establishment Clause regulates the institutional relationship between the state and organized churches, and that the proper institutional relationship is one of separation and mutual independence."), _c('a', {
    attrs: {
      "href": "#/#foot-216",
      "id": "foot_216"
    }
  }, [_c('sup', [_vm._v("216")])]), _vm._v(" Thus, a law that reduces the mutual independence of church and state presents an Establishment Clause issue, and it is irrelevant whether the law tends to help churches or harm them. Doctrinal tenets of the affected churches and the formal neutrality of the law are also irrelevant.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("This argument is not inconsistent with any specific language in "), _c('em', [_vm._v("Smith")]), _vm._v(", but there is no evidence in "), _c('em', [_vm._v("Smith")]), _vm._v(" or elsewhere that the Court will give more than minimal scope to the Establishment Clause in cases not involving arguable aid to religion. The Court has never ruled that a burden on religion violates either the inhibiting or entanglement prongs of its Establishment Clause doctrine. The Court has found violations of the entanglement doctrine only from programs in which there was a benefit to religion,"), _c('a', {
    attrs: {
      "href": "#/#foot-217",
      "id": "foot_217"
    }
  }, [_c('sup', [_vm._v("217")])]), _vm._v(" and it rejected the entanglement claim in "), _c('em', [_vm._v("Swaggart.")]), _vm._v(" This last exception to "), _c('em', [_vm._v("Smith")]), _vm._v(" may also be least.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec4",
    attrs: {
      "id": "sec3-22"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_122"
    }
  }, [_c('strong', [_c('em', [_vm._v("IV. The Legal Framework for Persecution")])])])]), _c('a', {
    attrs: {
      "id": "page_122"
    }
  }, [_c('p', {
    staticClass: "para1"
  }, [_c('em', [_vm._v("Smith")]), _vm._v(" announces a general rule that the Free Exercise Clause provides no substantive protection for religious conduct. It also notes enough exceptions and limitations to swallow most of its new rule. Everything seems to depend on judicial willingness to enforce the exceptions and police the neutrality requirement. The previous section assumed that "), _c('em', [_vm._v("Smith’")]), _vm._v("s exceptions and limitations are to be given full scope in the protection of religious liberty. This section assumes the opposite.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The Court in "), _c('em', [_vm._v("Smith")]), _vm._v(" was evidently seeking to get religious exemption cases out of the courts and to leave to the political branches the messy task of balancing the competing interests in religious exercise and government regulation. If the Court pursues that goal, it is unlikely to be vigorous about checking for bad motive or religious gerrymander. It may be myopic or deferential in considering claims that analogous secular behavior has gone unregulated. It is unlikely to expand the exceptions it created; it may let them wither away.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_122"
    }
  }, [_vm._v("The early decisions applying "), _c('em', [_vm._v("Smith")]), _vm._v(" in the lower courts give little content to the exceptions or even to the requirement of neutrality.")]), _c('a', {
    attrs: {
      "href": "#/#foot-218",
      "id": "foot_218"
    }
  }, [_c('sup', [_vm._v("218")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_123"
    }
  }, [_vm._v("If this trend continues, minority religions will effectively be at the mercy of the political branches. Many religions will be burdened, sometimes severely. Just how severely depends on how far the courts withdraw. I consider two doctrinal possibilities.")])]), _c('a', {
    attrs: {
      "id": "page_123"
    }
  }, [_c('h1', {
    staticClass: "sec5",
    attrs: {
      "id": "sec4-18"
    }
  }, [_c('strong', [_c('em', [_vm._v("A. Formal Neutrality without Exceptions")])])]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("First, assume that the courts carefully scrutinize legislative enactments for bad motives, religious gerrymanders, and the like, but that they narrowly interpret the "), _c('em', [_vm._v("Smith")]), _vm._v(" exceptions for internal church decision-making, speech, and parental control. That is, assume that the courts apply formal neutrality quite generally, but insist that it really be neutral. What results would follow?")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_123"
    }
  }, [_vm._v("One result might be more legislative exemptions for churches and believers. But if legislatures do not provide exemptions — if all the regulatory burdens of the modern state are laid on churches — churches would be severely damaged. The institutional damage to churches would be of two kinds. The first is simply the sheer burden of compliance. Rightly or wrongly, businesses complain about being strangled in red tape. But churches are not businesses; their product cannot be sold at a profit, and they cannot raise the price to cover the cost of regulation. They are largely dependent upon voluntary contributions, much of their cash flow is committed to charity,")]), _c('a', {
    attrs: {
      "href": "#/#foot-219",
      "id": "foot_219"
    }
  }, [_c('sup', [_vm._v("219")])]), _vm._v(" and a building in which to function is a large fixed expense. The demands of the modern regulatory state may severely constrain the religious mission.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Second, churches would frequently find that they simply cannot practice important parts of their faith, even within the enclave of the religious community. They would lose much of their capacity to preserve their distinctive traditions and values; they would gradually be suppressed or forced into assimilation. Theology could remain pluralistic, but religious practice would be pressured toward homogeneity by the sheer pervasiveness of modern regulation. "), _c('a', {
    attrs: {
      "id": "page_124"
    }
  }, [_vm._v("The churches would lose much of their role as mediating institutions and havens for pluralism.")])]), _c('a', {
    attrs: {
      "id": "page_124"
    }
  }), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_124"
    }
  }, [_vm._v("If this sounds alarmist, simply consider the range of regulatory issues mentioned in ")]), _c('span', {
    attrs: {
      "href": "#/046_Part03#pt-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part III")]), _vm._v(", and a few additional examples. If churches must share control of their institutions with unions and labor boards; if every church personnel dispute is resolved under secular standards with potential recourse to secular courts; if egalitarian sex roles may be enforced in church employment, or in the church itself as a place of public accommodation; if church schools must conform to secular models of curriculum, student discipline, and academic freedom; if church disciplinary processes are subject to secular standards of due process, or if any church discipline at all risks liability for intentional infliction of emotional distress; if all new ministries require notice to the neighbors and approval from the zoning board; if the Salvation Army cannot continue its ministry to the homeless unless it pays them the minimum wage;"), _c('a', {
    attrs: {
      "href": "#/#foot-220",
      "id": "foot_220"
    }
  }, [_c('sup', [_vm._v("220")])]), _vm._v(" if nuns cannot carry the handicapped homeless up a flight of steps because the code requires an elevator;"), _c('a', {
    attrs: {
      "href": "#/#foot-221",
      "id": "foot_221"
    }
  }, [_c('sup', [_vm._v("221")])]), _vm._v(" in short, if churches are neutrally subjected to the full range of modern regulation, it is hard to see how they can sustain any distinctive social structure or witness.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The impact would be greatest on the faiths most committed to traditional values and traditional sources of authority and most alienated from modern understandings of liberty and equality. Some will view it as a good thing to drag these “backward” institutions into the secular virtues of the post-modern age, but that assumes a dictatorial confidence in contemporary secular values. Believers who want a more libertarian or egalitarian church can find one; those who want no church at all can easily have that. Believers who want a more traditional religious community are entitled to it.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("These institutional impacts are in addition to the more widely recognized harm to individual conscientious objectors. Those who believe that God has commanded what the law forbids face an excruciating choice. Formal neutrality permits them no escape.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("These are the consequences of formal neutrality without legislative exemptions. Legislative exemptions are often hard to get, and they often require "), _c('a', {
    attrs: {
      "id": "page_125"
    }
  }, [_vm._v("a political battle. They may become harder to get in the wake of "), _c('em', [_vm._v("Smith.")]), _vm._v(" An arguable constitutional claim to exemption is also a political argument for exemption. If the Supreme Court says there is no constitutional right to exemption, the political argument for exemption is also weakened.")])]), _c('a', {
    attrs: {
      "id": "page_125"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Legislative exemptions are hard to get because the political dynamic of the modern regulatory state recognizes no natural limits to the pursuit of secular values. New regulatory legislation typically results when some interest group successfully demands it, and when such legislation is successfully enforced, it is either by the interest group on behalf of private litigants or by an agency that is committed to the legislative goals. Both the interest group and the agency tend to be single-mindedly focused on the benefits of their legislation; it is not for them to balance competing interests. Thus, those who initiate and enforce much modern legislation tend to be wholly unsympathetic to claims that religious liberty requires an exemption.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("If a church says that the sheer burden of compliance with particular legislation interferes with the religious mission, the interest group is unlikely to see that as an important enough reason to justify an exemption. If a church says that it is conscientiously opposed to compliance, the interest group is likely to see the church as an enemy, as a symbol of resistance to the goals of the legislation, legitimating other resistance by its moral or theological stance. If such a church can be forced to comply, that is an important victory in the larger fight to establish the goals of the interest group as unquestionably good things.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_125"
    }
  }, [_vm._v("Many of the church landmarking disputes illustrate the first kind of clash. Proponents of landmarking seem genuinely unable to comprehend why churches object to maintaining their houses of worship as permanent architectural museums, at the expense of those who worship there, for the aesthetic pleasure of those who do not. It does not matter to the landmarkers that the building has become liturgically or physically obsolete, that it is designed for a congregation much larger than the one that now worships there, or that maintaining the building may absorb all the resources that might have gone into charity, evangelism, education, or other aspects of the religious mission.")]), _c('a', {
    attrs: {
      "href": "#/#foot-222",
      "id": "foot_222"
    }
  }, [_c('sup', [_vm._v("222")])]), _vm._v(" The Second Circuit has cited "), _c('em', [_vm._v("Swaggart")]), _vm._v(" for the proposition that no constitutional issue is raised by a law that “drastically restricted the Church’s ability to raise revenues to carry out its various charitable and ministerial programs.”"), _c('a', {
    attrs: {
      "href": "#/#foot-223",
      "id": "foot_223"
    }
  }, [_c('sup', [_vm._v("223")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_126"
    }
  }, [_vm._v("The conflict over student gay rights organizations at Georgetown University illustrates the second kind of clash.")]), _c('a', {
    attrs: {
      "href": "#/#foot-224",
      "id": "foot_224"
    }
  }, [_c('sup', [_vm._v("224")])]), _vm._v(" This dispute has so far produced ten published judicial orders and two Acts of Congress. The sums expended on litigation and legislative lobbying far exceeded any economic stake for either side. The stakes were political and symbolic: could gay students force a Catholic university to recognize their equal status, and subsequently, could Congress force the City Council to accept the legitimacy of religious refusals to recognize the gay students’ equal status? It is hardly surprising that those who have devoted their time to leading the gay rights movement tend to see only one side to this issue.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("For churches and believers to get regulatory exemptions one at a time, statute by statute, requires a whole series of political battles of the magnitude illustrated by the landmarking dispute and the Georgetown gay rights dispute. A perpetual fight for regulatory exemptions will create serious political entanglement between church and state. I do not at all suggest that such political entanglement is unconstitutional,"), _c('a', {
    attrs: {
      "href": "#/#foot-225",
      "id": "foot_225"
    }
  }, [_c('sup', [_vm._v("225")])]), _vm._v(" but chronic legislative battles over the proper relationship between church and state are surely an unfortunate development.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The proposed Religious Freedom Restoration Act would avoid these problems by legislating religious exemptions all at once, across the board."), _c('a', {
    attrs: {
      "href": "#/#foot-226",
      "id": "foot_226"
    }
  }, [_c('sup', [_vm._v("226")])]), _vm._v(" The bill would provide that states must exempt churches and believers from laws that burden religious practice, unless the laws are formally neutral and there is compelling reason to deny the exemption. This part of the bill would be enacted pursuant to Congressional power to enforce the Fourteenth Amendment, which incorporates the Free Exercise Clause. The bill would apply the same rule to federal law as a mandatory rule of construction. Future Congresses could deny exemptions without a compelling interest, but only by express reference to the Religious Freedom Restoration Act. The model here is the Anti-Injunction Act,"), _c('a', {
    attrs: {
      "href": "#/#foot-227",
      "id": "foot_227"
    }
  }, [_c('sup', [_vm._v("227")])]), _vm._v(" which forbids federal injunctions against state judicial proceedings except where “expressly authorized” by Act of Congress. The bill gives Congress an opportunity to consider the need for religious exemptions in general terms, without the pressure of a particular problem to be addressed at the behest of a particular competing interest group.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec4",
    attrs: {
      "id": "sec4-19"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_127"
    }
  }, [_c('strong', [_c('em', [_vm._v("B. Formal Neutrality without Judicial Scrutiny")])])])]), _c('a', {
    attrs: {
      "id": "page_127"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_c('strong', [_vm._v("1. The risk of persecution")]), _vm._v(". So far I have assumed that even if "), _c('em', [_vm._v("Smith’")]), _vm._v("s exceptions to formal neutrality are allowed to wither, the Court will insist that formal neutrality at least be formally neutral. The equal protection right recognized in "), _c('em', [_vm._v("Smith")]), _vm._v(" requires strict scrutiny for its enforcement. The pervasiveness of modern regulation creates ample opportunity to hide hostile legislation in formally neutral terms. To avoid that danger, laws that burden religious practice must be scrutinized for evidence of anti-religious motive, religious gerrymander, or secular exemptions not available to churches or believers. The Court must perform at least this task, and insist that trial judges perform it. If the Court will not do this much, it has created a legal framework for persecution.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("I want to be very careful here, to avoid either overstating or understating the dangers. Religious liberty is one of America’s great inventions. The extent of religious pluralism in this country, and of legal and political protections for religious minorities, is probably unsurpassed in human experience. I have no desire to deny that achievement. But a counter-tradition also runs through American history. There have been religious persecutions in the American past, and it would be foolish to assume that there will not be religious persecutions in the American future. There are localized religious persecutions in the American present, and if the Court gives those persecutions a way to escape judicial review, they will accelerate.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Persecution” is a strong term, but it is the word I mean. Still, there are degrees of persecution. This country has never experienced the worst, and I am not predicting the worst. The strongest form of persecution is a systematic effort to kill all persons who believe in a minority faith, or who refuse to profess belief in the established faith. That has happened in other lands, but it has never happened here, and there is no apparent danger that it will happen here.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The next strongest form of persecution is a systematic effort to entirely eliminate the practice of a faith within a jurisdiction. This is what Cromwell did when he suppressed the Mass, and this is what the Court says Oregon may do to suppress peyote worship. There is an important difference between the two cases, but the Court’s emphasis on formal neutrality does not capture that difference. From the perspective of the minority whose religion is suppressed, it matters little whether Oregon suppresses all uses of peyote or only religious uses of peyote. The victims may feel worse knowing that Oregon has singled them out for discriminatory legislation, but either way, the dominant fact is that they cannot worship.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_127"
    }
  }, [_vm._v("From the point of view of the worshiper, what is importantly different between the Oregon situation and Cromwell is that the executive branch in ")]), _c('a', {
    attrs: {
      "id": "page_128"
    }
  }, [_vm._v("Oregon is not committed to vigorous enforcement efforts. It is not searching out peyote worshipers, prosecuting them, and demanding long prison sentences. The state has invested substantial litigation resources to win a symbolic affirmation of its right to suppress; it has not so far invested enforcement resources to actually suppress. A serious enforcement effort would surely produce a political reaction, and if the peyote worshipers persisted in the face of repeated prosecutions, it seems unlikely that the state would have the political will for persistent enforcement. I do not know the political situation in Oregon, but nothing I have read suggests the degree of hatred needed to fuel serious persecution. The legal framework for persecution is in place, but not the political will.")])]), _c('a', {
    attrs: {
      "id": "page_128"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_c('strong', [_vm._v("2. Past American persecutions")]), _vm._v(". At times Americans have had the political will for persecution, and in places they have it today. The history of religious tolerance in America reveals a gradually expanding circle of religious groups that are tolerated and even accepted, together with recurrent outbursts of public or private persecution of religions outside that perimeter.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_128"
    }
  }, [_vm._v("The New England theocracy expelled dissenters, executed Quaker missionaries who returned,")]), _c('a', {
    attrs: {
      "href": "#/#foot-228",
      "id": "foot_228"
    }
  }, [_c('sup', [_vm._v("228")])]), _vm._v(" and, most infamously, perpetrated the Salem witch trials. The political reaction to these trials broke the power of the theocracy in Massachusetts."), _c('a', {
    attrs: {
      "href": "#/#foot-229",
      "id": "foot_229"
    }
  }, [_c('sup', [_vm._v("229")])]), _vm._v(" Colonial Virginia imprisoned Baptist ministers for preaching without a license."), _c('a', {
    attrs: {
      "href": "#/#foot-230",
      "id": "foot_230"
    }
  }, [_c('sup', [_vm._v("230")])]), _vm._v(" But the largest and most important colonial religious persecution is relatively unknown. This was the total suppression of African religion among the slaves, what one historian has called “the African spiritual holocaust.”"), _c('a', {
    attrs: {
      "href": "#/#foot-231",
      "id": "foot_231"
    }
  }, [_c('sup', [_vm._v("231")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The best-known victims of American religious persecution in the nineteenth century were Catholics and Mormons. Hostility to Catholics fueled successive political movements."), _c('a', {
    attrs: {
      "href": "#/#foot-232",
      "id": "foot_232"
    }
  }, [_c('sup', [_vm._v("232")])]), _vm._v(" The first peaked at mid-century, with mob violence, church burnings, and the anti-Catholic, anti-immigrant Know Nothing Party sweeping elections in eight states."), _c('a', {
    attrs: {
      "href": "#/#foot-233",
      "id": "foot_233"
    }
  }, [_c('sup', [_vm._v("233")])]), _vm._v(" The worst of this was in "), _c('a', {
    attrs: {
      "id": "page_129"
    }
  }, [_vm._v("the form of private violence rather than governmental action. But government was responsible for a de facto Protestant establishment in the public schools.")]), _c('a', {
    attrs: {
      "href": "#/#foot-234",
      "id": "foot_234"
    }
  }, [_c('sup', [_vm._v("234")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("After the Civil War, there was a nationwide movement to forbid the expenditure of public funds in sectarian schools. This culminated in a proposed constitutional amendment, sponsored by James G. Blaine and defeated by Democrats in the Senate,"), _c('a', {
    attrs: {
      "href": "#/#foot-235",
      "id": "foot_235"
    }
  }, [_c('sup', [_vm._v("235")])]), _vm._v(" and a wave of state constitutional amendments forbidding public financing of religious schools."), _c('a', {
    attrs: {
      "href": "#/#foot-236",
      "id": "foot_236"
    }
  }, [_c('sup', [_vm._v("236")])]), _vm._v(" The state constitutional amendments may be defended as a victory for disestablishment and thus for religious liberty, although that view of disestablishment has been disputed."), _c('a', {
    attrs: {
      "href": "#/#foot-237",
      "id": "foot_237"
    }
  }, [_c('sup', [_vm._v("237")])]), _vm._v(" Whatever the ultimate merits of that argument, the historical political movement was targeted at Catholics, who had complained of Protestant instruction in the public schools, and much of the motivation was anti-Catholicism."), _c('a', {
    attrs: {
      "href": "#/#foot-238",
      "id": "foot_238"
    }
  }, [_c('sup', [_vm._v("238")])]), _vm._v(" It was in the context of this controversy that a Protestant minister endorsed Blaine’s campaign for the Presidency on the ground that the Democrats were the party of “rum, Romanism, and rebellion.”"), _c('a', {
    attrs: {
      "href": "#/#foot-239",
      "id": "foot_239"
    }
  }, [_c('sup', [_vm._v("239")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("A third wave came after World War I, when Oregon enacted a formally neutral law requiring all children to attend public schools."), _c('a', {
    attrs: {
      "href": "#/#foot-240",
      "id": "foot_240"
    }
  }, [_c('sup', [_vm._v("240")])]), _vm._v(" The effect would have been to close all private schools, most of which were Catholic. The Supreme Court invalidated the Oregon law before it could take effect."), _c('a', {
    attrs: {
      "href": "#/#foot-241",
      "id": "foot_241"
    }
  }, [_c('sup', [_vm._v("241")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_130"
    }
  }, [_vm._v("The Mormon experience was worse, and government was more fully involved. The Mormons fled from New York, to Ohio, to Missouri, to Illinois, to Utah, which was then in the most isolated reaches of Mexico.")]), _c('a', {
    attrs: {
      "href": "#/#foot-242",
      "id": "foot_242"
    }
  }, [_c('sup', [_vm._v("242")])]), _vm._v(" They were driven off their lands in Missouri by a combination of armed mobs and state militia."), _c('a', {
    attrs: {
      "href": "#/#foot-243",
      "id": "foot_243"
    }
  }, [_c('sup', [_vm._v("243")])]), _vm._v(" Their prophet, Joseph Smith, was murdered by a mob while in the custody of the state of Illinois."), _c('a', {
    attrs: {
      "href": "#/#foot-244",
      "id": "foot_244"
    }
  }, [_c('sup', [_vm._v("244")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The federal effort to suppress Mormon polygamy appears to have been a bona fide effort to suppress polygamy and not an effort to destroy Mormonism entirely. But the government was quite willing to destroy Mormonism entirely if that were necessary to suppress polygamy. The government prosecuted “hundreds” of Mormons for polygamy,"), _c('a', {
    attrs: {
      "href": "#/#foot-245",
      "id": "foot_245"
    }
  }, [_c('sup', [_vm._v("245")])]), _vm._v(" it imposed test oaths that denied Mormons the right to vote,"), _c('a', {
    attrs: {
      "href": "#/#foot-246",
      "id": "foot_246"
    }
  }, [_c('sup', [_vm._v("246")])]), _vm._v(" and it dissolved the Mormon Church and confiscated its property."), _c('a', {
    attrs: {
      "href": "#/#foot-247",
      "id": "foot_247"
    }
  }, [_c('sup', [_vm._v("247")])]), _vm._v(" The Supreme Court upheld all of this.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("A less noted aspect of the Mormon persecution is that Congress regulated family law directly, taking this traditional authority away from the territorial legislature. Unable to regulate family law directly after statehood, Congress required Utah and several other western states to attempt to disable their state legislatures. The Enabling Acts authorizing creation of these states required that the state constitution ban polygamy in a clause irrevocable without a popular referendum plus the consent of Congress."), _c('a', {
    attrs: {
      "href": "#/#foot-248",
      "id": "foot_248"
    }
  }, [_c('sup', [_vm._v("248")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The Jehovah’s Witness cases that reached the Supreme Court from the late 1930s to the early 1950s arose from the best-known twentieth-century outbreak of religious persecution. The Witnesses were persistent and aggressive proselytizers, and their message was offensively intolerant of other faiths, "), _c('a', {
    attrs: {
      "id": "page_131"
    }
  }, [_vm._v("and especially of Catholicism.")]), _c('a', {
    attrs: {
      "href": "#/#foot-249",
      "id": "foot_249"
    }
  }, [_c('sup', [_vm._v("249")])]), _vm._v(" Towns all over America tried to stop them from proselytizing, enacting a remarkable variety of ordinances, most of which were struck down."), _c('a', {
    attrs: {
      "href": "#/#foot-250",
      "id": "foot_250"
    }
  }, [_c('sup', [_vm._v("250")])]), _vm._v(" The Court’s decision in "), _c('em', [_vm._v("Minersville School District v. Gobitis,")]), _c('a', {
    attrs: {
      "href": "#/#foot-251",
      "id": "foot_251"
    }
  }, [_c('sup', [_vm._v("251")])]), _vm._v(" upholding the requirement that Jehovah’s Witnesses salute the flag, triggered a nationwide outburst of private violence against the Witnesses."), _c('a', {
    attrs: {
      "href": "#/#foot-252",
      "id": "foot_252"
    }
  }, [_c('sup', [_vm._v("252")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The Court in "), _c('em', [_vm._v("Smith")]), _vm._v(" relied heavily on "), _c('em', [_vm._v("Gobitis")]), _vm._v(" and on one of the Mormon cases, "), _c('em', [_vm._v("Reynolds v. United States.")]), _c('a', {
    attrs: {
      "href": "#/#foot-253",
      "id": "foot_253"
    }
  }, [_c('sup', [_vm._v("253")])]), _vm._v(" Both of these cases were central to genuine persecutions. "), _c('em', [_vm._v("Pierce v. Society of Sisters,")]), _c('a', {
    attrs: {
      "href": "#/#foot-254",
      "id": "foot_254"
    }
  }, [_c('sup', [_vm._v("254")])]), _vm._v(" striking down the formally neutral law closing private schools, averted another genuine persecution. The connection between religious persecution and formal neutrality interpretations of the Free Exercise Clause is not merely theoretical. It is historical.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('strong', [_vm._v("3. Contemporary persecutions")]), _vm._v(". These historical persecutions have two contemporary counterparts. There may be others, but these are the two I know about sufficiently to describe. One is the treatment of the so-called cults, itself a derogatory term. I mean the unfamiliar, high-demand, proselytizing religions, recently arrived from Asia or recently invented on these shores: the Hare Krishnas, the Unification Church, the Scientologists, and others less well known. Most of them are recent developments, but one, the Hare Krishnas, is generally accepted by Hindus as a bona fide branch of Hinduism."), _c('a', {
    attrs: {
      "href": "#/#foot-255",
      "id": "foot_255"
    }
  }, [_c('sup', [_vm._v("255")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_132"
    }
  }, [_vm._v("A loosely organized movement of private citizens is working to destroy these religions.")]), _c('a', {
    attrs: {
      "href": "#/#foot-256",
      "id": "foot_256"
    }
  }, [_c('sup', [_vm._v("256")])]), _vm._v(" The best-known controversy has surrounded the movement’s technique of physically abducting and “deprogramming” young adults who have joined high-demand religions against the wishes of their families."), _c('a', {
    attrs: {
      "href": "#/#foot-257",
      "id": "foot_257"
    }
  }, [_c('sup', [_vm._v("257")])]), _vm._v(" But the anti-cult movement found a much more powerful weapon in tort suits for emotional distress and punitive damages. These suits have produced verdicts exceeding $30 million. Verdicts as large as $3 million have survived post-trial motions and remittiturs, and some of these verdicts exceed $5 million with accrued interest."), _c('a', {
    attrs: {
      "href": "#/#foot-258",
      "id": "foot_258"
    }
  }, [_c('sup', [_vm._v("258")])]), _vm._v(" Few minority religions can survive more than one such judgment; none can survive several. All Krishna temples and monasteries in the United States are now in receivership, execution proceedings, or subject to lis pendens filings, to secure just one of these judgments. The Supreme Court vacated the judgment for further consideration of the Krishnas’ constitutional claims;"), _c('a', {
    attrs: {
      "href": "#/#foot-259",
      "id": "foot_259"
    }
  }, [_c('sup', [_vm._v("259")])]), _vm._v(" if those claims are ultimately rejected, the temples and monasteries will be sold. Seizing places of worship is a time-honored means of persecution: the Romans destroyed the Jewish Temple, and Henry VIII seized the Catholic monasteries, and both events are remembered centuries later.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("These extraordinary judgments have resulted from the application of formally neutral tort rules in decidedly non-neutral ways. The typical plaintiff is a disgruntled former adherent of the faith, often joined by relatives. The torts commonly alleged include intentional infliction of emotional distress, invasion of privacy, fraud and misrepresentation, and false imprisonment based not on alleged physical restraint but only on claims of “brainwashing.” The alleged wrongdoing typically consists of a series of communications, many of them communications about religious belief. Most of the sums claimed are punitive damages and compensatory damages for emotional distress, neither of which is measurable by any objective standard.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("From beginning to end, these cases consist of subjective and intangible elements. Even with careful and unbiased effort, it is difficult to separate the actionable wrongdoing, where there is any, from protected religious exercise. These cases provide maximum opportunity for juries to act on their prejudices, and minimum opportunity for judges to control juries.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_133"
    }
  }, [_vm._v("Whatever the merits and demerits of these religions that seem so odd to most Americans, they are, in historical perspective, simply the “cults” of our time. Other “cults” appear throughout the American past.")]), _c('a', {
    attrs: {
      "href": "#/#foot-260",
      "id": "foot_260"
    }
  }, [_c('sup', [_vm._v("260")])]), _vm._v(" The Baptists, Methodists, Presbyterians, Mormons, and Jehovah’s Witnesses all began as unfamiliar, high-demand, proselytizing religions, greeted with deep hostility by more sedate and longer established faiths. Nineteenth-century America spawned many such groups, most of which eventually faded away. Parents of converts reacted in much the same way as modern parents of Krishna or Unification converts, and angry parents found professional help. Today’s anti-cult psychiatrists diagnose “coercive persuasion”; the nineteenth-century equivalent was “religious insanity.”"), _c('a', {
    attrs: {
      "href": "#/#foot-261",
      "id": "foot_261"
    }
  }, [_c('sup', [_vm._v("261")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The other victim of contemporary religious persecution is the Santeria minority in South Florida. Santeria is an Afro-Caribbean religion with an estimated hundred million adherents in the Western hemisphere."), _c('a', {
    attrs: {
      "href": "#/#foot-262",
      "id": "foot_262"
    }
  }, [_c('sup', [_vm._v("262")])]), _vm._v(" Santeria and similar Afro-Caribbean religions may be the third largest religious group in South Florida, after Christianity and Judaism. An anthropologist who has studied African religion on both sides of the Atlantic reports that Santeria is faithful to its African roots."), _c('a', {
    attrs: {
      "href": "#/#foot-263",
      "id": "foot_263"
    }
  }, [_c('sup', [_vm._v("263")])]), _vm._v(" It is not Voodoo, and it is not Satanism."), _c('a', {
    attrs: {
      "href": "#/#foot-264",
      "id": "foot_264"
    }
  }, [_c('sup', [_vm._v("264")])]), _vm._v(" It is an ancient faith that has not adapted to the mores of modern Western culture.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The essential Santeria rituals involve the sacrifice of animals, usually goats and chickens. A government wishing to suppress the Santeria worship service would pass a law forbidding animal sacrifice. The City of Hialeah has passed four such ordinances, and their constitutionality is now in litigation."), _c('a', {
    attrs: {
      "href": "#/#foot-265",
      "id": "foot_265"
    }
  }, [_c('sup', [_vm._v("265")])]), _vm._v(" Under "), _c('em', [_vm._v("Smith")]), _vm._v(", the threshold issue is whether the ordinances are formally neutral.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("It seems to me obvious that the ordinances are not neutral. Hialeah ordinances "), _c('a', {
    attrs: {
      "id": "page_134"
    }
  }, [_vm._v("and Florida law permit people to kill animals for a vast array of secular reasons. Indeed, hunting is a constitutionally protected activity in Florida,")]), _c('a', {
    attrs: {
      "href": "#/#foot-266",
      "id": "foot_266"
    }
  }, [_c('sup', [_vm._v("266")])]), _vm._v(" the state runs camps to teach children how to hunt,"), _c('a', {
    attrs: {
      "href": "#/#foot-267",
      "id": "foot_267"
    }
  }, [_c('sup', [_vm._v("267")])]), _vm._v(" and it is a criminal offense to help an animal escape from a hunter."), _c('a', {
    attrs: {
      "href": "#/#foot-268",
      "id": "foot_268"
    }
  }, [_c('sup', [_vm._v("268")])]), _vm._v(" Florida also expressly permits the slaughter of animals for food,"), _c('a', {
    attrs: {
      "href": "#/#foot-269",
      "id": "foot_269"
    }
  }, [_c('sup', [_vm._v("269")])]), _vm._v(" the killing of unwanted pets and animals of “no commercial value,”"), _c('a', {
    attrs: {
      "href": "#/#foot-270",
      "id": "foot_270"
    }
  }, [_c('sup', [_vm._v("270")])]), _vm._v(" and the extermination of pests."), _c('a', {
    attrs: {
      "href": "#/#foot-271",
      "id": "foot_271"
    }
  }, [_c('sup', [_vm._v("271")])]), _vm._v(" Indeed, so long as one refrains from torture, it appears that one can legally kill an animal in Florida for any reason except religious sacrifice.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The City responds that all other reasons for killing animals are distinguishable, and that Santeria animal sacrifice falls into several categories that are religiously neutral: all killings of animals in a ritual or ceremony, all unnecessary killings of animals, all killings not primarily for food purposes, all killings for food purposes in a place not zoned for slaughterhouses, and so on."), _c('a', {
    attrs: {
      "href": "#/#foot-272",
      "id": "foot_272"
    }
  }, [_c('sup', [_vm._v("272")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The ordinances distinguish ritual sacrifice, which is forbidden, from ritual slaughter, which is protected."), _c('a', {
    attrs: {
      "href": "#/#foot-273",
      "id": "foot_273"
    }
  }, [_c('sup', [_vm._v("273")])]), _vm._v(" The legal difference is said to be that ritual slaughter is primarily for food, but ritual sacrifice is primarily for ritual and only secondarily for food. The factual difference is said to be that practitioners of ritual slaughter use a different knife stroke from practitioners of ritual sacrifice."), _c('a', {
    attrs: {
      "href": "#/#foot-274",
      "id": "foot_274"
    }
  }, [_c('sup', [_vm._v("274")])]), _vm._v(" The political difference is that ritual slaughter is conducted by Jews in Kosher slaughterhouses; ritual sacrifice is conducted by Santeria priests in private homes.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("A court willing to police gerrymanders, to examine motive, to examine regulation of comparable conduct and comparable harms — a court at all willing to insist that formal neutrality at least be formally neutral — can "), _c('a', {
    attrs: {
      "id": "page_135"
    }
  }, [_vm._v("readily strike these ordinances down. A court willing to defer to the political branches can readily accept one of the City’s rationalizations and uphold these ordinances. None of the other common ways of killing animals is exactly like Santeria sacrifice.")])]), _c('a', {
    attrs: {
      "id": "page_135"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Santeria was long suppressed in Cuba, and the Santeria community has adhered to its faith and practice despite generations of social and governmental hostility. It seems clear that many adherents will ignore the ordinances even if they are upheld in court. The real question is whether the anti-Santeria coalition — animal rights activists, Christian fundamentalists, and people who just seem to find animal sacrifice disgusting — will have the strength to demand vigorous and persistent enforcement. If it does, and these ordinances are upheld, there will be a full-scale persecution in South Florida.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("I have explored these examples at some length to make a point that is simple to understand but perhaps difficult to accept. Religious persecution can happen, is happening, in the United States, even in 1991. One minority’s worship service is now subject to suppression in Oregon, with the blessing of the Supreme Court. If the Hialeah ordinances are upheld, a second minority’s worship services will be subject to suppression and may be actively suppressed. If the Hare Krishna temples and monasteries are sold, a third minority’s worship services will have been suppressed. In a nation that sometimes claims to have been founded for religious liberty, it is not supposed to be that way.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec3",
    attrs: {
      "id": "sec3-23"
    }
  }, [_c('strong', [_c('em', [_vm._v("V. Conclusion")])])]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("When the Free Exercise Clause was adopted, religious pluralism in the United States consisted mostly of Protestant pluralism, and the scope of government was minimal. Today, the scope of pluralism and the scope of government are both vastly greater. The occasions on which the normal course of government restricts religious exercise have multiplied manyfold. The need for religious exemptions has multiplied in the same proportion.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The Court seems to see the number of potential requests as a threat to orderly government. But the number of potential requests is also a measure of the cumulative burden on religious exercise. The cumulative weight of government on religious minorities is sometimes crushing. The impact on government programs of exemptions for religious minorities is often quite minor, and almost never crushing. In the exceptional case, government can invoke the compelling interest test.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_135"
    }
  }, [_vm._v("I would grant most requests for exemption, because I think the text and ")]), _c('a', {
    attrs: {
      "id": "page_136"
    }
  }, [_vm._v("the purposes of the Free Exercise Clause require that government leave religion as free as can be managed in a complex urban society. Exemptions should be routine and not exceptional. The Court has taken the opposite view: it thinks judicial exemptions should be exceptional at best; it may think exemptions should not exist at all.")])]), _c('a', {
    attrs: {
      "id": "page_136"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Religious liberty is popular in the abstract, but unpopular in its concrete applications. A secular society is far too quick to decide that its interests in uniform application of the law override the needs of religious minorities, or even of the religious mainstream. Religious minorities may seem strange or obnoxious; their objections to the majority’s secular notion of what is good and right may seem wrongheaded. One function of judicial review is to protect religious exercise against such hostile or indifferent consequences of the political process. The Court has abandoned that function, at least in substantial part, and perhaps entirely.")]), _vm._v(" "), _c('p', {
    staticClass: "imagef"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/foot.jpg"
    }
  })]), _vm._v(" "), _c('h1', {
    staticClass: "foot-notes-p"
  }, [_vm._v("I am grateful to my colleagues at Texas for their helpful reactions to this paper at a faculty colloquium; to David Anderson, Joseph Dodge, L. A. Powe, Michael Sharlot, Jordan Steiker, Teresa Sullivan, and Jay Westbrook for comments on a written draft; and to David Petter for research assistance. Michael McConnell and I wrote on these issues simultaneously, exchanged drafts, and influenced each other throughout. I should disclose that I have participated as an advocate in several of the cases discussed in this article.")])]), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "id": "page_136"
    }
  }), _c('a', {
    attrs: {
      "href": "#/#foot_1",
      "id": "foot-1"
    }
  }, [_vm._v("1")]), _vm._v(". 493 U.S. 378 (1990).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_2",
      "id": "foot-2"
    }
  }, [_vm._v("2")]), _vm._v(". 494 U.S. 872 (1990).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_3",
      "id": "foot-3"
    }
  }, [_vm._v("3")]), _vm._v(". H.R. 5377 in the 101st Congress, titled the Religious Freedom Restoration Act of 1990. The bill is described in text at notes 226–27 "), _c('em', [_vm._v("infra.")])]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_4",
      "id": "foot-4"
    }
  }, [_vm._v("4")]), _vm._v(". Brief of Defendant-Appellant 34–35, in Soc’y of Jesus v. Boston Landmarks Comm’n, 564 N.E.2d 571 (Mass. 1990).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_5",
      "id": "foot-5"
    }
  }, [_vm._v("5")]), _vm._v(". Brief of Appellee in Church of the Lukumi Babalu Aye, Inc. v. City of Hialeah, No. 90–5176, in the United States Court of Appeals for the Eleventh Circuit. For the opinion below, see 723 F. Supp. 1467 (S.D. Fla. 1989).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_6",
      "id": "foot-6"
    }
  }, [_vm._v("6")]), _vm._v(". Cornerstone Bible Church v. City of Hastings, 740 F. Supp. 654, 663 (D. Minn. 1990).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_7",
      "id": "foot-7"
    }
  }, [_vm._v("7")]), _vm._v(". "), _c('em', [_vm._v("Cf.")]), _vm._v(" Dignity Twin Cities v. Newman Center & Chapel, No. 87204-RE-9 (Minneapolis Comm’n on Civil Rights 1990) (Catholic student center must allocate office and meeting space, but not the use of its chapel, without regard to sexual orientation; impact of "), _c('em', [_vm._v("Smith")]), _vm._v(" not considered); Gay Rights Coalition v. Georgetown Univ., 536 A.2d 1 (D.C. App. 1987) (Jesuit university must provide services and facilities to student organizations, but not official recognition as university groups, without regard to sexual orientation); Walker v. First Presbyterian Church, 22 Fair Empl. Prac. 762 (Cal. Super. Ct. 1980) (upholding church’s right to discharge homosexual organist).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_8",
      "id": "foot-8"
    }
  }, [_vm._v("8")]), _vm._v(". Michael W. McConnell, "), _c('em', [_vm._v("The Origins and Historical Understanding of Free Exercise of Religion,")]), _vm._v(" 103 Harv. L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 1409, 1466–73 (1990).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_9",
      "id": "foot-9"
    }
  }, [_vm._v("9")]), _vm._v(". "), _c('em', [_vm._v("Smith,")]), _vm._v(" 494 U.S. at 895–901 (O’Connor, J., dissenting); Douglas Laycock, "), _c('em', [_vm._v("The Supreme Court’s Assault on Free Exercise and the Amicus Brief That Was Never Filed,")]), _vm._v(" 8 J.L. & R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ELIGION")]), _vm._v(" 99 (1990); Michael W. McConnell, "), _c('em', [_vm._v("Free Exercise Revisionism and the Smith Decision,")]), _vm._v(" 57 U. C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HI.")]), _vm._v(" L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 1109 (1990); "), _c('em', [_vm._v("The Supreme Court 1989 Term,")]), _vm._v(" 104 H"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ARV.")]), _vm._v(" L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 129, 204–05 (1990).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_10",
      "id": "foot-10"
    }
  }, [_vm._v("10")]), _vm._v(". Texas Monthly, Inc. v. Bullock, 489 U.S. 1, 38 (1989) (Scalia, J., dissenting) (emphasis in original) (citations omitted).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_11",
      "id": "foot-11"
    }
  }, [_vm._v("11")]), _vm._v(". "), _c('em', [_vm._v("Smith,")]), _vm._v(" 494 U.S. at 878–79.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_12",
      "id": "foot-12"
    }
  }, [_vm._v("12")]), _vm._v(". "), _c('em', [_vm._v("Id.")]), _vm._v(" at 893 (O’Connor, J., dissenting); McConnell, "), _c('a', {
    attrs: {
      "href": "#/017_Chapter02c#foot-9"
    }
  }, [_vm._v("note 9")]), _vm._v(" "), _c('em', [_vm._v("supra,")]), _vm._v(" at 1114–16; Laycock, "), _c('a', {
    attrs: {
      "href": "#/017_Chapter02c#foot-9"
    }
  }, [_vm._v("note 9")]), _vm._v(" "), _c('em', [_vm._v("supra,")]), _vm._v(" at 103 (text at notes 13–14).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_13",
      "id": "foot-13"
    }
  }, [_vm._v("13")]), _vm._v(". 494 U.S. at 877.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_14",
      "id": "foot-14"
    }
  }, [_vm._v("14")]), _vm._v(". "), _c('em', [_vm._v("Id.")]), _vm._v(" at 884.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_15",
      "id": "foot-15"
    }
  }, [_vm._v("15")]), _vm._v(". "), _c('em', [_vm._v("Id.")]), _vm._v(" at 878.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_16",
      "id": "foot-16"
    }
  }, [_vm._v("16")]), _vm._v(". William P. Marshall, "), _c('em', [_vm._v("The Case Against the Constitutionally Compelled Free Exercise Exemption,")]), _vm._v(" 40 C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ASE")]), _vm._v(" W"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ESTERN")]), _vm._v(" L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 357 (1989–90); Mark Tushnet, "), _c('em', [_vm._v("“Of Church and State and the Supreme Court”: Kurland Revisited,")]), _vm._v(" 1989 S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("UP.")]), _vm._v(" C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("T.")]), _vm._v(" R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 373; Ellis West, "), _c('em', [_vm._v("The Case Against a Right to Religion-based Exemptions,")]), _vm._v(" 4 N"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OTRE")]), _vm._v(" D"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AME")]), _vm._v(" J.L. E"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("THICS")]), _vm._v(", & P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("UB.")]), _vm._v(" P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OL’Y")]), _vm._v(" 591(1990).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_17",
      "id": "foot-17"
    }
  }, [_vm._v("17")]), _vm._v(". "), _c('em', [_vm._v("See also")]), _vm._v(" Douglas Laycock, "), _c('em', [_vm._v("Formal, Substantive, and Disaggregated Neutrality Toward Religion,")]), _vm._v(" 39 D"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EPAUL")]), _vm._v(" L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 993 (1990).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_18",
      "id": "foot-18"
    }
  }, [_vm._v("18")]), _vm._v(". "), _c('em', [_vm._v("Compare")]), _vm._v(" Nat’l Geographic v. Cal. Equalization Bd., 430 U.S. 551, 556 (1977) (mail order seller must collect use tax on sales to California, where seller maintains two offices in California), "), _c('em', [_vm._v("with")]), _vm._v(" Nat’l Bellas Hess, Inc. v. Illinois Revenue Dept., 386 U.S. 753, 756–60 (1967) (mail order seller cannot be required to collect use tax on sales to Illinois, where seller has no offices, property, or agents in Illinois).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_19",
      "id": "foot-19"
    }
  }, [_vm._v("19")]), _vm._v(". Calder v. Jones, 465 U.S. 783, 790–91 (1984); Keeton v. Hustler Magazine, Inc., 465 U.S. 770, 780 n.12 (1984). These cases are suggestive, but they do not control Swaggart’s claim. In "), _c('em', [_vm._v("Calder")]), _vm._v(" and "), _c('em', [_vm._v("Keeton,")]), _vm._v(" publication in the state conferred jurisdiction to decide a dispute that could have been decided elsewhere. In "), _c('em', [_vm._v("Swaggart,")]), _vm._v(" the crusades conferred jurisdiction to impose a substantive obligation to collect and remit tax, an obligation that could not otherwise be imposed at all by any governmental unit. Indeed, the Court in "), _c('em', [_vm._v("Calder")]), _vm._v(" distinguished substantive protections from procedural rules. "), _c('em', [_vm._v("See")]), _vm._v(" 465 U.S. at 790–91.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_20",
      "id": "foot-20"
    }
  }, [_vm._v("20")]), _vm._v(". "), _c('em', [_vm._v("Swaggart,")]), _vm._v(" 493 U.S. at 382.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_21",
      "id": "foot-21"
    }
  }, [_vm._v("21")]), _vm._v(". "), _c('em', [_vm._v("Id.")]), _vm._v(" at 396–97.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_22",
      "id": "foot-22"
    }
  }, [_vm._v("22")]), _vm._v(". 319 U.S. 105 (1943).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_23",
      "id": "foot-23"
    }
  }, [_vm._v("23")]), _vm._v(". 321 U.S. 573 (1944).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_24",
      "id": "foot-24"
    }
  }, [_vm._v("24")]), _vm._v(". "), _c('em', [_vm._v("Murdock,")]), _vm._v(" 319 U.S. at 111.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_25",
      "id": "foot-25"
    }
  }, [_vm._v("25")]), _vm._v(". "), _c('em', [_vm._v("Swaggart,")]), _vm._v(" 493 U.S. at 382.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_26",
      "id": "foot-26"
    }
  }, [_vm._v("26")]), _vm._v(". Texas Monthly, Inc. v. Bullock, 489 U.S. 1, 21–25 (1989) (plurality opinion).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_27",
      "id": "foot-27"
    }
  }, [_vm._v("27")]), _vm._v(". "), _c('em', [_vm._v("Id.")]), _vm._v(" at 41 (Scalia, J., dissenting).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_28",
      "id": "foot-28"
    }
  }, [_vm._v("28")]), _vm._v(". "), _c('em', [_vm._v("Swaggart,")]), _vm._v(" 493 U.S. at 389.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_29",
      "id": "foot-29"
    }
  }, [_vm._v("29")]), _vm._v(". "), _c('em', [_vm._v("Id.")])]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_30",
      "id": "foot-30"
    }
  }, [_vm._v("30")]), _vm._v(". "), _c('em', [_vm._v("Murdock,")]), _vm._v(" 319 U.S. at 112–15.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_31",
      "id": "foot-31"
    }
  }, [_vm._v("31")]), _vm._v(". "), _c('em', [_vm._v("Id.")]), _vm._v(" at 115.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_32",
      "id": "foot-32"
    }
  }, [_vm._v("32")]), _vm._v(". "), _c('em', [_vm._v("See")]), _vm._v(" Frazee v. Illinois Dept. of Employment Security, 489 U.S. 829 (1989); Hobbie v. Unemployment Appeals Comm’n, 480 U.S. 136 (1987); Thomas v. Review Bd., 450 U.S. 707 (1981); Sherbert v. Verner, 374 U.S. 398 (1963) (all holding that Free Exercise Clause forbids states to deny unemployment compensation to employees who lose their job because of conflict between job and religious practice).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_33",
      "id": "foot-33"
    }
  }, [_vm._v("33")]), _vm._v(". E"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("DWARD")]), _vm._v(" F. A"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("NDERSON,")]), _vm._v(" P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EYOTE")]), _vm._v(": T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HE")]), _vm._v(" D"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("IVINE")]), _vm._v(" C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ACTUS")]), _vm._v(" 161 (1980); J"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AMES")]), _vm._v(" S. S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("LOTKIN")]), _vm._v(", T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HE")]), _vm._v(" P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EYOTE")]), _vm._v(" W"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AY")]), _vm._v(" 98 (1956).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_34",
      "id": "foot-34"
    }
  }, [_vm._v("34")]), _vm._v(". R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OBERT")]), _vm._v(" M. J"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ULIEN")]), _vm._v(", A P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("RIMER OF")]), _vm._v(" D"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("RUG")]), _vm._v(" A"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CTION")]), _vm._v(" 152 (4th ed. 1985); Bergman, "), _c('em', [_vm._v("Navajo Peyote Use: Its Apparent Safety,")]), _vm._v(" 128 A"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("M.")]), _vm._v(" J. P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("SYCH")]), _vm._v(". 695 (1971).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_35",
      "id": "foot-35"
    }
  }, [_vm._v("35")]), _vm._v(". Bergman, "), _c('a', {
    attrs: {
      "href": "#/017_Chapter02c#foot-34"
    }
  }, [_vm._v("note 34")]), _vm._v(" "), _c('em', [_vm._v("supra,")]), _vm._v(" at 697 (describing five possible cases in author’s clinical experience, crudely estimating one bad reaction in 70,000 ingestions, and describing that as “probably overestimating”).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_36",
      "id": "foot-36"
    }
  }, [_vm._v("36")]), _vm._v(". For accounts by anthropologists, see W"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ESTON")]), _vm._v(" L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("A")]), _vm._v(" B"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ARRE")]), _vm._v(", T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HE")]), _vm._v(" P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EYOTE")]), _vm._v(" C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ULT")]), _vm._v(" (rev. ed. 1964); S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("LOTKIN")]), _vm._v(", "), _c('a', {
    attrs: {
      "href": "#/017_Chapter02c#foot-33"
    }
  }, [_vm._v("note 33")]), _vm._v(" "), _c('em', [_vm._v("supra.")])]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_37",
      "id": "foot-37"
    }
  }, [_vm._v("37")]), _vm._v(". For descriptions of the meeting, see People v. Woody, 394 P.2d 813, 817 (Cal. 1964); Bergman, "), _c('a', {
    attrs: {
      "href": "#/017_Chapter02c#foot-34"
    }
  }, [_vm._v("note 34")]), _vm._v(" "), _c('em', [_vm._v("supra,")]), _vm._v(" at 695–96.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_38",
      "id": "foot-38"
    }
  }, [_vm._v("38")]), _vm._v(". 21 C.F.R. § 1307.31 (1990). The state exemptions are collected in "), _c('em', [_vm._v("Smith v. Employment Div.,")]), _vm._v(" 763 P.2d 146, 148 n.2 (Or. 1988).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_39",
      "id": "foot-39"
    }
  }, [_vm._v("39")]), _vm._v(". Bergman, "), _c('a', {
    attrs: {
      "href": "#/017_Chapter02c#foot-34"
    }
  }, [_vm._v("note 34")]), _vm._v(" "), _c('em', [_vm._v("supra,")]), _vm._v(" at 698; Pascarosa & Futterman, "), _c('em', [_vm._v("Ethnopsychedelic Therapy for Alcoholics: Observations in the Peyote Ritual of the Native American Church,")]), _vm._v(" 8 J. P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("SYCHEDELIC DRUGS")]), _vm._v(" 215 (1976).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_40",
      "id": "foot-40"
    }
  }, [_vm._v("40")]), _vm._v(". Reply Brief for Petitioners 11–14, in "), _c('em', [_vm._v("Smith.")])]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_41",
      "id": "foot-41"
    }
  }, [_vm._v("41")]), _vm._v(". Employment Div. v. Smith, 485 U.S. 660, 672 (1988).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_42",
      "id": "foot-42"
    }
  }, [_vm._v("42")]), _vm._v(". "), _c('em', [_vm._v("Smith,")]), _vm._v(" 494 U.S. at 878–79, quoting United States v. Lee, 455 U.S. 252, 263 n.3 (1982) (Stevens, J., concurring)")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_43",
      "id": "foot-43"
    }
  }, [_vm._v("43")]), _vm._v(". "), _c('em', [_vm._v("Smith,")]), _vm._v(" 494 U.S. at 877.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_44",
      "id": "foot-44"
    }
  }, [_vm._v("44")]), _vm._v(". "), _c('em', [_vm._v("Id.")]), _vm._v(" at 881–82.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_45",
      "id": "foot-45"
    }
  }, [_vm._v("45")]), _vm._v(". 406 U.S. 205 (1972).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_46",
      "id": "foot-46"
    }
  }, [_vm._v("46")]), _vm._v(". "), _c('em', [_vm._v("Smith,")]), _vm._v(" 494 U.S. at 884. This proviso is considered in text at notes 199–209 "), _c('em', [_vm._v("infra.")])]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_47",
      "id": "foot-47"
    }
  }, [_vm._v("47")]), _vm._v(". "), _c('em', [_vm._v("Smith,")]), _vm._v(" 494 U.S. at 887 n.4.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_48",
      "id": "foot-48"
    }
  }, [_vm._v("48")]), _vm._v(". "), _c('em', [_vm._v("Id.")]), _vm._v(" at 886–90.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_49",
      "id": "foot-49"
    }
  }, [_vm._v("49")]), _vm._v(". 443 U.S. 595 (1979)")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_50",
      "id": "foot-50"
    }
  }, [_vm._v("50")]), _vm._v(". For the earlier rule, see Serbian E. Orthodox Diocese v. Milivojevich, 426 U.S. 696 (1976); Kreshik v. Saint Nicholas Cathedral, 363 U.S. 190 (1960) (per curiam); Kedroff v. Saint Nicholas Cathedral, 344 U.S. 94 (1952); Watson v. Jones, 80 U.S. (13 Wall.) 679 (1871) (federal common law).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_51",
      "id": "foot-51"
    }
  }, [_vm._v("51")]), _vm._v(". "), _c('em', [_vm._v("Cf.")]), _vm._v(" Goldman v. Weinberger, 475 U.S. 503 (1986) (Air Force officer disciplined for wearing yarmulke). The result in "), _c('em', [_vm._v("Goldman")]), _vm._v(" was changed by statute. 10 U.S.C. § 774 (1988).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_52",
      "id": "foot-52"
    }
  }, [_vm._v("52")]), _vm._v(". Laycock, "), _c('a', {
    attrs: {
      "href": "#/017_Chapter02c#foot-17"
    }
  }, [_vm._v("note 17")]), _vm._v(" "), _c('em', [_vm._v("supra,")]), _vm._v(" at 999 (text at note 21).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_53",
      "id": "foot-53"
    }
  }, [_vm._v("53")]), _vm._v(". "), _c('em', [_vm._v("Smith,")]), _vm._v(" 494 U.S. at 890; Corporation of the Presiding Bishop v. Amos, 483 U.S. 327 (1987).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_54",
      "id": "foot-54"
    }
  }, [_vm._v("54")]), _vm._v(". Jones v. Wolf, 443 U.S. 595, 602 (1979). If the religious dispute involves an issue of theology or religious doctrine, the secular court must defer to religious authority, a form of required exemption that apparently survives "), _c('em', [_vm._v("Smith. See")]), _vm._v(" 494 U.S. at 877.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_55",
      "id": "foot-55"
    }
  }, [_vm._v("55")]), _vm._v(". Texas Monthly, Inc. v. Bullock, 489 U.S. 1 (1989).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_56",
      "id": "foot-56"
    }
  }, [_vm._v("56")]), _vm._v(". "), _c('em', [_vm._v("See")]), _vm._v(" Walz v. Tax Comm’n, 397 U.S. 664 (1970) (upholding property tax exemptions for “religious, educational, and charitable” organizations).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_57",
      "id": "foot-57"
    }
  }, [_vm._v("57")]), _vm._v(". "), _c('em', [_vm._v("Smith,")]), _vm._v(" 494 U.S. at 890.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_58",
      "id": "foot-58"
    }
  }, [_vm._v("58")]), _vm._v(". "), _c('em', [_vm._v("Swaggart,")]), _vm._v(" 493 U.S. at 394.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_59",
      "id": "foot-59"
    }
  }, [_vm._v("59")]), _vm._v(". "), _c('em', [_vm._v("Smith,")]), _vm._v(" 494 U.S. at 886.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_60",
      "id": "foot-60"
    }
  }, [_vm._v("60")]), _vm._v(". "), _c('em', [_vm._v("Id.")]), _vm._v(" at 891–905 (O’Connor, J., concurring, joined by Brennan, J., Marshall, J., and Blackmun, J.). Each of these justices joined Justice O’Connor’s unanimous opinion in "), _c('em', [_vm._v("Swaggart.")])]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_61",
      "id": "foot-61"
    }
  }, [_vm._v("61")]), _vm._v(". "), _c('em', [_vm._v("See")]), _vm._v(" Aguilar v. Felton, 473 U.S. 402 (1985) (invalidating federal funding of remedial education for low-income children in public and private schools, as applied to instruction provided on premises of religiously affiliated schools); Sch. Dist. v. Ball, 473 U.S. 373 (1985) (invalidating remedial and enrichment courses taught by public school teachers in religiously affiliated schools, although same courses were taught in public schools); "), _c('em', [_vm._v("but see")]), _vm._v(" Bowen v. Kendrick, 487 U.S. 589 (1988) (relying on formal neutrality to uphold grants to religiously affiliated organizations); Mueller v. Allen, 463 U.S. 388 (1983) (relying on formal neutrality to uphold tax deductions for payments to religious schools).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_62",
      "id": "foot-62"
    }
  }, [_vm._v("62")]), _vm._v(". "), _c('em', [_vm._v("Swaggart,")]), _vm._v(" 493 U.S. at 391. This point is elaborated in Laycock, "), _c('a', {
    attrs: {
      "href": "#/017_Chapter02c#foot-17"
    }
  }, [_vm._v("note 17")]), _vm._v(" "), _c('em', [_vm._v("supra,")]), _vm._v(" at 1009–10 (text at notes 56–64).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_63",
      "id": "foot-63"
    }
  }, [_vm._v("63")]), _vm._v(". On the distinction, see Kenneth W. Simons, "), _c('em', [_vm._v("Equality as a Comparative Right,")]), _vm._v(" 65 B.U.L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 387 (1985).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_64",
      "id": "foot-64"
    }
  }, [_vm._v("64")]), _vm._v(". Goldman v. Weinberger, 475 U.S. 503, 512–13 (1986) (Stevens, J., concurring); United States v. Lee, 455 U.S. 252, 263 (1982) (Stevens, J., concurring).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_65",
      "id": "foot-65"
    }
  }, [_vm._v("65")]), _vm._v(". Tushnet, "), _c('a', {
    attrs: {
      "href": "#/017_Chapter02c#foot-16"
    }
  }, [_vm._v("note 16")]), _vm._v(" "), _c('em', [_vm._v("supra,")]), _vm._v(" at 381.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_66",
      "id": "foot-66"
    }
  }, [_vm._v("66")]), _vm._v(". "), _c('em', [_vm._v("See")]), _vm._v(" Larson v. Valente, 456 U.S. 228 (1982) (invoking Establishment Clause to protect Unification Church from discriminatory regulation); United States v. Ballard, 322 U.S. 78 (1944) (holding that jury in prosecution for mail fraud could not determine truth or falsity of religious beliefs of the I Am movement). In Bowen v. Roy, 476 U.S. 693 (1986), there were five votes for the proposition that, if the case survived a mootness challenge, the government could not require Native Americans to use social security numbers in violation of their religious beliefs. "), _c('em', [_vm._v("Id.")]), _vm._v(" at 715–16 (Blackmun, J., concurring); "), _c('em', [_vm._v("id.")]), _vm._v(" at 726–33 (O’Connor, J., joined by Brennan, J. & Marshall, J., concurring); "), _c('em', [_vm._v("id.")]), _vm._v(" at 733 (White, J., dissenting). For illustrative cases in the lower courts, see Benjamin v. Coughlin, 905 F.2d 571 (2d Cir. 1990) (invalidating prison rule requiring Rastafarians to cut their hair); Islamic Center, Inc. v. City of Starkville, 840 F.2d 293 (5th Cir. 1988) (protecting Islamic student center from discriminatory zoning decisions); Kahane v. Carlson, 527 F.2d 492 (2d Cir. 1975) (requiring prison to provide Kosher food for observant Jewish prisoners). Most cases striking down government-sponsored religious observances and displays have struck down Christian observances and displays. Most notably, see County of Allegheny v. American Civil Liberties Union Greater Pittsburgh Chapter, 492 U.S. 573 (1989) (striking down Christian creche but permitting Jewish menorah).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_67",
      "id": "foot-67"
    }
  }, [_vm._v("67")]), _vm._v(". Stephen L. Pepper, "), _c('em', [_vm._v("Taking the Free Exercise Clause Seriously,")]), _vm._v(" 1986 B"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("YU")]), _vm._v(" L. Rev. 299, 312–16; Marc Galanter, "), _c('em', [_vm._v("Religious Freedoms in the United States: A Turning Point?")]), _vm._v(" 1966 W"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("IS.")]), _vm._v(" L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 217, 291.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_68",
      "id": "foot-68"
    }
  }, [_vm._v("68")]), _vm._v(". "), _c('em', [_vm._v("Smith,")]), _vm._v(" 494 U.S. at 918 (Blackmun, J., dissenting).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_69",
      "id": "foot-69"
    }
  }, [_vm._v("69")]), _vm._v(". For historical accounts of these debates, see T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HOMAS")]), _vm._v(" C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("URRY")]), _vm._v(", T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HE")]), _vm._v(" F"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("IRST")]), _vm._v(" F"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("REEDOMS")]), _vm._v(": C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HURCH AND")]), _vm._v(" S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("TATE IN")]), _vm._v(" A"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("MERICA TO THE")]), _vm._v(" P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ASSAGE OF THE")]), _vm._v(" F"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("IRST")]), _vm._v(" A"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("MENDMENT")]), _vm._v(" (1986); T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HOMAS")]), _vm._v(" E. B"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("UCKLEY,")]), _vm._v(" C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HURCH AND")]), _vm._v(" S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("TATE IN")]), _vm._v(" R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EVOLUTIONARY")]), _vm._v(" V"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("IRGINIA")]), _vm._v(", 1776–1787 (1977). For legal analyses of these debates, see McConnell, "), _c('a', {
    attrs: {
      "href": "#/017_Chapter02c#foot-8"
    }
  }, [_vm._v("note 8")]), _vm._v(" "), _c('em', [_vm._v("supra;")]), _vm._v(" Douglas Laycock, "), _c('em', [_vm._v("“Nonpreferential” Aid to Religion: A False Claim about Original Intent,")]), _vm._v(" 27 W"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("M.")]), _vm._v(" & M"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ARY")]), _vm._v(" L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 875 (1986); Steven D. Smith, "), _c('em', [_vm._v("Separation and the “Secular”: Reconstructing the Disestablishment Doctrine,")]), _vm._v(" 67 T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EX.")]), _vm._v(" L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 955 (1989). I briefly consider the source of my disagreement with Steven Smith in Douglas Laycock, "), _c('em', [_vm._v("Original Intent and the Constitution Today,")]), _vm._v(" in "), _c('em', [_vm._v("The First Freedom: Religion and the Bill of Rights")]), _vm._v(" 87, 92–93, 103–04 (James E. Wood, ed., 1990) (text at notes 19–20, 46–47).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_70",
      "id": "foot-70"
    }
  }, [_vm._v("70")]), _vm._v(". Laycock, "), _c('a', {
    attrs: {
      "href": "#/017_Chapter02c#foot-17"
    }
  }, [_vm._v("note 17")]), _vm._v(" "), _c('em', [_vm._v("supra,")]), _vm._v(" at 1001 (text at note 27).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_71",
      "id": "foot-71"
    }
  }, [_vm._v("71")]), _vm._v(". For an economic version of this argument, see Michael W. McConnell & Richard A. Posner, "), _c('em', [_vm._v("An Economic Approach to Issues of Religious Freedom,")]), _vm._v(" 56 U. C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HI")]), _vm._v(". L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 1, 32–54 (1989).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_72",
      "id": "foot-72"
    }
  }, [_vm._v("72")]), _vm._v(". For further analysis, see Laycock, "), _c('a', {
    attrs: {
      "href": "#/017_Chapter02c#foot-17"
    }
  }, [_vm._v("note 17")]), _vm._v(" "), _c('em', [_vm._v("supra,")]), _vm._v(" at 1017–18 (text at notes 95–100).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_73",
      "id": "foot-73"
    }
  }, [_vm._v("73")]), _vm._v(". "), _c('em', [_vm._v("Smith,")]), _vm._v(" 494 U.S. at 886 n.3.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_74",
      "id": "foot-74"
    }
  }, [_vm._v("74")]), _vm._v(". Washington v. Davis, 426 U.S. 229 (1976). Similarly, a law that merely has a disproportionate impact on religious minorities raised no special issue under the Free Exercise Clause even before "), _c('em', [_vm._v("Smith. See")]), _vm._v(" Braunfeld v. Brown, 366 U.S. 599, 606 (1961).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_75",
      "id": "foot-75"
    }
  }, [_vm._v("75")]), _vm._v(". "), _c('em', [_vm._v("See, e.g.,")]), _vm._v(" Gale Binion, "), _c('em', [_vm._v("Intent and Equal Protection: A Reconsideration,")]), _vm._v(" 1983 S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("UP.")]), _vm._v(" C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("T.")]), _vm._v(" R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 397; Theodore Eisenberg, "), _c('em', [_vm._v("Disproportionate Impact and Illicit Motive: Theories of Constitutional Adjudication,")]), _vm._v(" 52 N"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("YU")]), _vm._v(" L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 36 (1977); Michael J. Perry, "), _c('em', [_vm._v("The Disproportionate Impact Theory of Racial Discrimination,")]), _vm._v(" 125 U. P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("A.")]), _vm._v(" L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 540 (1977). For comparisons of equal protection and the religion clauses, see Binion at 418–19; Eisenberg at 156–68.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_76",
      "id": "foot-76"
    }
  }, [_vm._v("76")]), _vm._v(". "), _c('em', [_vm._v("Smith,")]), _vm._v(" 494 U.S. at 886 n.3, citing Citizen Publishing Co. v. United States, 394 U.S. 131, 139 (1969). "), _c('em', [_vm._v("See also Smith,")]), _vm._v(" 494 U.S. at 878, citing Minneapolis Star & Tribune Co. v. Minnesota Comm’r of Revenue, 460 U.S. 575 (1983). "), _c('em', [_vm._v("Citizen Publishing")]), _vm._v(" and "), _c('em', [_vm._v("Minneapolis Star,")]), _vm._v(" respectively, upheld the application of facially neutral antitrust and tax laws to commercial media corporations. The commercial context is surely relevant to the holdings.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_77",
      "id": "foot-77"
    }
  }, [_vm._v("77")]), _vm._v(". NAACP v. Alabama, 357 U.S. 449 (1958). "), _c('em', [_vm._v("See also")]), _vm._v(" Brown v. Socialist Workers ’74 Campaign Comm. (Ohio), 459 U.S. 87 (1982); Geoffrey Stone & William P. Marshall, "), _c('em', [_vm._v("Brown v. Socialist Workers: Inequality as a Command of the First Amendment,")]), _vm._v(" 1983 S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("UP.")]), _vm._v(" C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("T.")]), _vm._v(" R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 583.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_78",
      "id": "foot-78"
    }
  }, [_vm._v("78")]), _vm._v(". 468 U.S. 609 (1984).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_79",
      "id": "foot-79"
    }
  }, [_vm._v("79")]), _vm._v(". "), _c('em', [_vm._v("Id.")]), _vm._v(" at 623–24.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_80",
      "id": "foot-80"
    }
  }, [_vm._v("80")]), _vm._v(". 485 U.S. 46 (1988).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_81",
      "id": "foot-81"
    }
  }, [_vm._v("81")]), _vm._v(". "), _c('em', [_vm._v("See Restatement (Second) of Torts")]), _vm._v(" § 46 (1965) (“One who by extreme and outrageous conduct intentionally or recklessly causes severe emotional distress to another” is liable for damages); Growth Properties I v. Cannon, 669 S.W.2d 447 (Ark. 1984) (building temporary access road for heavy equipment over graves); Great Atl. & Pac. Tea Co. v. Roch, 153 A. 22 (Md. 1930) (delivering dead rat in a bread wrapper).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_82",
      "id": "foot-82"
    }
  }, [_vm._v("82")]), _vm._v(". For illustrations, see W. P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AGE")]), _vm._v(" K"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EETON,")]), _vm._v(" D"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AN")]), _vm._v(" B. D"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OBBS,")]), _vm._v(" R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OBERT")]), _vm._v(" K"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EETON,")]), _vm._v(" & D"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AVID")]), _vm._v(" G. O"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("WEN,")]), _vm._v(" P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ROSSER AND")]), _vm._v(" K"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EETON ON THE")]), _vm._v(" L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AW OF")]), _vm._v(" T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ORTS")]), _vm._v(" § 12 at 57–66 (5th ed. 1984 and Supp. 1988).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_83",
      "id": "foot-83"
    }
  }, [_vm._v("83")]), _vm._v(". 376 U.S. 254 (1964).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_84",
      "id": "foot-84"
    }
  }, [_vm._v("84")]), _vm._v(". 308 U.S. 147 (1939).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_85",
      "id": "foot-85"
    }
  }, [_vm._v("85")]), _vm._v(". 310 U.S. 296 (1940).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_86",
      "id": "foot-86"
    }
  }, [_vm._v("86")]), _vm._v(". "), _c('em', [_vm._v("Smith,")]), _vm._v(" 494 U.S. at 881.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_87",
      "id": "foot-87"
    }
  }, [_vm._v("87")]), _vm._v(". "), _c('em', [_vm._v("See")]), _vm._v(" United States v. Eichman, 496 U.S. 310 (1990); Texas v. Johnson, 491 U.S. 397 (1989).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_88",
      "id": "foot-88"
    }
  }, [_vm._v("88")]), _vm._v(". United States v. O’Brien, 391 U.S. 367 (1968).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_89",
      "id": "foot-89"
    }
  }, [_vm._v("89")]), _vm._v(". "), _c('em', [_vm._v("See, e.g.,")]), _vm._v(" United States v. Kokinda, 497 U.S. 720 (1990) (upholding ban on solicitation on sidewalk leading to post office); Ward v. Rock Against Racism, 491 U.S. 781, 791, 799 (1989) (requiring only that law not be motivated by hostility to message, that it serve a “substantial government interest that would be achieved less effectively absent the regulation,” and that it leave open ample alternative means of communication); Frisby v. Schultz, 487 U.S. 474 (1988) (upholding ban on picketing a single residence); Boos v. Barry, 485 U.S. 312 (1988) (upholding ban on congregating within five hundred feet of a foreign embassy); Los Angeles City Council v. Taxpayers for Vincent, 466 U.S. 789 (1984) (upholding ban on placing signs on utility poles); Heffron v. Int’l Soc’y for Krishna Consciousness, 452 U.S. 640 (1981) (upholding rule confining all solicitation at state fair to booths).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_90",
      "id": "foot-90"
    }
  }, [_vm._v("90")]), _vm._v(". "), _c('em', [_vm._v("Cf.")]), _vm._v(" Geoffrey Stone, "), _c('em', [_vm._v("Constitutionally Compelled Exemptions and the Free Exercise Clause,")]), _vm._v(" 27 W"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("M.")]), _vm._v(" & M"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ARY")]), _vm._v(" L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 985, 990–93 (1986).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_91",
      "id": "foot-91"
    }
  }, [_vm._v("91")]), _vm._v(". For further analysis and additional cases, see Geoffrey Stone, "), _c('em', [_vm._v("Content Neutral Restrictions,")]), _vm._v(" 54 U. C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HI.")]), _vm._v(" L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 46, 105–14 (1987). The Court has agreed to review two recent decisions protecting expressive activity from formally neutral laws. Cohen v. Cowles Media Co., 457 N.W.2d 199 (Minn. 1990) (rejecting claims of fraud, breach of contract, and promissory estoppel for newspaper’s breach of reporter’s promise to conceal identity of source), ["), _c('em', [_vm._v("rev’d,")]), _vm._v(" 501 U.S. 663 (1991)]; Miller v. Civil City of South Bend, 904 F.2d 1081 (7th Cir. 1990) (refusing to apply public indecency law to nude dancing offered as entertainment), ["), _c('em', [_vm._v("rev’d as")]), _vm._v(" Barnes v. Glen Theatre Inc., 501 U.S. 560 (1991). The Supreme Court decisions in "), _c('em', [_vm._v("Cowles Media")]), _vm._v(" and "), _c('em', [_vm._v("Glen Theatre")]), _vm._v(" were released after this article went to press. The decision in "), _c('em', [_vm._v("Cowles Media")]), _vm._v(" was based on the theory that the law enforcing contractual promises was a law of general applicability, so that the state need not justify the resulting burden on free speech. The decision in "), _c('em', [_vm._v("Glen Theatre")]), _vm._v(" was based on the quite different theory that the state had sufficiently justified the burden on free speech of suppressing nude dancing. Justice Scalia filed a separate opinion, arguing that the decision should have been based on the theory that the law against public nudity was generally applicable, so that no justification was required.]")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_92",
      "id": "foot-92"
    }
  }, [_vm._v("92")]), _vm._v(". "), _c('em', [_vm._v("Smith,")]), _vm._v(" 494 U.S. at 877.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_93",
      "id": "foot-93"
    }
  }, [_vm._v("93")]), _vm._v(". See text at notes 182–85 "), _c('em', [_vm._v("infra.")])]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_94",
      "id": "foot-94"
    }
  }, [_vm._v("94")]), _vm._v(". "), _c('em', [_vm._v("Smith,")]), _vm._v(" 494 U.S. at 877.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_95",
      "id": "foot-95"
    }
  }, [_vm._v("95")]), _vm._v(". "), _c('em', [_vm._v("Id.")])]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_96",
      "id": "foot-96"
    }
  }, [_vm._v("96")]), _vm._v(". C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HRISTOPHER")]), _vm._v(" H"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ILL")]), _vm._v(", G"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OD")]), _vm._v("’"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("S")]), _vm._v(" E"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("NGLISHMAN")]), _vm._v(" 121 (1970).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_97",
      "id": "foot-97"
    }
  }, [_vm._v("97")]), _vm._v(". See text at notes 210–12 "), _c('em', [_vm._v("infra.")])]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_98",
      "id": "foot-98"
    }
  }, [_vm._v("98")]), _vm._v(". "), _c('em', [_vm._v("See")]), _vm._v(" Douglas Laycock, "), _c('em', [_vm._v("Text, Intent, and the Religious Clauses,")]), _vm._v(" 4 N"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OTRE")]), _vm._v(" D"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AME")]), _vm._v(" J.L. E"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("THICS")]), _vm._v(" & P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("UB")]), _vm._v(". P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OL")]), _vm._v("’"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("Y")]), _vm._v(" 683, 691–93 (1990) (text at notes 19–24).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_99",
      "id": "foot-99"
    }
  }, [_vm._v("99")]), _vm._v(". See text at notes 228–74 "), _c('em', [_vm._v("infra.")])]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_100",
      "id": "foot-100"
    }
  }, [_vm._v("100")]), _vm._v(". I distinguish between these kinds of claims in Douglas Laycock, "), _c('em', [_vm._v("Towards a General Theory of the Religion Clauses: The Case of Church Labor Relations and the Right to Church Autonomy,")]), _vm._v(" 81 C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OLUM.")]), _vm._v(" L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 1373, 1388–90 (1981) (text at notes 133–40).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_101",
      "id": "foot-101"
    }
  }, [_vm._v("101")]), _vm._v(". "), _c('em', [_vm._v("Swaggart,")]), _vm._v(" 493 U.S. at 392.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_102",
      "id": "foot-102"
    }
  }, [_vm._v("102")]), _vm._v(". "), _c('em', [_vm._v("Id.")]), _vm._v(" at 391–92.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_103",
      "id": "foot-103"
    }
  }, [_vm._v("103")]), _vm._v(". The Boston Landmarks Commission cited "), _c('em', [_vm._v("Swaggart")]), _vm._v(" for the proposition that state control of the location of altars is of no First Amendment significance unless a church’s specific religious beliefs forbid it to put the altar where the state wants it. Brief of Defendant-Appellant 28, 36–37, in Soc’y of Jesus v. Boston Landmarks Comm’n, 564 N.E.2d 571 (Mass. 1990) (decided for church on state constitutional grounds). "), _c('em', [_vm._v("See also")]), _vm._v(" Rector of St. Bartholomew’s Church v. City of New York, 914 F.2d 348, 355 (2d Cir. 1990) (citing "), _c('em', [_vm._v("Swaggart")]), _vm._v(" for proposition that regulatory burdens on churches, without more, are of no constitutional significance).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_104",
      "id": "foot-104"
    }
  }, [_vm._v("104")]), _vm._v(". Brandon v. Bd. of Educ., 635 F.2d 971, 977 (2d Cir. 1980); Chess v. Widmar, 480 F. Supp. 907, 917 (W.D. Mo. 1979), "), _c('em', [_vm._v("rev’d on other grounds,")]), _vm._v(" 635 F.2d 1310 (8th Cir. 1980), "), _c('em', [_vm._v("aff’d sub nom.")]), _vm._v(" Widmar v. Vincent, 454 U.S. 263 (1981). The result, but not the free exercise reasoning, was changed by the Equal Access Act, 20 U.S.C. § 4071 "), _c('em', [_vm._v("et seq.")]), _vm._v(" (1988), upheld in "), _c('em', [_vm._v("Board of Education v. Mergens,")]), _vm._v(" 496 U.S. 226 (1990).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_105",
      "id": "foot-105"
    }
  }, [_vm._v("105")]), _vm._v(". "), _c('em', [_vm._v("Brandon,")]), _vm._v(" 635 F.2d at 977.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_106",
      "id": "foot-106"
    }
  }, [_vm._v("106")]), _vm._v(". Mozert v. Hawkins County Pub. Sch., 827 F.2d 1058, 1063–68 (6th Cir. 1987).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_107",
      "id": "foot-107"
    }
  }, [_vm._v("107")]), _vm._v(". The unreported opinion is described and reversed in Dorr v. First Kentucky Nat’l Corp., 41 Fair Empl. Prac. Cases 421, 423–24 (6th Cir.), "), _c('em', [_vm._v("vacated and rehearing en banc granted,")]), _vm._v(" 42 Fair Empl. Prac. Cases 64 (6th Cir. 1986). No further proceedings are reported.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_108",
      "id": "foot-108"
    }
  }, [_vm._v("108")]), _vm._v(". Witters v. State Comm’n for the Blind, 771 P.2d 1119, 1123 (Wash. 1989) (quoting Thomas v. Review Bd., 450 U.S. 707, 718 (1981)).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_109",
      "id": "foot-109"
    }
  }, [_vm._v("109")]), _vm._v(". McDaniel v. Paty, 435 U.S. 618 (1978).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_110",
      "id": "foot-110"
    }
  }, [_vm._v("110")]), _vm._v(". Matthew 23 (New English Bible; in several other translations the denunciation is of “scribes and Pharisees”). See also 2 Corinthians 3:6 (God’s new covenant is “expressed not in a written document, but in a spiritual bond; for the written law condemns to death, but the Spirit gives life.”).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_111",
      "id": "foot-111"
    }
  }, [_vm._v("111")]), _vm._v(". For further criticism of the emphasis on what the faith requires, see Frederick Gedicks, "), _c('em', [_vm._v("Toward a Constitutional Jurisprudence of Religious Group Rights,")]), _vm._v(" 1989 W"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("IS.")]), _vm._v(" L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 99, 142–44; Laycock, "), _c('a', {
    attrs: {
      "href": "#/017_Chapter02c#foot-100"
    }
  }, [_vm._v("note 100")]), _vm._v(" "), _c('em', [_vm._v("supra,")]), _vm._v(" at 1390–91 (text at notes 141–48). For arguments supporting that emphasis, see Jesse Choper, "), _c('em', [_vm._v("Defining “Religion” in the First Amendment,")]), _vm._v(" 1982 U. I"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("LL.")]), _vm._v(" L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 579; Stone, "), _c('a', {
    attrs: {
      "href": "#/017_Chapter02c#foot-90"
    }
  }, [_vm._v("note 90")]), _vm._v(" "), _c('em', [_vm._v("supra,")]), _vm._v(" at 993.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_112",
      "id": "foot-112"
    }
  }, [_vm._v("112")]), _vm._v(". "), _c('em', [_vm._v("Swaggart,")]), _vm._v(" 493 U.S. at 391, 392, 394.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_113",
      "id": "foot-113"
    }
  }, [_vm._v("113")]), _vm._v(". "), _c('em', [_vm._v("Id.")]), _vm._v(" at 394–95.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_114",
      "id": "foot-114"
    }
  }, [_vm._v("114")]), _vm._v(". 440 U.S. 490 (1979).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_115",
      "id": "foot-115"
    }
  }, [_vm._v("115")]), _vm._v(". "), _c('em', [_vm._v("Centesimus Annus")]), _vm._v(" (1991); "), _c('em', [_vm._v("Laborum Exercens")]), _vm._v(" (1981); "), _c('em', [_vm._v("Rerum Novarum")]), _vm._v(" (1891).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_116",
      "id": "foot-116"
    }
  }, [_vm._v("116")]), _vm._v(". Serbian E. Orthodox Diocese v. Milivojevich, 426 U.S. 696, 710, 720–24 (1976); Kedroff v. Saint Nicholas Cathedral, 344 U.S. 94, 116 (1952).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_117",
      "id": "foot-117"
    }
  }, [_vm._v("117")]), _vm._v(". "), _c('em', [_vm._v("Compare")]), _vm._v(" Carl Esbeck, "), _c('em', [_vm._v("Establishment Clause Limits on Governmental Interference with Religious Organizations,")]), _vm._v(" 41 W"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ASH.")]), _vm._v(" & L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EE")]), _vm._v(" L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 347 (1984), and Laycock, "), _c('a', {
    attrs: {
      "href": "#/017_Chapter02c#foot-100"
    }
  }, [_vm._v("note 100")]), _vm._v(" "), _c('em', [_vm._v("supra,")]), _vm._v(" with Ira C. Lupu, "), _c('em', [_vm._v("Free Exercise Exemption and Religious Institutions: The Case of Employment Discrimination,")]), _vm._v(" 67 B.U. L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 391 (1987); and William P. Marshall & Douglas C. Blomgren, "), _c('em', [_vm._v("Regulating Religious Organizations Under the Establishment Clause,")]), _vm._v(" 47 Ohio St. L. J. 293 (1986).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_118",
      "id": "foot-118"
    }
  }, [_vm._v("118")]), _vm._v(". Laycock, "), _c('a', {
    attrs: {
      "href": "#/017_Chapter02c#foot-100"
    }
  }, [_vm._v("note 100")]), _vm._v(" "), _c('em', [_vm._v("supra.")])]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_119",
      "id": "foot-119"
    }
  }, [_vm._v("119")]), _vm._v(". For elaboration of this theme, see Stephen L. Carter, "), _c('em', [_vm._v("Evolutionism, Creationism, and Treating Religion as a Hobby,")]), _vm._v(" 1987 D"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("UKE")]), _vm._v(" L.J. 977.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_120",
      "id": "foot-120"
    }
  }, [_vm._v("120")]), _vm._v(". In re Adoption of W.A.T., 808 P.2d 1083 (Utah 1991) (polygamous parents may adopt children if adoption will promote the children’s interests). "), _c('em', [_vm._v("See also")]), _vm._v(" Cleveland v. United States, 329 U.S. 14 (1946) (criminal prosecution for polygamy); Potter v. Murray City, 760 F.2d 1065 (10th Cir. 1985) (police officer discharged for polygamy); Barlow v. Blackburn, 798 P.2d 1360 (Ariz. App. 1990) (same); Ken Driggs, "), _c('em', [_vm._v("After the Manifesto: Modern Polygamy and Fundamentalist Mormons,")]), _vm._v(" 32 J. C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HURCH")]), _vm._v(" & S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("TATE")]), _vm._v(" 367 (1990).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_121",
      "id": "foot-121"
    }
  }, [_vm._v("121")]), _vm._v(". "), _c('em', [_vm._v("See")]), _vm._v(" M"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ULFORD")]), _vm._v(" Q. S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("IBLEY")]), _vm._v(" & P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HILIP")]), _vm._v(" E. J"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ACOB,")]), _vm._v(" C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ONSCRIPTION OF")]), _vm._v(" C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ONSCIENCE: THE")]), _vm._v(" A"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("MERICAN")]), _vm._v(" S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("TATE AND THE")]), _vm._v(" C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ONSCIENTIOUS")]), _vm._v(" O"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("BJECTOR")]), _vm._v(", 1940–1947, at 34, 84, 355–58 (1952).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_122",
      "id": "foot-122"
    }
  }, [_vm._v("122")]), _vm._v(". "), _c('em', [_vm._v("Smith,")]), _vm._v(" 494 U.S. at 889 & n.5.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_123",
      "id": "foot-123"
    }
  }, [_vm._v("123")]), _vm._v(". "), _c('em', [_vm._v("See")]), _vm._v(" T. Alexander Aleinikoff, "), _c('em', [_vm._v("Constitutional Law in the Age of Balancing,")]), _vm._v(" 96 Y"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ALE")]), _vm._v(" L. J. 943 (1987).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_124",
      "id": "foot-124"
    }
  }, [_vm._v("124")]), _vm._v(". "), _c('em', [_vm._v("See")]), _vm._v(" Douglas Laycock, "), _c('em', [_vm._v("Notes on the Role of Judicial Review, the Expansion of Federal Power, and the Structure of Constitutional Rights,")]), _vm._v(" 99 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("YALE")]), _vm._v(" L.J. 1711, 1743–47 (1990).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_125",
      "id": "foot-125"
    }
  }, [_vm._v("125")]), _vm._v(". "), _c('em', [_vm._v("Smith,")]), _vm._v(" 494 U.S. at 885.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_126",
      "id": "foot-126"
    }
  }, [_vm._v("126")]), _vm._v(". "), _c('em', [_vm._v("Id.")]), _vm._v(" at 886–87.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_127",
      "id": "foot-127"
    }
  }, [_vm._v("127")]), _vm._v(". Hustler Magazine, Inc. v. Falwell, 485 U.S. 46, 56 (1988), quoting Dun & Bradstreet, Inc. v. Greenmoss Builders, Inc., 472 U.S. 749, 758 (1985). For an extensive review of variations in the protection accorded different kinds of speech, see Young v. Am. Mini Theatres, Inc., 427 U.S. 50, 63–71 (1976) (plurality opinion).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_128",
      "id": "foot-128"
    }
  }, [_vm._v("128")]), _vm._v(". "), _c('em', [_vm._v("See, e.g.,")]), _vm._v(" Posadas de Puerto Rico Assoc. v. Tourism Co., 478 U.S. 328, 340 (1986); Central Hudson Gas & Elec. Corp. v. Pub. Serv. Comm’n, 447 U.S. 557, 561–63 (1980); Friedman v. Rogers, 440 U.S. 1, 10 (1979).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_129",
      "id": "foot-129"
    }
  }, [_vm._v("129")]), _vm._v(". "), _c('em', [_vm._v("Compare")]), _vm._v(" Gertz v. Welch, 418 U.S. 323 (1974) (private figure suing for defamation need show only negligence), "), _c('em', [_vm._v("with")]), _vm._v(" New York Times Co. v. Sullivan, 376 U.S. 254 (1964) (public figure suing for defamation must show actual malice).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_130",
      "id": "foot-130"
    }
  }, [_vm._v("130")]), _vm._v(". Young v. Am. Mini Theatres, Inc., 427 U.S. 50, 70–71 (1976) (plurality opinion).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_131",
      "id": "foot-131"
    }
  }, [_vm._v("131")]), _vm._v(". Miller v. California, 413 U.S. 15, 20, 34–36 (1973).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_132",
      "id": "foot-132"
    }
  }, [_vm._v("132")]), _vm._v(". "), _c('em', [_vm._v("See")]), _vm._v(" Cynthia Estlund, "), _c('em', [_vm._v("Speech on Matters of Public Concern: The Perils of an Emerging First Amendment Category,")]), _vm._v(" 56 GEO. W"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ASH.")]), _vm._v(" L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV.")]), _vm._v(" 1 (1990).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_133",
      "id": "foot-133"
    }
  }, [_vm._v("133")]), _vm._v(". Osborne v. Ohio, 495 U.S. 103, 108, 109 (1990).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_134",
      "id": "foot-134"
    }
  }, [_vm._v("134")]), _vm._v(". "), _c('em', [_vm._v("Smith,")]), _vm._v(" 494 U.S. at 887 n.4.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_135",
      "id": "foot-135"
    }
  }, [_vm._v("135")]), _vm._v(". The point is elaborated in McConnell, "), _c('a', {
    attrs: {
      "href": "#/017_Chapter02c#foot-9"
    }
  }, [_vm._v("note 9")]), _vm._v(" "), _c('em', [_vm._v("supra,")]), _vm._v(" at 1144–49.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_136",
      "id": "foot-136"
    }
  }, [_vm._v("136")]), _vm._v(". "), _c('em', [_vm._v("See")]), _vm._v(" Laycock, "), _c('a', {
    attrs: {
      "href": "#/017_Chapter02c#foot-124"
    }
  }, [_vm._v("note 124")]), _vm._v(" "), _c('em', [_vm._v("supra,")]), _vm._v(" at 1745–46.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_137",
      "id": "foot-137"
    }
  }, [_vm._v("137")]), _vm._v(". Black v. Employment Div., 707 P.2d 1274 (Or. App. 1985), "), _c('em', [_vm._v("aff’d as modified,")]), _vm._v(" 721 P.2d 451(Or. 1986), "), _c('em', [_vm._v("vacated,")]), _vm._v(" 485 U.S. 660 (1988); Smith v. Employment Div., 709 P.2d 246 (Or. App. 1985), "), _c('em', [_vm._v("aff’d as modified,")]), _vm._v(" 721 P.2d 445 (Or. 1986), "), _c('em', [_vm._v("vacated,")]), _vm._v(" 485 U.S. 660 (1988).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_138",
      "id": "foot-138"
    }
  }, [_vm._v("138")]), _vm._v(". 374 U.S. 398 (1963).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_139",
      "id": "foot-139"
    }
  }, [_vm._v("139")]), _vm._v(". Smith v. Employment Div., 721 P.2d 445, 450 (Or. 1986).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_140",
      "id": "foot-140"
    }
  }, [_vm._v("140")]), _vm._v(". Employment Div. v. Smith, 485 U.S. 660 (1988).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_141",
      "id": "foot-141"
    }
  }, [_vm._v("141")]), _vm._v(". "), _c('em', [_vm._v("Compare")]), _vm._v(" Miss. Univ. for Women v. Hogan, 458 U.S. 718, 730 & n.16 (1982); Weinberger v. Wiesenfeld, 420 U.S. 636, 648 & n.16 (1975); Jimenez v. Weinberger, 417 U.S. 628, 634 (1974); United States Dept. of Agric. v. Moreno, 413 U.S. 528, 536–37 (1973); Eisenstadt v. Baird, 405 U.S. 438, 450 (1972) (all suggesting a negative answer); "), _c('em', [_vm._v("with")]), _vm._v(" United States R.R. Retirement Bd. v. Fritz, 449 U.S. 166, 179 (1980); Hampton v. Mow Sun Wong, 426 U.S. 88, 103–05 (1976); "), _c('em', [_vm._v("and")]), _vm._v(" Flemming v. Nestor, 363 U.S. 603, 612 (1960) (all suggesting an affirmative answer).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_142",
      "id": "foot-142"
    }
  }, [_vm._v("142")]), _vm._v(". Black v. Employment Div., 721 P.2d 451, 453–54 (Or. 1986), quoting at length from People v. Woody, 394 P.2d 813 (Cal. 1964).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_143",
      "id": "foot-143"
    }
  }, [_vm._v("143")]), _vm._v(". "), _c('em', [_vm._v("See, e.g.,")]), _vm._v(" City of Los Angeles v. Lyons, 461 U.S. 95 (1983); Younger v. Harris, 401 U.S. 37, 41–42 (1971) (no case or controversy where no genuine threat of prosecution).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_144",
      "id": "foot-144"
    }
  }, [_vm._v("144")]), _vm._v(". Michigan v. Long, 463 U.S. 1032, 1068 (1983) (Stevens, J., dissenting); "), _c('em', [_vm._v("see id.")]), _vm._v(" at 1068–70.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_145",
      "id": "foot-145"
    }
  }, [_vm._v("145")]), _vm._v(". Minnesota v. Clover Leaf Creamery, 449 U.S. 456, 482 (1981) (Stevens, J., dissenting); "), _c('em', [_vm._v("see id.")]), _vm._v(" at 477–89.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_146",
      "id": "foot-146"
    }
  }, [_vm._v("146")]), _vm._v(". On Justice Stevens’ apparent hostility to religion, see Laycock, "), _c('a', {
    attrs: {
      "href": "#/017_Chapter02c#foot-17"
    }
  }, [_vm._v("note 17")]), _vm._v(" "), _c('em', [_vm._v("supra,")]), _vm._v(" at 1010 (text at notes 63–64).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_147",
      "id": "foot-147"
    }
  }, [_vm._v("147")]), _vm._v(". Smith v. Employment Div., 763 P.2d 146, 148 n.3 (Or. 1988) (departing from its usual practice of considering the state constitution first, because “no criminal case is before us”).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_148",
      "id": "foot-148"
    }
  }, [_vm._v("148")]), _vm._v(". "), _c('em', [_vm._v("Id.")]), _vm._v(" at 149, citing committee reports on the Drug Abuse Control Amendments of 1965 and the American Indian Religious Freedom Act of 1978.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_149",
      "id": "foot-149"
    }
  }, [_vm._v("149")]), _vm._v(". Smith v. Employment Div., 763 P.2d 146, 149 (Or. 1988).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_150",
      "id": "foot-150"
    }
  }, [_vm._v("150")]), _vm._v(". "), _c('em', [_vm._v("See, e.g.,")]), _vm._v(" Patterson v. McLean Credit Union, 485 U.S. 617 (1988); Garcia v. San Antonio Metro. Transit Auth., 468 U.S. 1213 (1984); Illinois v. Gates, 459 U.S. 1028 (1982); Alfred Dunhill, Inc. v. Republic of Cuba, 422 U.S. 1005 (1975); Brown v. Bd. of Educ., 347 U.S. 483, 495–96 (1954); Brown v. Bd. of Educ., 345 U.S. 972 (1953).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_151",
      "id": "foot-151"
    }
  }, [_vm._v("151")]), _vm._v(". 406 U.S. 205 (1972).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_152",
      "id": "foot-152"
    }
  }, [_vm._v("152")]), _vm._v(". "), _c('em', [_vm._v("Smith,")]), _vm._v(" 494 U.S. at 881 (citation omitted).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_153",
      "id": "foot-153"
    }
  }, [_vm._v("153")]), _vm._v(". "), _c('em', [_vm._v("See")]), _vm._v(" Pierce v. Soc’y of Sisters, 268 U.S. 510, 533–35 (1925) (finding right to send children to private schools in Due Process Clause); Roe v. Wade, 410 U.S. 113, 153 (1972) (preferring to find right to abortion in Fourteenth Amendment rather than Ninth).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_154",
      "id": "foot-154"
    }
  }, [_vm._v("154")]), _vm._v(". "), _c('em', [_vm._v("See")]), _vm._v(" R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OBERT")]), _vm._v(" B"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ORK")]), _vm._v(", T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HE")]), _vm._v(" T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EMPTING OF")]), _vm._v(" A"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("MERICA")]), _vm._v(" 166 (1990).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_155",
      "id": "foot-155"
    }
  }, [_vm._v("155")]), _vm._v(". "), _c('em', [_vm._v("See")]), _vm._v(" Laycock, "), _c('a', {
    attrs: {
      "href": "#/017_Chapter02c#foot-17"
    }
  }, [_vm._v("note 17")]), _vm._v(" "), _c('em', [_vm._v("supra,")]), _vm._v(" at 1002 (text at notes 28–30); "), _c('em', [_vm._v("cf.")]), _vm._v(" Welsh v. United States, 398 U.S. 333, 344 (1970) (interpreting conscientious objector provisions of Selective Service Act to protect non-theistic objectors).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_156",
      "id": "foot-156"
    }
  }, [_vm._v("156")]), _vm._v(". 489 U.S. 1, 11–13 (1989). "), _c('em', [_vm._v("See")]), _vm._v(" Walz v. Tax Comm’n, 397 U.S. 664 (1970).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_157",
      "id": "foot-157"
    }
  }, [_vm._v("157")]), _vm._v(". "), _c('em', [_vm._v("See")]), _vm._v(" Nat’l Bellas Hess, Inc. v. Dep’t of Revenue, 386 U.S. 753, 759–60 (1967).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_158",
      "id": "foot-158"
    }
  }, [_vm._v("158")]), _vm._v(". "), _c('em', [_vm._v("See")]), _vm._v(" Edward McGlynn Gaffney, "), _c('em', [_vm._v("On Not Rendering to Caesar: The Unconstitutionality of Tax Regulation of Activities of Religious Organizations Relating to Politics,")]), _vm._v(" 40 D"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EPAUL")]), _vm._v(" L. "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("REV.")]), _vm._v(" 1 (1990); Wilfred R. Caron & Deirdre Dessingue, "), _c('em', [_vm._v("IRC § 501(c)(3): Practical and Constitutional Implications of “Political” Activity Restrictions,")]), _vm._v(" 2 J.L. & P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OL")]), _vm._v(". 169 (1985).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_159",
      "id": "foot-159"
    }
  }, [_vm._v("159")]), _vm._v(". "), _c('em', [_vm._v("Smith,")]), _vm._v(" 494 U.S. at 877.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_160",
      "id": "foot-160"
    }
  }, [_vm._v("160")]), _vm._v(". "), _c('em', [_vm._v("Id.")]), _vm._v(" at 881–82. The Court distinguishes “profession” from “speech” without explanation. See text at notes 182–84 "), _c('em', [_vm._v("infra.")])]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_161",
      "id": "foot-161"
    }
  }, [_vm._v("161")]), _vm._v(". "), _c('em', [_vm._v("Smith,")]), _vm._v(" 494 U.S. at 881.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_162",
      "id": "foot-162"
    }
  }, [_vm._v("162")]), _vm._v(". "), _c('em', [_vm._v("Id.")]), _vm._v(" at 883–84.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_163",
      "id": "foot-163"
    }
  }, [_vm._v("163")]), _vm._v(". "), _c('em', [_vm._v("Id.")]), _vm._v(" at 884.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_164",
      "id": "foot-164"
    }
  }, [_vm._v("164")]), _vm._v(". "), _c('em', [_vm._v("Swaggart,")]), _vm._v(" 493 U.S. at 394–97.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_165",
      "id": "foot-165"
    }
  }, [_vm._v("165")]), _vm._v(". "), _c('em', [_vm._v("Smith,")]), _vm._v(" 494 U.S. at 877.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_166",
      "id": "foot-166"
    }
  }, [_vm._v("166")]), _vm._v(". "), _c('em', [_vm._v("Id.,")]), _vm._v(" citing 322 U.S. 78, 86–88 (1944).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_167",
      "id": "foot-167"
    }
  }, [_vm._v("167")]), _vm._v(". Serbian E. Orthodox Diocese v. Milivojevich, 426 U.S. 696, 708–25 (1976); Presbyterian Church v. Mary Elizabeth Blue Hull Memorial Presbyterian Church, 393 U.S. 440, 445–52 (1969); Kedroff v. St. Nicholas Cathedral, 344 U.S. 94, 95–119 (1952).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_168",
      "id": "foot-168"
    }
  }, [_vm._v("168")]), _vm._v(". 443 U.S. 595 (1979).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_169",
      "id": "foot-169"
    }
  }, [_vm._v("169")]), _vm._v(". Jones v. Wolf, 443 U.S. 595, 599–600, 602, 609 (1979); Presbyterian Church v. Mary Elizabeth Blue Hull Memorial Presbyterian Church, 393 U.S. 440 (1968).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_170",
      "id": "foot-170"
    }
  }, [_vm._v("170")]), _vm._v(". "), _c('em', [_vm._v("Smith,")]), _vm._v(" 494 U.S. at 877.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_171",
      "id": "foot-171"
    }
  }, [_vm._v("171")]), _vm._v(". The cases are collected in Douglas Laycock & Susan Waelbroeck, "), _c('em', [_vm._v("Academic Freedom and the Free Exercise of Religion,")]), _vm._v(" 66 T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EX.")]), _vm._v(" L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 1455, 1462 nn.27–30.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_172",
      "id": "foot-172"
    }
  }, [_vm._v("172")]), _vm._v(". 42 U.S.C. § 2000e-1 and e-2 (1988).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_173",
      "id": "foot-173"
    }
  }, [_vm._v("173")]), _vm._v(". "), _c('em', [_vm._v("See")]), _vm._v(" Dolter v. Wahlert High Sch., 483 F. Supp. 266 (N.D. Iowa 1980) (holding that school is constitutionally protected if it acted for religious reasons and did so consistently).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_174",
      "id": "foot-174"
    }
  }, [_vm._v("174")]), _vm._v(". "), _c('em', [_vm._v("See")]), _vm._v(" Ohio Civil Rights Comm’n v. Dayton Christian Sch., Inc., 477 U.S. 619 (1986) (failing to decide the issue); McLeod v. Providence Christian Sch., 408 N.W.2d 146 (Mich. App. 1987) (reinstating teacher).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_175",
      "id": "foot-175"
    }
  }, [_vm._v("175")]), _vm._v(". "), _c('em', [_vm._v("See")]), _vm._v(" Daniel Abuhoff, Comment, "), _c('em', [_vm._v("Title VII and the Appointment of Women Clergy: A Statutory and Constitutional Quagmire,")]), _vm._v(" 13 C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OLUM.")]), _vm._v(" J.L. & S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OC")]), _vm._v(". P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ROBS.")]), _vm._v(" 257 (1977) (implausibly finding the issue closed before "), _c('em', [_vm._v("Smith,")]), _vm._v(" but concluding that state’s interest was not compelling).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_176",
      "id": "foot-176"
    }
  }, [_vm._v("176")]), _vm._v(". "), _c('em', [_vm._v("See")]), _vm._v(" Walker v. First Presbyterian Church, 22 Fair Empl. Prac. Cases 762 (Cal. Super. Ct. 1980) (upholding discharge of homosexual organist); "), _c('em', [_vm._v("cf.")]), _vm._v(" Gay Rights Coalition v. Georgetown Univ., 536 A.2d 1 (D.C. App. 1987) (refusing to order Catholic university to grant official recognition to gay rights organization).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_177",
      "id": "foot-177"
    }
  }, [_vm._v("177")]), _vm._v(". "), _c('em', [_vm._v("See")]), _vm._v(" Miller v. Catholic Diocese, 728 P.2d 794 (Mont. 1986) (refusing to review discharge of school teacher).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_178",
      "id": "foot-178"
    }
  }, [_vm._v("178")]), _vm._v(". "), _c('em', [_vm._v("See, e.g.,")]), _vm._v(" Hutchison v. Thomas, 789 F.2d 392 (6th Cir. 1986) (refusing to review forced retirement of Methodist minister).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_179",
      "id": "foot-179"
    }
  }, [_vm._v("179")]), _vm._v(". "), _c('em', [_vm._v("See")]), _vm._v(" Serbian E. Orthodox Diocese v. Milivojevich, 426 U.S. 696 (1976) (refusing to let civil court review decision to remove bishop and appoint a successor).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_180",
      "id": "foot-180"
    }
  }, [_vm._v("180")]), _vm._v(". 440 U.S. 490 (1979).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_181",
      "id": "foot-181"
    }
  }, [_vm._v("181")]), _vm._v(". Catholic High Sch. Ass’n v. Culvert, 753 F.2d 1161 (2d Cir. 1985) (state labor board can assert jurisdiction over religious schools, except where sponsoring church has doctrinal objection to collective bargaining).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_182",
      "id": "foot-182"
    }
  }, [_vm._v("182")]), _vm._v(". "), _c('em', [_vm._v("Smith,")]), _vm._v(" 494 U.S. at 877.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_183",
      "id": "foot-183"
    }
  }, [_vm._v("183")]), _vm._v(". "), _c('em', [_vm._v("Id.")])]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_184",
      "id": "foot-184"
    }
  }, [_vm._v("184")]), _vm._v(". "), _c('em', [_vm._v("Id.")]), _vm._v(" at 881.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_185",
      "id": "foot-185"
    }
  }, [_vm._v("185")]), _vm._v(". "), _c('em', [_vm._v("Id.")]), _vm._v(" at 886 n.3.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_186",
      "id": "foot-186"
    }
  }, [_vm._v("186")]), _vm._v(". "), _c('em', [_vm._v("See, e.g.,")]), _vm._v(" Airport Comm’rs v. Jews for Jesus, Inc., 482 U.S. 569 (1987) (religious solicitation in airport); Heffron v. Int’l Soc’y for Krishna Consciousness, Inc., 452 U.S. 640 (1981) (religious solicitation at state fair, held properly regulated under same rules as secular solicitation at state fair); Widmar v. Vincent, 454 U.S. 263 (1981) (religious student groups on university campus); Fowler v. Rhode Island, 345 U.S. 67 (1953) (religious service in park).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_187",
      "id": "foot-187"
    }
  }, [_vm._v("187")]), _vm._v(". "), _c('em', [_vm._v("See, e.g.,")]), _vm._v(" Molko v. Holy Spirit Ass’n, 762 P.2d 46 (Cal. 1988); Christofferson v. Church of Scientology, 644 P.2d 577 (Or. App. 1982). A high-demand religion is one that demands much of its adherents: strict moral codes that are enforced and not merely encouraged, significant lifestyle changes, dietary restrictions, conspicuous dress, and the like.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_188",
      "id": "foot-188"
    }
  }, [_vm._v("188")]), _vm._v(". George v. Int’l Soc’y for Krishna Consciousness, No. D007153 (Cal. App. 4th Dist. 1989) ($32.7 million verdict reduced to $3 million), "), _c('em', [_vm._v("vacated,")]), _vm._v(" 499 U.S. 914 (1991); Wollersheim v. Church of Scientology, 260 Cal. Rptr. 331 (Cal. App. 1989) ($30 million verdict reduced to $2.5 million), "), _c('em', [_vm._v("vacated,")]), _vm._v(" 499 U.S. 914 (1991); Church Universal & Triumphant, Inc. v. Witt, No. B021187 (Cal. App. 2d Dist. 1989) ($1.5 million); O’Neil v. Schuckardt, 733 P.2d 693 (Idaho 1986) ($1 million against priest; $250,000 affirmed; new trial granted on the rest because damages for invasion of privacy could not be separated from damages for alienation of affections, a tort not recognized in Idaho); Christofferson v. Church of Scientology, 5 Religious Freedom Rptr. 126 (Or. Cir. Ct. Multnomah County 1985) ($39 million); Guinn v. Church of Christ, 775 P.2d 766 (Okla. 1989) ($390,000 against local congregation).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_189",
      "id": "foot-189"
    }
  }, [_vm._v("189")]), _vm._v(". New York Times Co. v. Sullivan, 376 U.S. 254 (1964).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_190",
      "id": "foot-190"
    }
  }, [_vm._v("190")]), _vm._v(". Hustler Magazine, Inc. v. Falwell, 485 U.S. 46 (1988).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_191",
      "id": "foot-191"
    }
  }, [_vm._v("191")]), _vm._v(". "), _c('em', [_vm._v("George")]), _vm._v(" and "), _c('em', [_vm._v("Wollersheim,")]), _vm._v(" both cited in "), _c('a', {
    attrs: {
      "href": "#/017_Chapter02c#foot-188"
    }
  }, [_vm._v("note 188")]), _vm._v(" "), _c('em', [_vm._v("supra.")])]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_192",
      "id": "foot-192"
    }
  }, [_vm._v("192")]), _vm._v(". Pac. Mut. Life Ins. Co. v. Haslip, 499 U.S. 1 (1991).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_193",
      "id": "foot-193"
    }
  }, [_vm._v("193")]), _vm._v(". "), _c('em', [_vm._v("Compare")]), _vm._v(" Marshall, "), _c('a', {
    attrs: {
      "href": "#/017_Chapter02c#foot-16"
    }
  }, [_vm._v("note 16")]), _vm._v(" "), _c('em', [_vm._v("supra,")]), _vm._v(" with William P. Marshall, "), _c('em', [_vm._v("Solving the Free Exercise Dilemma: Free Exercise as Expression,")]), _vm._v(" 67 M"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("INN.")]), _vm._v(" L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 545 (1983).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_194",
      "id": "foot-194"
    }
  }, [_vm._v("194")]), _vm._v(". Cases upholding such regulation are collected in New Life Baptist Church Academy v. Town of E. Longmeadow, 885 F.2d 940, 950 (1st Cir. 1989). For cases limiting such regulation, see Farrington v. Tokushige, 273 U.S. 284 (1927); Kentucky State Bd. for Elementary & Secondary Educ. v. Rudasill, 589 S.W.2d 877 (Ky. 1979); State v. Whisner, 351 N.E.2d 750 (Ohio 1976); "), _c('em', [_vm._v("see also")]), _vm._v(" State v. Emmanuel Baptist Preschool, 455 N.W.2d 1 (Mich. 1990) (limiting regulation of church day care center).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_195",
      "id": "foot-195"
    }
  }, [_vm._v("195")]), _vm._v(". Cases upholding restrictions on home schooling are collected in New Life Baptist Church Academy v. Town of E. Longmeadow, 885 F.2d 940, 950–51 (1st Cir. 1989). The home schooling movement has been politically strong enough to get substantial legislative accommodation in many states. For a collection of statutes, see Kara T. Burgess, Comment, "), _c('em', [_vm._v("The Constitutionality of Home Education Statutes,")]), _vm._v(" 55 UMKC L. Rev. 69 (1986). "), _c('em', [_vm._v("See also")]), _vm._v(" Wisconsin v. Yoder, 406 U.S. 205 (1972) (finding constitutional right to home schooling for Amish children in ninth and tenth grade).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_196",
      "id": "foot-196"
    }
  }, [_vm._v("196")]), _vm._v(". Mozert v. Hawkins County Pub. Sch., 827 F.2d 1058 (6th Cir. 1987).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_197",
      "id": "foot-197"
    }
  }, [_vm._v("197")]), _vm._v(". Wisconsin v. Yoder, 406 U.S. 205 (1972); Farrington v. Tokushige, 273 U.S. 284 (1927); Pierce v. Soc’y of Sisters, 268 U.S. 510 (1925).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_198",
      "id": "foot-198"
    }
  }, [_vm._v("198")]), _vm._v(". "), _c('em', [_vm._v("Smith,")]), _vm._v(" 494 U.S. at 884.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_199",
      "id": "foot-199"
    }
  }, [_vm._v("199")]), _vm._v(". Both quotations appear "), _c('em', [_vm._v("id.,")]), _vm._v(" citing Bowen v. Roy, 476 U.S. 693, 708 (1986) (plurality opinion).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_200",
      "id": "foot-200"
    }
  }, [_vm._v("200")]), _vm._v(". "), _c('em', [_vm._v("See, e.g.,")]), _vm._v(" Love Church v. City of Evanston, 896 F.2d 1082 (7th Cir. 1989) (city code required special use permit for any new church; claim dismissed for lack of standing); Lakewood, Ohio Congregation of Jehovah’s Witnesses, Inc. v. City of Lakewood, 699 F.2d 303 (6th Cir. 1983) (zoning decision forbidding church to build on its land, upheld). A majority of courts hold, often on grounds other than free exercise, that churches cannot be excluded from residential zones. Laurie Reynolds, "), _c('em', [_vm._v("Zoning the Church: The Police Power Versus the First Amendment,")]), _vm._v(" 64 B.U. L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 767, 776–77 (1985).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_201",
      "id": "foot-201"
    }
  }, [_vm._v("201")]), _vm._v(". "), _c('em', [_vm._v("See, e.g.,")]), _vm._v(" Havurah v. Zoning Bd. of Appeals, 418 A.2d 82 (Conn. 1979) (zoning decision forbidding use of church for overnight accommodations, struck down); Burlington Assembly of God Church v. Zoning Bd. of Adjustment, 570 A.2d 495 (N.J. Super. Ct. 1989) (refusal of variance for church radio tower, struck down); St. John’s Evangelical Lutheran Church v. Hoboken, 479 A.2d 935 (N.J. Super. Ct. 1983) (zoning decision forbidding church to shelter homeless, struck down); Westchester Reform Temple v. Brown, 239 N.E.2d 891, 293 N.Y.S.2d 297 (N.Y. 1968) (setback rules imposing financial hardship on expansion of synagogue, struck down); "), _c('em', [_vm._v("see also")]), _vm._v(" Grosz v. City of Miami Beach, 721 F.2d 729 (11th Cir. 1983) (zoning decision forbidding meetings of prayer group in private home, upheld). For analysis and more cases, see Reynolds, "), _c('a', {
    attrs: {
      "href": "#/017_Chapter02c#foot-200"
    }
  }, [_vm._v("note 200")]), _vm._v(" "), _c('em', [_vm._v("supra,")]), _vm._v(" at 810–17.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_202",
      "id": "foot-202"
    }
  }, [_vm._v("202")]), _vm._v(". Islamic Center, Inc. v. City of Starkville, 840 F.2d 293 (5th Cir. 1988) (series of zoning decisions refusing to allow Muslims to meet in university neighborhood where no Christian church had ever been denied zoning, struck down); Moore v. Trippe, 743 F. Supp. 201 (S.D.N.Y. 1990) (repeated citations against Buddhist temple, and zoning amendment requiring special use permit for any change to property); Reynolds, "), _c('a', {
    attrs: {
      "href": "#/017_Chapter02c#foot-200"
    }
  }, [_vm._v("note 200")]), _vm._v(" "), _c('em', [_vm._v("supra,")]), _vm._v(" at 770–71 & n.20.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_203",
      "id": "foot-203"
    }
  }, [_vm._v("203")]), _vm._v(". N. J. L’Heureux, "), _c('em', [_vm._v("Ministry v. Mortar. A Landmark Conflict,")]), _vm._v(" in Dean M. Kelley, G"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OVERNMENT")]), _vm._v(" I"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("NTERVENTION IN")]), _vm._v(" R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ELIGIOUS")]), _vm._v(" A"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("FFAIRS")]), _vm._v(" 2, at 164, 168 (1986) (stating that religious buildings are less than 1/3 of one percent of buildings in New York City, but more than fourteen percent of buildings designated as landmarks in New York City). For further analysis, see Angela C. Carmella, "), _c('em', [_vm._v("Houses of Worship and Religious Liberty: Constitutional Limits to Landmark Preservation and Architectural Review,")]), _vm._v(" 36 V"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ILL.")]), _vm._v(" L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 401 (1991); Kent Greenawalt, "), _c('em', [_vm._v("Church and State: Some Constitutional Questions in Landmarking of Church-owned Properties,")]), _vm._v(" in H"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ISTORIC")]), _vm._v(" P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("RESERVATION")]), _vm._v(" L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AW")]), _vm._v(" 465 (Nicholas A. Robinson, ed., 1982). For illustrative cases, see Church of St. Paul and St. Andrew v. Barwick, 496 N.E.2d 183 (N.Y. 1986); First Covenant Church v. City of Seattle, 787 P.2d 1352 (Wash.), "), _c('em', [_vm._v("vacated for reconsideration in light of Smith,")]), _vm._v(" 499 U.S. 901 (1991). For an application of "), _c('em', [_vm._v("Smith,")]), _vm._v(" see Rector of St. Bartholomew’s Church v. City of New York, 914 F.2d 348, 354–55 (2d Cir. 1990) (finding a landmarking ordinance neutral and generally applicable, and finding discretionary application to individual churches of “no constitutional relevance”).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_204",
      "id": "foot-204"
    }
  }, [_vm._v("204")]), _vm._v(". For a reported example, see Yonkers Racing Corp. v. City of Yonkers, 858 F.2d 855, 871 (2d Cir. 1988). Other condemnations with devastating consequences can be avoided only by an exemption. "), _c('em', [_vm._v("See")]), _vm._v(" Pillar of Fire v. Denver Urban Renewal Auth., 509 P.2d 1250 (Col. 1973), where a thirty-three-block urban renewal project included a denomination’s first church, which had great historical and symbolic significance. The court conditioned the condemnation on proof of “a substantial interest without a reasonable alternative means of accomplishment.” "), _c('em', [_vm._v("Id.")]), _vm._v(" 1253.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_205",
      "id": "foot-205"
    }
  }, [_vm._v("205")]), _vm._v(". 401 U.S. 437 (1971).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_206",
      "id": "foot-206"
    }
  }, [_vm._v("206")]), _vm._v(". 42 U.S.C. § 2000e (1988).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_207",
      "id": "foot-207"
    }
  }, [_vm._v("207")]), _vm._v(". "), _c('em', [_vm._v("But see")]), _vm._v(" Intercommunity Center for Justice & Peace v. Immigration & Naturalization Serv., 910 F. 2d 42, 45 (2d Cir. 1990), finding this exception irrelevant to a free exercise claim. It is not clear from the opinion whether plaintiffs urged that the exception in the statute triggered an exception to "), _c('em', [_vm._v("Smith.")]), _vm._v(" In any event, the court found that the government’s interest was compelling.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_208",
      "id": "foot-208"
    }
  }, [_vm._v("208")]), _vm._v(". F"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("LA.")]), _vm._v(" S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("TAT.")]), _vm._v(" A"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("NN")]), _vm._v(". § 828.24(3) (1976).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_209",
      "id": "foot-209"
    }
  }, [_vm._v("209")]), _vm._v(". "), _c('em', [_vm._v("See")]), _vm._v(" Ansonia Bd. of Educ. v. Philbrook, 479 U.S. 60 (1986); "), _c('em', [_vm._v("id.")]), _vm._v(" at 79 (Stevens, J., dissenting in part).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_210",
      "id": "foot-210"
    }
  }, [_vm._v("210")]), _vm._v(". "), _c('em', [_vm._v("Smith,")]), _vm._v(" 494 U.S. at 878.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_211",
      "id": "foot-211"
    }
  }, [_vm._v("211")]), _vm._v(". 297 U.S. 223, 250–51 (1936), cited in "), _c('em', [_vm._v("Smith,")]), _vm._v(" 494 U.S. at 878. "), _c('em', [_vm._v("Grosjean")]), _vm._v(" struck down a Louisiana tax on all newspapers with circulation greater than 20,000. With only one exception, drawing the line at 20,000 taxed all the urban papers that opposed Huey Long, and exempted all the small town papers that supported him. For analysis of "), _c('em', [_vm._v("Grosjean,")]), _vm._v(" see L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("UCAS A.")]), _vm._v(" P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OWE,")]), _vm._v(" J"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("R.")]), _vm._v(", T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HE")]), _vm._v(" F"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OURTH")]), _vm._v(" E"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("STATE AND THE")]), _vm._v(" C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ONSTITUTION")]), _vm._v(" 222 (1991).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_212",
      "id": "foot-212"
    }
  }, [_vm._v("212")]), _vm._v(". Compare the Court’s example of a “doubtless[ly]” unconstitutional law making it a crime to bow down before a golden calf. "), _c('em', [_vm._v("Smith,")]), _vm._v(" 494 U.S. at 877–78.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_213",
      "id": "foot-213"
    }
  }, [_vm._v("213")]), _vm._v(". Lemon v. Kurtzman, 403 U.S. 602, 612–13 (1971).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_214",
      "id": "foot-214"
    }
  }, [_vm._v("214")]), _vm._v(". "), _c('em', [_vm._v("Swaggart,")]), _vm._v(" 493 U.S. at 392–97; Tony and Susan Alamo Foundation v. Secretary of Labor, 471 U.S. 290, 305–06 (1985).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_215",
      "id": "foot-215"
    }
  }, [_vm._v("215")]), _vm._v(". Laycock, "), _c('a', {
    attrs: {
      "href": "#/017_Chapter02c#foot-100"
    }
  }, [_vm._v("note 100")]), _vm._v(" "), _c('em', [_vm._v("supra,")]), _vm._v(" at 1378–86 (text at notes 57–112).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_216",
      "id": "foot-216"
    }
  }, [_vm._v("216")]), _vm._v(". Carl Esbeck, "), _c('em', [_vm._v("Towards a General Theory of Church-State Relations and the First Amendment,")]), _vm._v(" 4 P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("UB.")]), _vm._v(" L.F. 325 (1985); Carl Esbeck, "), _c('em', [_vm._v("Establishment Clause Limits on Governmental Interference with Religious Organizations,")]), _vm._v(" 41 W"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ASH.")]), _vm._v(" & L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EE")]), _vm._v(" L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 347 (1984).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_217",
      "id": "foot-217"
    }
  }, [_vm._v("217")]), _vm._v(". "), _c('em', [_vm._v("See, e.g.,")]), _vm._v(" Aguilar v. Felton, 473 U.S. 402, 408–14 (1985) (remedial instruction in math and reading for impoverished students attending religious schools); Larkin v. Grendel’s Den, Inc., 459 U.S. 116, 126–27 (1982) (partial delegation of zoning power to churches). The Court did find an Establishment Clause violation in Larson v. Valente, 456 U.S. 228 (1982), which struck down a burdensome regulation that had been designed to regulate the Unification Church without affecting more mainstream faiths. This was based not on any prong of the "), _c('em', [_vm._v("Lemon")]), _vm._v(" test, but on a separate principle that the Establishment Clause forbids discrimination among faiths. "), _c('em', [_vm._v("Larson’")]), _vm._v("s requirement of denominational neutrality under the Establishment Clause corresponds to "), _c('em', [_vm._v("Smith’")]), _vm._v("s requirement of denominational neutrality under the Free Exercise Clause.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_218",
      "id": "foot-218"
    }
  }, [_vm._v("218")]), _vm._v(". "), _c('em', [_vm._v("See")]), _vm._v(" Salvation Army v. Dep’t of Cmty. Affairs, 919 F.2d 183, 199–200 (3d Cir. 1990) (hybrid freedom of association claim adds nothing to free exercise claim); Rector of St. Bartholomew’s Church v. City of New York, 914 F.2d 348, 354–55 (2d Cir. 1990) (landmark ordinance is neutral because it potentially applies to all buildings; irrelevant that designation process is individualized); Intercommunity Center for Justice v. Immigration & Naturalization Serv., 910 F.2d 42, 45 (2d Cir. 1990) (secular exemptions irrelevant to claim for religious exemption); Cornerstone Bible Church v. City of Hastings, 740 F. Supp. 654 (D.Minn. 1990) (upholding exclusion of churches from commercial zone, finding the ordinance neutral despite its express reference to churches, holding that hybrid free speech claim added nothing to the free exercise claim, holding it irrelevant that church could find nowhere else in city to meet, and ignoring individualized decision-making in zoning process). "), _c('em', [_vm._v("But see")]), _vm._v(" You Vang Yang v. Starner, 750 F. Supp. 558 (D.R.I. 1990) (“regretfully” applying "), _c('em', [_vm._v("Smith")]), _vm._v(" to uphold requirement of mandatory autopsy as applied to Hmong accident victim; nothing in opinion indicates any plausible basis for claiming an exception to "), _c('em', [_vm._v("Smith")]), _vm._v("); Montgomery v. County of Clinton, 743 F. Supp. 1253, 1259 (W.D. Mich. 1990) (even with no arguable exception relevant, "), _c('em', [_vm._v("Smith")]), _vm._v(" still requires rational basis review). "), _c('em', [_vm._v("See also")]), _vm._v(" State v. Hershberger 462 N.W.2d 393 (Minn. 1990) (rejecting "), _c('em', [_vm._v("Smith")]), _vm._v(" in principle and granting religious exemptions under state constitution); State v. French, 460 N.W.2d 2 (Minn. 1990) (same); Soc’y of Jesus v. Boston Landmarks Comm’n, 564 N.E.2d 571 (Mass. 1990) (ignoring "), _c('em', [_vm._v("Smith")]), _vm._v(" and granting religious exemptions under state constitution). "), _c('em', [_vm._v("Salvation Army,")]), _vm._v(" the first case in this note, may be correctly decided under "), _c('em', [_vm._v("Smith,")]), _vm._v(" because freedom of association is itself a derivative right. That is, freedom of religious association is derived from the Free Exercise Clause, and could not plausibly change the free-exercise standard of review. The reasoning in "), _c('em', [_vm._v("Salvation Army")]), _vm._v(" should not apply to a true hybrid claim, involving an independent right such as free speech or parental control of education.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_219",
      "id": "foot-219"
    }
  }, [_vm._v("219")]), _vm._v(". "), _c('em', [_vm._v("Compare")]), _vm._v(" H"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ODGKINSON,")]), _vm._v(" W"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EITZMAN")]), _vm._v(" & K"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("IRSCH")]), _vm._v(", F"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ROM")]), _vm._v(" B"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ELIEF TO")]), _vm._v(" C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OMMITMENT")]), _vm._v(": T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HE")]), _vm._v(" A"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CTIVITIES AND")]), _vm._v(" F"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("INANCES OF")]), _vm._v(" R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ELIGIOUS")]), _vm._v(" O"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("RGANIZATIONS IN THE")]), _vm._v(" U"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("NITED")]), _vm._v(" S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("TATES")]), _vm._v(" 49 (1988) (42% of church expenditures go to “non-religious” charitable and cultural activities), "), _c('em', [_vm._v("with")]), _vm._v(" I"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("NTERFAITH")]), _vm._v(" R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ESEARCH")]), _vm._v(" C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OMM. OF THE")]), _vm._v(" C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OMM")]), _vm._v("’"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("N ON")]), _vm._v(" P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("RIVATE")]), _vm._v(" P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HILANTHROPY AND")]), _vm._v(" P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("UBLIC")]), _vm._v(" N"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EEDS")]), _vm._v(", A S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("TUDY OF")]), _vm._v(" R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ELIGIOUS")]), _vm._v(" R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ECEIPTS AND")]), _vm._v(" E"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("XPENDITURES IN THE")]), _vm._v(" U"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("NITED")]), _vm._v(" S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("TATES")]), _vm._v(" 402–34 (1977) (15% or less of church expenditures go to purposes that are neither sacramental or educational). The categories in the two studies are not well defined, and the reasons for their strikingly different results are unclear. Contributing factors appear to be that Hodgkinson, Weitzman, & Kirsch treated the cost of church-sponsored schools as charitable, and that they used current operating expenses as the denominator.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_220",
      "id": "foot-220"
    }
  }, [_vm._v("220")]), _vm._v(". "), _c('em', [_vm._v("See")]), _vm._v(" Anthony DePalma, "), _c('em', [_vm._v("Salvation Army Is Told to Pay Minimum Wage,")]), _vm._v(" N.Y. T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("IMES")]), _vm._v(", Sept. 16, 1990, § 1, part 1, at 42, col. 5. "), _c('em', [_vm._v("See also")]), _vm._v(" Salvation Army v. Dep’t of Cmty. Affairs, 919 F.2d 183 (3d Cir. 1990) (rejecting most of Salvation Army’s challenge to application of boarding house regulations to its shelters).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_221",
      "id": "foot-221"
    }
  }, [_vm._v("221")]), _vm._v(". "), _c('em', [_vm._v("See")]), _vm._v(" Sam Roberts, "), _c('em', [_vm._v("Fight City Hall? Nope, Not Even Mother Teresa,")]), _vm._v(" N.Y. T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("IMES")]), _vm._v(", Sept. 17, 1990, at B1, col. 1 (reporting permanent closure of religious order’s shelter for the homeless; elevator was prohibitively expensive and violated religious order’s teachings against using modern conveniences).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_222",
      "id": "foot-222"
    }
  }, [_vm._v("222")]), _vm._v(". "), _c('em', [_vm._v("See generally")]), _vm._v(" Carmella, "), _c('a', {
    attrs: {
      "href": "#/017_Chapter02c#foot-203"
    }
  }, [_vm._v("note 203")]), _vm._v(" "), _c('em', [_vm._v("supra.")])]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_223",
      "id": "foot-223"
    }
  }, [_vm._v("223")]), _vm._v(". Rector of St. Bartholomew’s Church v. City of New York, 914 F.2d 348, 355 (2d Cir. 1990).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_224",
      "id": "foot-224"
    }
  }, [_vm._v("224")]), _vm._v(". The judicial and legislative history is summarized in Clarke v. United States, 915 F.2d 699 (D.C. Cir. 1990).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_225",
      "id": "foot-225"
    }
  }, [_vm._v("225")]), _vm._v(". For effective criticism of the political entanglement doctrine, see Edward McGlynn Gaffney, "), _c('em', [_vm._v("Political Divisiveness Along Religious Lines: The Entanglement of the Court in Sloppy History and Bad Public Policy,")]), _vm._v(" 24 S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("T.")]), _vm._v(" L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OUIS")]), _vm._v(" U.L.J. 205 (1980).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_226",
      "id": "foot-226"
    }
  }, [_vm._v("226")]), _vm._v(". H. R. 5377 in the 101st Congress.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_227",
      "id": "foot-227"
    }
  }, [_vm._v("227")]), _vm._v(". 28 U.S.C. § 2283 (1988).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_228",
      "id": "foot-228"
    }
  }, [_vm._v("228")]), _vm._v(". D"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ANIEL")]), _vm._v(" B"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OORSTIN")]), _vm._v(", T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HE")]), _vm._v(" A"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("MERICANS")]), _vm._v(": T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HE")]), _vm._v(" C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OLONIAL")]), _vm._v(" E"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("XPERIENCE")]), _vm._v(" 35–40 (1958).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_229",
      "id": "foot-229"
    }
  }, [_vm._v("229")]), _vm._v(". "), _c('em', [_vm._v("See")]), _vm._v(" M"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ARION")]), _vm._v(" L. S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("TARKEY")]), _vm._v(", T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HE")]), _vm._v(" D"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EVIL IN")]), _vm._v(" M"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ASSACHUSETTS")]), _vm._v(": A M"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ODERN")]), _vm._v(" E"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("NQUIRY INTO THE")]), _vm._v(" S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ALEM")]), _vm._v(" W"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ITCH")]), _vm._v(" T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("RIALS")]), _vm._v(" 248–70 (1961).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_230",
      "id": "foot-230"
    }
  }, [_vm._v("230")]), _vm._v(". "), _c('em', [_vm._v("See")]), _vm._v(" B"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OORSTIN")]), _vm._v(", "), _c('a', {
    attrs: {
      "href": "#/017_Chapter02c#foot-228"
    }
  }, [_vm._v("note 228")]), _vm._v(" "), _c('em', [_vm._v("supra,")]), _vm._v(" at 136.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_231",
      "id": "foot-231"
    }
  }, [_vm._v("231")]), _vm._v(". J"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ON")]), _vm._v(" B"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("UTLER,")]), _vm._v(" A"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("WASH IN A")]), _vm._v(" S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EA OF")]), _vm._v(" F"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AITH")]), _vm._v(" 129–63 (1990).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_232",
      "id": "foot-232"
    }
  }, [_vm._v("232")]), _vm._v(". For general accounts of American anti-Catholicism, see D"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AVID")]), _vm._v(" H. B"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ENNETT")]), _vm._v(", T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HE")]), _vm._v(" P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ARTY OF")]), _vm._v(" F"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EAR")]), _vm._v(": F"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ROM")]), _vm._v(" N"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ATIVIST")]), _vm._v(" M"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OVEMENTS TO THE")]), _vm._v(" N"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EW")]), _vm._v(" R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("IGHT IN")]), _vm._v(" A"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("MERICAN")]), _vm._v(" H"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ISTORY")]), _vm._v(" (1988); M"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ICHAEL")]), _vm._v(" S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CHWARTZ")]), _vm._v(", T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HE")]), _vm._v(" P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ERSISTENT")]), _vm._v(" P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("REJUDICE:")]), _vm._v(" A"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("NTI-CATHOLICISM IN")]), _vm._v(" A"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("MERICA")]), _vm._v(" (1984).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_233",
      "id": "foot-233"
    }
  }, [_vm._v("233")]), _vm._v(". "), _c('em', [_vm._v("See")]), _vm._v(" B"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ENNETT")]), _vm._v(", "), _c('a', {
    attrs: {
      "href": "#/017_Chapter02c#foot-232"
    }
  }, [_vm._v("note 232")]), _vm._v(" "), _c('em', [_vm._v("supra,")]), _vm._v(" at 27–155; L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EONARD")]), _vm._v(" L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EVY")]), _vm._v(", T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HE")]), _vm._v(" E"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("STABLISHMENT")]), _vm._v(" C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("LAUSE")]), _vm._v(" 170 (1986); 1 A"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("NSON")]), _vm._v(" P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HELPS")]), _vm._v(" S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("TOKES,")]), _vm._v(" C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HURCH AND")]), _vm._v(" S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("TATE IN THE")]), _vm._v(" U"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("NITED")]), _vm._v(" S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("TATES")]), _vm._v(" 836–37 (1950); 2 "), _c('em', [_vm._v("id.")]), _vm._v(" at 67–68.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_234",
      "id": "foot-234"
    }
  }, [_vm._v("234")]), _vm._v(". "), _c('em', [_vm._v("See")]), _vm._v(" C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ARL")]), _vm._v(" F. K"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AESTLE,")]), _vm._v(" P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ILLARS OF THE")]), _vm._v(" R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EPUBLIC")]), _vm._v(": C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OMMON")]), _vm._v(" S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CHOOLS AND")]), _vm._v(" A"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("MERICAN")]), _vm._v(" S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OCIETY")]), _vm._v(", 1780–1860, at 71–103 (1971); D"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("IANE")]), _vm._v(" R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AVITCH")]), _vm._v(", T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HE")]), _vm._v(" G"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("REAT")]), _vm._v(" S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CHOOL")]), _vm._v(" W"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ARS")]), _vm._v(" 35, 45, 51–52, 80 (1974); 2 S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("TOKES")]), _vm._v(", "), _c('a', {
    attrs: {
      "href": "#/017_Chapter02c#foot-233"
    }
  }, [_vm._v("note 233")]), _vm._v(" "), _c('em', [_vm._v("supra,")]), _vm._v(" at 47–72, 549–51; C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ARL")]), _vm._v(" Z"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OLLMAN,")]), _vm._v(" A"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("MERICAN")]), _vm._v(" C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HURCH")]), _vm._v(" L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AW")]), _vm._v(" §§ 58–60 at 72–74 (2d ed. 1933).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_235",
      "id": "foot-235"
    }
  }, [_vm._v("235")]), _vm._v(". The proposed amendment is reprinted in 2 S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("TOKES")]), _vm._v(", "), _c('a', {
    attrs: {
      "href": "#/017_Chapter02c#foot-233"
    }
  }, [_vm._v("note 233")]), _vm._v(" "), _c('em', [_vm._v("supra,")]), _vm._v(" at 68–69.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_236",
      "id": "foot-236"
    }
  }, [_vm._v("236")]), _vm._v(". "), _c('em', [_vm._v("Id.")]), _vm._v(" at 69–70; Z"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OLLMAN")]), _vm._v(", "), _c('a', {
    attrs: {
      "href": "#/017_Chapter02c#foot-234"
    }
  }, [_vm._v("note 234")]), _vm._v(" "), _c('em', [_vm._v("supra,")]), _vm._v(" §§ 62–66 at 75–80.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_237",
      "id": "foot-237"
    }
  }, [_vm._v("237")]), _vm._v(". "), _c('em', [_vm._v("See")]), _vm._v(" Michael W. McConnell, "), _c('em', [_vm._v("The Selective Funding Problem: Abortions and Religious Schools Funding,")]), _vm._v(" 104 H"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ARV.")]), _vm._v(" L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 989 (1991); McConnell & Posner, "), _c('a', {
    attrs: {
      "href": "#/017_Chapter02c#foot-71"
    }
  }, [_vm._v("note 71")]), _vm._v(" "), _c('em', [_vm._v("supra,")]), _vm._v(" at 14–32.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_238",
      "id": "foot-238"
    }
  }, [_vm._v("238")]), _vm._v(". For accounts of the fight over religion and the Protestant Bible in public schools, see C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HARLES")]), _vm._v(" L. G"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("LENN,")]), _vm._v(" J"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("R.")]), _vm._v(", T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HE")]), _vm._v(" M"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("YTH OF THE")]), _vm._v(" C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OMMON")]), _vm._v(" S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CHOOL")]), _vm._v(" 115–235 (1988); K"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AESTLE")]), _vm._v(", "), _c('a', {
    attrs: {
      "href": "#/017_Chapter02c#foot-234"
    }
  }, [_vm._v("note 234")]), _vm._v(" "), _c('em', [_vm._v("supra,")]), _vm._v(" at 158–70; R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AVITCH")]), _vm._v(", "), _c('a', {
    attrs: {
      "href": "#/017_Chapter02c#foot-234"
    }
  }, [_vm._v("note 234")]), _vm._v(" "), _c('em', [_vm._v("supra,")]), _vm._v(" at 27–76. Focusing on Massachusetts, Glenn argues that Catholics and conservative Protestants initially offered similar objections to the liberal Protestantism and Unitarianism that prevailed in Horace Mann’s common schools, but that the liberal and conservative Protestant factions united as Catholic immigration increased.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_239",
      "id": "foot-239"
    }
  }, [_vm._v("239")]), _vm._v(". For accounts of the incident, which probably cost Blaine the Presidency, see H"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ISTORY OF")]), _vm._v(" A"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("MERICAN")]), _vm._v(" P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("RESIDENTIAL")]), _vm._v(" E"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("LECTIONS")]), _vm._v(" 1789–1968 at 1606 (Arthur M. Schlesinger, Jr., ed., 1971) (reprinting the story from the New York World, Oct. 30, 1884); "), _c('em', [_vm._v("Samuel Dickinson Burchard,")]), _vm._v(" in 2 D"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ICTIONARY OF")]), _vm._v(" A"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("MERICAN")]), _vm._v(" B"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("IOGRAPHY")]), _vm._v(" 271 (Johnson & Malone, eds., 1958).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_240",
      "id": "foot-240"
    }
  }, [_vm._v("240")]), _vm._v(". "), _c('em', [_vm._v("See")]), _vm._v(" 2 S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("TOKES")]), _vm._v(", "), _c('a', {
    attrs: {
      "href": "#/017_Chapter02c#foot-233"
    }
  }, [_vm._v("note 233")]), _vm._v(" "), _c('em', [_vm._v("supra,")]), _vm._v(" at 737–41.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_241",
      "id": "foot-241"
    }
  }, [_vm._v("241")]), _vm._v(". Pierce v. Soc’y of Sisters, 268 U.S. 510 (1925).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_242",
      "id": "foot-242"
    }
  }, [_vm._v("242")]), _vm._v(". "), _c('em', [_vm._v("See")]), _vm._v(" L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EONARD")]), _vm._v(" J. A"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("RRINGTON")]), _vm._v(" & D"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AVIS")]), _vm._v(" B"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ITTON")]), _vm._v(", T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HE")]), _vm._v(" M"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ORMON")]), _vm._v(" E"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("XPERIENCE")]), _vm._v(" 44–64 (1979).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_243",
      "id": "foot-243"
    }
  }, [_vm._v("243")]), _vm._v(". "), _c('em', [_vm._v("Id.")]), _vm._v(" at 45–46; L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EONARD")]), _vm._v(" J. A"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("RRINGTON,")]), _vm._v(" B"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("RIGHAM")]), _vm._v(" Y"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OUNG")]), _vm._v(" 62–78 (1985); 2 S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("TOKES")]), _vm._v(", "), _c('a', {
    attrs: {
      "href": "#/017_Chapter02c#foot-233"
    }
  }, [_vm._v("note 233")]), _vm._v(" "), _c('em', [_vm._v("supra,")]), _vm._v(" at 43–44.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_244",
      "id": "foot-244"
    }
  }, [_vm._v("244")]), _vm._v(". A"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("RRINGTON")]), _vm._v(" & B"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ITTON")]), _vm._v(", "), _c('a', {
    attrs: {
      "href": "#/017_Chapter02c#foot-242"
    }
  }, [_vm._v("note 242")]), _vm._v(" "), _c('em', [_vm._v("supra,")]), _vm._v(" at 65–82; 2 S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("TOKES")]), _vm._v(", "), _c('a', {
    attrs: {
      "href": "#/017_Chapter02c#foot-233"
    }
  }, [_vm._v("note 233")]), _vm._v(" "), _c('em', [_vm._v("supra,")]), _vm._v(" at 46.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_245",
      "id": "foot-245"
    }
  }, [_vm._v("245")]), _vm._v(". A"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("RRINGTON")]), _vm._v(" & B"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ITTON")]), _vm._v(", "), _c('a', {
    attrs: {
      "href": "#/017_Chapter02c#foot-242"
    }
  }, [_vm._v("note 242")]), _vm._v(" "), _c('em', [_vm._v("supra,")]), _vm._v(" at 280. These prosecutions were upheld in Reynolds v. United States, 98 U.S. 145 (1878).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_246",
      "id": "foot-246"
    }
  }, [_vm._v("246")]), _vm._v(". Davis v. Beason, 133 U.S. 333 (1890).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_247",
      "id": "foot-247"
    }
  }, [_vm._v("247")]), _vm._v(". Late Corporation of the Church of Jesus Christ of Latter Day Saints v. United States, 136 U.S. 1 (1890).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_248",
      "id": "foot-248"
    }
  }, [_vm._v("248")]), _vm._v(". See, "), _c('em', [_vm._v("e.g.,")]), _vm._v(" Utah Enabling Act, ch. 138, § 3, 28 S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("TAT")]), _vm._v(". 107 (1894); U"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("TAH")]), _vm._v(" C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ONST")]), _vm._v(". art. III; New Mexico & Arizona Enabling Act, ch. 310, §§ 2, 36 S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("TAT")]), _vm._v(". 557, 558, "), _c('em', [_vm._v("id.")]), _vm._v(" § 20 at 569; A"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("RIZ.")]), _vm._v(" C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ONST")]), _vm._v(". art. XX; Dakota, Montana, and Washington Enabling Act, ch. 180, § 4, 25 Stat. 676, 677 (1889). In fact, these “irrevocable” clauses are revocable through ordinary state political processes. Congressional control over state laws and constitutions is unenforceable, because it would violate each state’s constitutional right to equal sovereignty. "), _c('em', [_vm._v("See")]), _vm._v(" Coyle v. Smith, 221 U.S. 559 (1911).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_249",
      "id": "foot-249"
    }
  }, [_vm._v("249")]), _vm._v(". See the descriptions of their tactics and message in Douglas v. City of Jeannette, 319 U.S. 157, 166–74 (1943) (Jackson, J., dissenting); Cantwell v. Connecticut, 310 U.S. 296, 30–103 (1940).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_250",
      "id": "foot-250"
    }
  }, [_vm._v("250")]), _vm._v(". The cases are collected in Douglas Laycock, "), _c('em', [_vm._v("A Survey of Religious Liberty in the United States,")]), _vm._v(" 47 O"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HIO")]), _vm._v(" S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("T.")]), _vm._v(" L J. 409, 419–20 (1986) (text at notes 60–75).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_251",
      "id": "foot-251"
    }
  }, [_vm._v("251")]), _vm._v(". 310 U.S. 586 (1940).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_252",
      "id": "foot-252"
    }
  }, [_vm._v("252")]), _vm._v(". "), _c('em', [_vm._v("See")]), _vm._v(" P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ETER")]), _vm._v(" I"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("RONS")]), _vm._v(", T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HE")]), _vm._v(" C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OURAGE OF")]), _vm._v(" T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HEIR")]), _vm._v(" C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ONVICTIONS")]), _vm._v(" 22–35 (1988).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_253",
      "id": "foot-253"
    }
  }, [_vm._v("253")]), _vm._v(". "), _c('em', [_vm._v("Smith,")]), _vm._v(" 494 U.S. at 879. The Court does not cite West Virginia Bd. of Educ. v. Barnette, 319 U.S. 624 (1943), which overruled the result in "), _c('em', [_vm._v("Gobitis.")]), _vm._v(" The opinion for the Court in "), _c('em', [_vm._v("Barnette")]), _vm._v(" relies on the Free Speech Clause, and holds that no one can be required to salute the flag. It is thus formally consistent with the "), _c('em', [_vm._v("Gobitis")]), _vm._v(" holding that religious objectors were not entitled to an exemption from a generally applicable rule. "), _c('em', [_vm._v("Id.")]), _vm._v(" at 634–36. I am indebted to my colleague Scot Powe for pointing out that votes essential to the majority filed concurring opinions based on the Free Exercise Clause. "), _c('em', [_vm._v("Id.")]), _vm._v(" at 643–44 (Black, J., and Douglas, J., concurring); "), _c('em', [_vm._v("id.")]), _vm._v(" at 644–47 (Murphy, J., concurring).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_254",
      "id": "foot-254"
    }
  }, [_vm._v("254")]), _vm._v(". 268 U.S. 510 (1925).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_255",
      "id": "foot-255"
    }
  }, [_vm._v("255")]), _vm._v(". "), _c('em', [_vm._v("See")]), _vm._v(" Brief of World Hindu Assembly of North America, et al., as Amicus Curiae, in Int’l Soc’y of Krishna Consciousness v. George, 499 U.S. 914 (1991). For good descriptions and analyses of the Hare Krishnas, Scientologists, and Unification Church, see the essays in T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HE")]), _vm._v(" F"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("UTURE OF")]), _vm._v(" N"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EW")]), _vm._v(" R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ELIGIOUS")]), _vm._v(" M"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OVEMENTS")]), _vm._v(" (David G. Bromley & Phillip E. Hammond, eds., 1987).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_256",
      "id": "foot-256"
    }
  }, [_vm._v("256")]), _vm._v(". The movement is carefully described in A"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("NSON")]), _vm._v(" D. S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HUPE,")]), _vm._v(" J"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("R.")]), _vm._v(" & D"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AVID")]), _vm._v(" G. B"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ROMLEY")]), _vm._v(", T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HE")]), _vm._v(" N"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EW")]), _vm._v(" V"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("IGILANTES")]), _vm._v(" (1980). The inference that the movement seeks to destroy these religions is mine, not Shupe & Bromley’s, and the inference is based largely on developments subsequent to their book.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_257",
      "id": "foot-257"
    }
  }, [_vm._v("257")]), _vm._v(". See "), _c('em', [_vm._v("id.")]), _vm._v(" at 121–67.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_258",
      "id": "foot-258"
    }
  }, [_vm._v("258")]), _vm._v(". See cases cited "), _c('a', {
    attrs: {
      "href": "#/017_Chapter02c#foot-188"
    }
  }, [_vm._v("note 188")]), _vm._v(" "), _c('em', [_vm._v("supra.")]), _vm._v(" For the $5 million figure, see Petition for Certiorari 8, in "), _c('em', [_vm._v("George,")]), _vm._v(" 499 U.S. 914.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_259",
      "id": "foot-259"
    }
  }, [_vm._v("259")]), _vm._v(". "), _c('em', [_vm._v("George,")]), _vm._v(" 499 U.S. 914.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_260",
      "id": "foot-260"
    }
  }, [_vm._v("260")]), _vm._v(". "), _c('em', [_vm._v("See")]), _vm._v(" S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("YDNEY")]), _vm._v(" E. A"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HLSTROM")]), _vm._v(", A R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ELIGIOUS")]), _vm._v(" H"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ISTORY OF THE")]), _vm._v(" A"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("MERICAN")]), _vm._v(" P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EOPLE")]), _vm._v(" (1972); E"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("LMER")]), _vm._v(" T. C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("LARK")]), _vm._v(", T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HE")]), _vm._v(" S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("MALL")]), _vm._v(" S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ECTS IN")]), _vm._v(" A"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("MERICA")]), _vm._v(" (1937); J"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OHN")]), _vm._v(" H. N"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OYES,")]), _vm._v(" S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("TRANGE")]), _vm._v(" C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ULTS AND")]), _vm._v(" U"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("TOPIAS OF")]), _vm._v(" 19"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("TH-CENTURY")]), _vm._v(" A"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("MERICA")]), _vm._v(" (1966); Paulson & Ness, "), _c('em', [_vm._v("New Religious Movements in Historical Perspective,")]), _vm._v(" in C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ULTS AND")]), _vm._v(" N"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EW")]), _vm._v(" R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ELIGIOUS")]), _vm._v(" M"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OVEMENTS")]), _vm._v(" 43 (Mark Galanter, ed., 1989); 2 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("STOKES")]), _vm._v(", "), _c('a', {
    attrs: {
      "href": "#/017_Chapter02c#foot-233"
    }
  }, [_vm._v("note 233")]), _vm._v(" "), _c('em', [_vm._v("supra,")]), _vm._v(" at 112–20.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_261",
      "id": "foot-261"
    }
  }, [_vm._v("261")]), _vm._v(". Pattison & Ness, "), _c('a', {
    attrs: {
      "href": "#/017_Chapter02c#foot-260"
    }
  }, [_vm._v("note 260")]), _vm._v(" "), _c('em', [_vm._v("supra,")]), _vm._v(" at 75–76.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_262",
      "id": "foot-262"
    }
  }, [_vm._v("262")]), _vm._v(". M"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("IGENE")]), _vm._v(" G"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ONZALES")]), _vm._v("-W"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("IPPLER,")]), _vm._v(" S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ANTERIA")]), _vm._v(": T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HE")]), _vm._v(" R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ELIGION")]), _vm._v(" 9 (1989).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_263",
      "id": "foot-263"
    }
  }, [_vm._v("263")]), _vm._v(". R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OGER")]), _vm._v(" B"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ASTIDE,")]), _vm._v(" A"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("FRICAN")]), _vm._v(" C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("IVILISATIONS IN THE")]), _vm._v(" N"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EW")]), _vm._v(" W"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ORLD")]), _vm._v(" 115 (Peter Green, trans., 1971).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_264",
      "id": "foot-264"
    }
  }, [_vm._v("264")]), _vm._v(". "), _c('em', [_vm._v("Id.")]), _vm._v(" at 138.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_265",
      "id": "foot-265"
    }
  }, [_vm._v("265")]), _vm._v(". Church of the Lukumi Babalu Aye, Inc. v. City of Hialeah, 723 F. Supp. 1467 (S.D. Fla. 1989), ["), _c('em', [_vm._v("aff’d,")]), _vm._v(" 936 F.2d 586 (11th Cir. 1991), "), _c('em', [_vm._v("rev’d,")]), _vm._v(" 508 U.S. 520 (1993). The appellate decisions in this case came down after this article was published.] The author [was] appellate counsel for the church.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_266",
      "id": "foot-266"
    }
  }, [_vm._v("266")]), _vm._v(". Alford v. Finch, 155 So.2d 790, 793 (Fla. 1963); Bell v. Vaughn, 21 So.2d 31 (Fla. 1945); Fla. Const. art. 4 § 9.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_267",
      "id": "foot-267"
    }
  }, [_vm._v("267")]), _vm._v(". Henderson, "), _c('em', [_vm._v("Camera-Toting Kids Sought to Infiltrate Hunt,")]), _vm._v(" M"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("IAMI")]), _vm._v(" H"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ERALD")]), _vm._v(" 5B (June 15, 1990).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_268",
      "id": "foot-268"
    }
  }, [_vm._v("268")]), _vm._v(". F"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("LA.")]), _vm._v(" S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("TAT.")]), _vm._v(" A"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("NN")]), _vm._v(". § 372.705 (Supp. 1991).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_269",
      "id": "foot-269"
    }
  }, [_vm._v("269")]), _vm._v(". F"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("LA.")]), _vm._v(" S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("TAT.")]), _vm._v(" A"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("NN")]), _vm._v(". §§ 828.22 to 828.26 (1976 & Supp. 1991); Hialeah Ordinances 87–40, 87–52, 87–72.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_270",
      "id": "foot-270"
    }
  }, [_vm._v("270")]), _vm._v(". F"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("LA.")]), _vm._v(" S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("TAT.")]), _vm._v(" A"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("NN")]), _vm._v(". § 828.073(4)(c)2 (Supp. 1991); Hialeah Ordinance 87–40.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_271",
      "id": "foot-271"
    }
  }, [_vm._v("271")]), _vm._v(". F"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("LA.")]), _vm._v(" S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("TAT.")]), _vm._v(" A"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("NN")]), _vm._v(". § 482 (Supp. 1991).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_272",
      "id": "foot-272"
    }
  }, [_vm._v("272")]), _vm._v(". Each of these classifications appears expressly in one or more of the four ordinances enacted to suppress animal sacrifice. The theory that animal sacrifice is unnecessary also appears in Fla. Atty. Gen. Opinion 87–56, Annual Report at 146 (1987). The Attorney General failed to see that the necessity of animal sacrifice is a purely theological question.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_273",
      "id": "foot-273"
    }
  }, [_vm._v("273")]), _vm._v(". Compare Hialeah Ordinance 87–40 with F"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("LA.")]), _vm._v(" S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("TAT.")]), _vm._v(" A"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("NN")]), _vm._v(". § 828.22(3) (1976).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_274",
      "id": "foot-274"
    }
  }, [_vm._v("274")]), _vm._v(". Brief of Appellee 40–41, in "), _c('em', [_vm._v("Lukumi,")]), _vm._v(" No. 90–5176 in the United States Court of Appeals for the Eleventh Circuit.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7c4cefd7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/017_Chapter02-c.vue
// module id = 105
// module chunks = 0